import React, { useCallback, useState, useEffect, useMemo, useContext, useRef } from 'react';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import UncollapseIcon from '@mui/icons-material/NavigateNext';
import CollapseIcon from '@mui/icons-material/NavigateBefore';
import Slide from '@mui/material/Slide';
import Zoom from '@mui/material/Zoom';
import PropTypes from 'prop-types';
import { InvoiceDocumentViewer } from './InvoiceDocumentViewer';
import { InvoiceDocumentRoutingHistory } from './InvoiceDocumentRoutingHistory';
import { VendorLookup } from '../Lookups/VendorLookup';
import { POHeaderLookup } from '../Lookups/POHeaderLookup';
import { POHeaderResourceLookup } from '../Lookups/POHeaderResourceLookup';
import { Level2ResourceLookup } from '../Lookups/Level2ResourceLookup';
import { stringIsNullOrEmpty, blankStringIfNullOrEmpty, formatNumber, zeroIfNull, addDaysInDate, FormatToInputDate, getRoutingLevelOfApproval, downloadBase64File, formatAmount, round, getDisplayName, parseServiceTermDates } from '../Common/Utilities';
import { toast } from 'react-toastify';
import { httpDelete, httpGet, httpPost } from '../../HttpRequestHandling/httpRequestHandler';
import InvoiceDocumentEditorGrid from './InvoiceDocumentEditorGrid';
import IconButton from '@mui/material/IconButton';
import InvoiceDocumentEditorAttachments from './InvoiceDocumentEditorAttachments';
import './../site.css';
import { VendorMappingConfirmationDialog } from '../InvoiceModels/VendorMapConfirmationDialog'
import { ClientLookup } from '../Lookups/ClientLookup';
import { InvoiceDocumentApprovalRoutingHistory } from './InvoiceDocumentApprovalRoutingHistory';
import { Constants } from '../Common/Constants';
import { Tooltip } from '@mui/material';
import { VendorMappingDialogPrompt } from '../VendorMap/VendorMappingPrompt';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {
	Typography,
	Box
} from '@mui/material';
import {
	creditMemo,
	routeToEmployee_clickHandler,
	handleTabInvoiceDetails,
	handleTabAttachments,
	accept_clickHandler,
	reject_clickHandler,
	handleRouteToEmployeeWarning,
	handleClientWarning,
	handleOverrideWarning,
	handleCustomWarning,
	save_clickHandler,
	//routingHistory_clickHandler,
	invoiceDocumentRoutingHistoryDialog_closeHandler,
	input_changeHandler,
	onPaymentTermsChange,
	serviceTerm_blurHandler,
	search_clickHandler,
	searchClient_clickHandler,
	STATUS_ATTRIBUTE,
	VIEW_ATTRIBUTE,
	INVOICE_EDITOR_TEST_CASES,
	needsRevertTo40,
	isMultipleOf20,
	getIsAutoApproved,
	resolveWorkflowMode,
	resolveWorkflowCapabilities,
	isRepostRuleEditable,
	derivePartialInvoiceStatus,
	isApprovalLevelBreached,
	openLinkedInvoice,
	rescanOriginalInvoice,
	isCreditMemoPostEnabled,
	savePostedInvoiceComments,
	getInvalidIoPoRowsForServiceTerm
	//vendorDialog_closeHandler,
	//clientDialog_closeHandler,
	//isFieldReadOnly


} from '../InvoiceDocument/InvoiceDocumentEditorFunctions';
import { GenericMessageDialog } from '../Common/Components/GenericMessageDialog';
import { InvoiceDocumentEditorContext, useInvoice } from './InvoiceDocumentEditorContext';
const Transition = React.forwardRef(function Transition(props, ref) {
	return <Zoom in={true} ref={ref} {...props} />;
});

// VIEW-variant mode used when editing selected detail lines for partial posting.
// NOTE: We intentionally keep the invoice header/attachments in read-only mode.
const PARTIAL_POST_MODE = 'PartialPost';


export const InvoiceDocumentEditor = (props) => {

	return (<>
		<InvoiceDocumentEditorContext {...props}>
			<InvoiceDocumentEditorInner {...props} />
		</InvoiceDocumentEditorContext>
	</>)
}

const InvoiceDocumentEditorInner = (props) => {



	//#region Initializers
	const { state,
		setState,
		setDetailsOnVendorChange,
		getTitle,
		getCalculatedTax,
		setSuccessfullSave,
		successfullSave,
		dialog,
		setDialog,
		partialPostSeqIdsMap,
		setPartialPostSeqIdsMap,
		setTitle,
		title
	} = useInvoice();

	const { capabilities, mode, partialInvoiceStatus, invoiceDocument: _invoiceDocument } = state;
	const originalInvoiceStatusIdRef = React.useRef(null);
	const { applyTaxCodeToAllLines, calculateTaxAmountForRow } = useInvoice();

	const routingLevels =
		_invoiceDocument?.routingNumberOfApprovalLevels ??
		_invoiceDocument?.companyApprovalConfiguration?.routingNumberOfApprovalLevels ??
		0;

	// Action buttons (Edit/Override/Edit Dates/Post/Repost) are only enabled when opened from the Invoice List source.
	// Other entry points should keep their original editor behavior, but must not expose list-only actions.
	//const isInvoiceListSource = props?.info?.editorSource === Constants.INVOICE_LIST_SOURCE;

	const isListLikeSource =
		props?.info?.editorSource === Constants.INVOICE_LIST_SOURCE ||
		props?.info?.editorSource === Constants.SOURCE_DASHBOARD_GADGET ||
		props?.info?.editorSource === Constants.SOURCE_INVOICE_REPORT;
	const buttonCapabilities = useMemo(() => {
		if (isListLikeSource) return capabilities || {};
		return {
			...(capabilities || {}),
			canPostToERP: false,
			canRepostToERP: false,
			canOverride: false,
			canEditDates: false,
			// legacy keys used by parts of the UI
			canEditInvoice: false,
			canOverridInvoice: false,
			canRepost: false,
			canPostCreditMemo: false,
			canDelete: false
		};
	}, [isListLikeSource, capabilities, state]);

	// Partial Posting editor variant: comes from partial post dialog "Edit".
	// New flow: editability is driven by seqIds (line identity), not orderId/ioNumber.
	// Safeguard: If mode is UserEntry, ignore partialSelectedRows
	const partialSelectedRows = props?.info?.mode === "UserEntry" ? null : (props?.partialSelectedRows || null);
	const isPartialPostRequested = Array.isArray(partialSelectedRows) && partialSelectedRows.length > 0;
	const partialEditableIONumberSet = useMemo(() => {
		if (!isPartialPostRequested) return null;

		// In partial post mode, seqIds are the only reliable join key between logs and editor lines.
		// Only failed (not posted) seqIds should be editable.
		const all = [];
		if (partialPostSeqIdsMap) {
			partialPostSeqIdsMap.forEach((v) => {
				if (Number(v?.posted) === 1) return;
				const seqIds = Array.isArray(v?.seqIds) ? v.seqIds : [];
				seqIds.forEach(x => all.push(String(x)));
			});
		}
		return new Set(all);
	}, [isPartialPostRequested, partialPostSeqIdsMap]);

	// Map ioNumber -> { intInvoiceNumber, posted } for MO invoice display and styling.
	const partialMoInvoiceMap = useMemo(() => {
		if (!isPartialPostRequested) return null;
		if (!partialPostSeqIdsMap) return [];
		const map = new Map();
		partialPostSeqIdsMap.forEach((r, k) => {
			const intInvoiceNumber = k ?? '';
			const posted = Number(r?.posted) === 1 ? 1 : 0;
			const orderIds = Array.isArray(r?.orderIds) ? r.orderIds : [];
			const seqIds = Array.isArray(r?.seqIds) ? r.seqIds : [];
			seqIds.forEach(seqId => {
				const key = String(seqId);
				if (!map.has(key)) {
					map.set(key, { intInvoiceNumber, posted });
				}
			});
		});
		return map;
	}, [partialPostSeqIdsMap]);


	const incomingStatus = props?.info?.rowData?.status;
	var userInfo = JSON.parse(localStorage.userInfo);
	let resourceId = userInfo.id;
	let isAdmin = userInfo.selectedUserRoles.isAdmin;
	let loginUserRole = userInfo.selectedUserRoles.userRoleName;
	let currentEditRow = null;
	const currentDetailEditRowRef = React.useRef(null);
	const currentDetailEditRow = currentDetailEditRowRef.current;
	const [openClientWarningDialog, setOpenClientWarningDialog] = useState(false);
	const [openRouteToEmployeeWarningDialog, setOpenRouteToEmployeeDialog] = useState(false);
	//const [hasShownClientWarningDialog, setHasShownClientWarningDialog] = useState(false);
	const [dialogResponseHandler, setDialogResponseHandler] = useState(null);
	const [overrideDialogResponseHandler, setOverrideDialogResponseHandler] = useState(null);
	const [openSaveChangesDialog, setOpenSaveChangesDialog] = useState(false);
	const [openAmountsMismatchDialog, setOpenAmountsMismatchDialog] = useState(false);
	const [amountsMismatchMessage, setAmountsMismatchMessage] = useState('');
	const [amountsMismatchDialogResponseHandler, setAmountsMismatchDialogResponseHandler] = useState(null);

	const [view, setView] = React.useState(0);
	const [taxTotal, setTaxTotal] = React.useState(0);
	const [grossTotal, setGrossTotal] = React.useState(0);
	const editorGridRef = React.useRef(null);
	const attachmentRef = React.useRef(null);
	const [currentSelectedRow, setcurrentSelectedRow] = React.useState(null);
	const [activeTab, setActiveTab] = useState("tabInvoiceDetails");
	const [isClientCodeConsistent, setIsClientCodeConsistent] = useState(true);
	const [companyList, setCompanyList] = useState([]);
	const [selectedCompany, setSelectedCompany] = useState(null);
	const [showDropdown, setShowDropdown] = useState(false);
	const [showChangeCompany, setShowChangeCompany] = useState(true);
	const [pendingCompany, setPendingCompany] = useState(null);
	const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
	const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
	const [initialInvoiceDocument, setInitialInvoiceDocument] = useState(null);
	const [allowDiscrepentTax, setAllowDiscrepentTax] = useState(null);
	const [isDataLoaded, setIsDataLoaded] = useState(false);
	const [braodCastTaxChanged, setBraodCastTaxChanged] = useState(false);
	const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
	const [invoiceDocumentStatusId, setInvoiceDocumentStatusId] = useState(0);
	const [invoiceIndicator, setInvoiceIndicator] = useState(0);
	const [groupRules, setGroupRules] = useState([]);
	const [openCreditMemoDialog, setOpenCreditMemoDialog] = useState(false);
	const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
	const [creditedMemoInvoiceId, setCreditedMemoInvoiceId] = useState(0);
	const [mediaTypeOptions, setMediaTypeOptions] = useState([]);
	const [mediaTypeBandMap, setMediaTypeBandMap] = useState({});
	const [archiveDialogOpen, setArchiveDialogOpen] = useState(false);
	const [archiveStatusChanged, setArchiveStatusChanged] = useState(false);
	const [openMakeEditableDialog, setOpenMakeEditableDialog] = useState(false);
	const [openResetAndPostDialog, setOpenResetAndPostDialog] = useState(false);
	const [openRescanAfterPostDialog, setOpenRescanAfterPostDialog] = useState(false);
	const [isEditModeEnabled, setIsEditModeEnabled] = useState(false);
	const [vendorChangeWarningMessage, setVendorChangeWarningMessage] = useState('');
	const rescanAfterPostResolverRef = useRef(null); // resolves boolean | null (cancel)

	const [pendingEditMode, setPendingEditMode] = useState(null); // Constants.EDIT_DATES or Constants.OVERRIDE
	const [pendingPostAction, setPendingPostAction] = useState(null); // "post" | "repost"
	const [openUnsavedDialog, setOpenUnsavedDialog] = useState(false);
	const [pendingServiceTerm, setPendingServiceTerm] = useState(null);
	const [openServiceTermDialog, setOpenServiceTermDialog] = useState(false);
	const [invalidIoPoRows, setInvalidIoPoRows] = useState([]);

	// Never override UserEntry mode
	const isPartialPostMode = mode === PARTIAL_POST_MODE && mode !== "UserEntry";

	const creditMemoEditorInfo = {
		mode: Constants.CREDIT_MEMO,
		modelDefId: state.invoiceDocument?.modelDefId,
		rowData: { invoiceDocumentId: creditedMemoInvoiceId || state.invoiceDocument?.invoiceDocumentId },
		inProgress: props.info.inProgress,
		isViaQueryString: false,
		editorSource: Constants.INVOICE_LIST_SOURCE
	};


	// ModelDef 1/2: header-level Tax Code dropdown (bulk-apply to all lines).
	const modelDefId = state.invoiceDocument?.modelDefId;
	const showHeaderTaxForLines = modelDefId === 1 || modelDefId === 2;

	const headerTaxCodeForLines = React.useMemo(() => {
		const details = state?.invoiceDocument?.invoiceDocumentEditorDetails || [];
		if (!details.length) return '';
		let maxApprovalLevelBase = state.invoiceDocument?.companyApprovalConfiguration?.routingNumberOfApprovalLevels || 0;
		const maxApprovalStatus = (maxApprovalLevelBase * 20) + 50;

		const editableRows = details.filter(detail => {
			const lineStatus = Number(detail.lineStatus);
			const baseEditable =
				(detail.hasAuthority === 'Y' && detail.allowInvoiceCorrection === 'Y') ||
				lineStatus <= 50 ||
				lineStatus === 180 ||
				lineStatus == maxApprovalStatus || lineStatus == 170;
			return baseEditable;
		});

		if (!editableRows.length) return '';

		const nonEmptyTaxCodes = editableRows.map(d => d.taxCode).filter(Boolean);

		if (nonEmptyTaxCodes.length !== editableRows.length) return '';

		const uniqueCodes = [...new Set(nonEmptyTaxCodes)];
		return uniqueCodes.length === 1 ? uniqueCodes[0] : '';
	}, [state?.invoiceDocument?.invoiceDocumentEditorDetails, state?.invoiceDocument?.vendorCode]);



	// state for only view//
	const [broadCastInvoiceTotal, setBroadCastInvoiceTotal] = useState(invoiceTotal);
	const [broadCastTaxCode, setBroadCastTaxCode] = useState('');
	const [filteredBandOptions, setFilteredBandOptions] = useState([]);
	// state for only view//
	const [openInvoiceDocumentApprovalDialog, setOpenInvoiceDocumentApprovalDialog] = useState(false);
	const [datesValidation, setDateValidation] = useState({
		invoiceDateString: false,
		dueDateString: false,
		glDateString: false,
		serviceTermStartDateString: false,
		serviceTermEndDateString: false,
		startDateString: false,
		endDateString: false
	});
	const [changeCompanyData, setChangeCompanyData] = useState({
		companyCode: '',
		invoiceDocumentId: '',
		invoiceDocumentStatusId: '',
		mode: ''
	});

	// only broadcast validation
	const [broadCastValidation, setBroadCastValidation] = React.useState({
		isVendorSelectEnabled: true,
		isDueDateEnabled: true,
		isStartDateEnabled: true,
		isEndDateEnabled: true,
		isInvoiceNumberEnabled: true,
		isGLDateEnabled: true,
		isPaymentTermEnabled: true,
		isInvoiceDateEnabled: true,
		isTaxCodeEnabled: true,
		changeCount: 0
	});

	// only broadcast validation
	const minYear = 1970;

	const allowOverrideTaxAmount = React.useMemo(() => {
		return state?.invoiceDocument?.allowOverrideTaxAmount;
	}, [state?.invoiceDocument?.allowOverrideTaxAmount]);

	const dialogTitle = React.useMemo(() => {
		let title = $('.vendorMapDialog-header-title').text();
		if (title === 'Vendor Mapping' && mode === 'Test') {
			return 'Vendor Map';
		}
		else {
			return '';
		}
	}, [mode])

	const supportsAdminDateAndOverride = (props?.info?.modelDefId === 2 || props?.info?.modelDefId === 1);

	// Keep these derived from the *same* capability engine used for list/report.
	// This ensures auto-approved rules (and any future changes) are applied consistently.
	const dateEditableForAdmin = React.useMemo(() => {
		return supportsAdminDateAndOverride
			&& mode === Constants.EDIT_DATES;
	}, [supportsAdminDateAndOverride, mode]);

	const overrideAllChks = React.useMemo(() => {
		return supportsAdminDateAndOverride
			&& mode === Constants.OVERRIDE;
	}, [supportsAdminDateAndOverride, mode]);

	// Edit button rules:
	// - ModelDef 3: never show Edit Invoice
	// - Credit Memo: show only if auto-approved AND modelDef is 1 or 2
	// - Other invoices: keep existing behavior (based on derived capabilities)
	const shouldShowEditInvoiceButton = React.useMemo(() => {
		const md = Number(state.invoiceDocument?.modelDefId || props?.info?.modelDefId || 0);

		// ModelDef 3: never show Edit Invoice
		if (md === 3) return false;

		// Different company: invoice is read-only, no edit actions
		if (capabilities?.hasDifferentCompany) return false;

		const hasEditCapability = !!(
			buttonCapabilities?.canEditDates ||
			buttonCapabilities?.canOverride ||
			buttonCapabilities?.canEditInvoice
		);
		if (!hasEditCapability) return false;

		const isCreditMemo =
			Number(state.invoiceDocument?.applyToInvoiceDocumentId || 0) > 0 ||
			mode === Constants.CREDIT_MEMO;

		// Credit Memo: only if auto-approved and modelDef is 1 or 2
		if (isCreditMemo) {
			return getIsAutoApproved(state.invoiceDocument) && (md === 1 || md === 2);
		}

		return true;
	}, [
		state.invoiceDocument?.invoiceDocumentId,
		state.invoiceDocument?.applyToInvoiceDocumentId,
		state.invoiceDocument?.modelDefId,
		state.invoiceDocument?.invoiceSource,
		state.invoiceDocument?.isAutoApproved,
		buttonCapabilities?.canEditDates,
		buttonCapabilities?.canOverride,
		buttonCapabilities?.canEditInvoice,
		capabilities?.hasDifferentCompany,
		mode,
		props?.info?.modelDefId,
	]);

	const editableLabels = useMemo(() => {
		const map = {};
		groupRules.forEach(rule => {
			if (rule.Model_def_id === props.info.modelDefId) {
				const key = rule.label?.toLowerCase?.();
				map[key] = rule.editable === "1";
			}
		});
		return map;
	}, [groupRules, props.info.modelDefId]);

	const isListLikeSourceMemo = React.useMemo(() => {
		const isListLikeSource =
			props?.info?.editorSource === Constants.INVOICE_LIST_SOURCE ||
			props?.info?.editorSource === Constants.SOURCE_DASHBOARD_GADGET ||
			props?.info?.editorSource === Constants.SOURCE_INVOICE_REPORT;
		return isListLikeSource;
	}, [props?.info]);

	const isEditable = (label) => editableLabels[label?.toLowerCase?.()] ?? false;



	useEffect(() => {
		if (props.info.previewInvoiceDocument) {
			const previewTaxes = [];
			if (props.info.previewInvoiceDocument.taxes) {
				props.info.previewInvoiceDocument.taxes.forEach(t => {
					if (previewTaxes.find(tt => tt.taxCode === t.taxCode) == null) {
						previewTaxes.push({ taxCode: t.taxCode, taxDesc: t.taxDesc });
					}
				});
			}
			props.info.previewInvoiceDocument.invoiceDocumentEditorDetails?.forEach(detail => {
				if (detail.taxCode?.toLowerCase() === 'dummy') {
					detail.taxCode = null;
				}
				detail.invoiceDocumentDetailTaxes?.forEach(tax => {
					if (tax.taxCode?.toLowerCase() === 'dummy') {
						tax.taxCode = null;
						tax.taxTypeCode = null;
					}
				});
			});

			setState((prev) => ({
				...prev,
				invoiceDocument: props.info.previewInvoiceDocument,
				taxes: previewTaxes,
				isDirty: false,
			}));
			setBroadCastTaxCode(props.info.previewInvoiceDocument?.invoiceDocumentEditorDetails[0]?.taxCode);
			calculateAndSetTotals(props.info.previewInvoiceDocument);
		} else {
			fetchInvoiceDocument();
		}
	}, [props.info.previewInvoiceDocument]);



	useEffect(() => {
		let invoiceDocumentEditorDetails = (state?.invoiceDocument?.invoiceDocumentEditorDetails || []);
		if (isDataLoaded && invoiceDocumentEditorDetails.length > 0 && !props.info.previewInvoiceDocument) {
			setTaxTotal(invoiceDocumentEditorDetails.length > 0 ? invoiceDocumentEditorDetails.map(item => parseFloat(item.taxAmount)).reduce((prev, next) => prev + next) : 0.00);
			setGrossTotal(invoiceDocumentEditorDetails.length > 0 ? invoiceDocumentEditorDetails.map(item => parseFloat(item.ioInvoiceAmount || 0)).reduce((prev, next) => prev + next) : 0.00);
		}
		else if (props.info?.previewInvoiceDocument?.invoiceDocumentEditorDetails?.length > 0) {
			setTaxTotal(props.info.previewInvoiceDocument.invoiceDocumentEditorDetails.length > 0 ? props.info.previewInvoiceDocument.invoiceDocumentEditorDetails.map(item => parseFloat(item.taxAmount)).reduce((prev, next) => prev + next) : 0.00);
			setGrossTotal(props.info.previewInvoiceDocument.invoiceDocumentEditorDetails.length > 0 ? props.info.previewInvoiceDocument.invoiceDocumentEditorDetails.map(item => parseFloat(item.ioInvoiceAmount || 0)).reduce((prev, next) => prev + next) : 0.00);
		}
		else {
			setTaxTotal(0);
			setGrossTotal(0);
		}

	}, [view, editorGridRef.current?.isGridDataValid, isDataLoaded, state?.invoiceDocument?.invoiceDocumentEditorDetails, currentSelectedRow, broadCastTaxCode, props.info.previewInvoiceDocument]);
	useEffect(() => {
		const invoiceTotal = parseFloat(grossTotal || 0);
		if (!state.isDirty)
			return;

		//if (state.lineDirty) {
		if (state.invoiceDocument?.discountAmount !== undefined) {
			const paymentTerm = state.invoiceDocument?.paymentTerms?.find(
				(term) => term.termsCode === state.invoiceDocument?.paymentTermCode
			);
			//let discount = (state.invoiceDocument?.scannedTotal - invoiceTotal);
			let discount = 0.00;
			if (paymentTerm && paymentTerm.discountPercent) {
				discount = (invoiceTotal * paymentTerm.discountPercent) / 100;
			}
			if (discount < 0) {
				discount = 0.00;
			}
			setState({ ...state, invoiceDocument: { ...state.invoiceDocument, discountAmount: discount } });
			//}
		}
	}, [state.lineDirty, taxTotal, grossTotal, invoiceTotal, state.invoiceDocument?.paymentTermCode, state.invoiceDocument?.paymentTerms]);

	useEffect(() => {
		const invoiceDocumentEditorDetails = state?.invoiceDocument?.invoiceDocumentEditorDetails || [];

		//if (invoiceDocumentEditorDetails.length > 0) {
		const clientCodes = invoiceDocumentEditorDetails.map(detail => detail.clientCode);

		const allMatch = clientCodes.every(code => code === clientCodes[0]);
		const matchesDisplayedClientCode = clientCodes.every(code => !code ||
			code === state.invoiceDocument?.clientCode || state.invoiceDocument?.clientCode === null || state.invoiceDocument?.clientCode === undefined || state.invoiceDocument?.clientCode === "" || state?.invoiceDocument?.invoiceDocumentEditorDetails === 0
		);
		//const isClientCodeNullOrUndefined = state.invoiceDocument?.clientCode == null || state.invoiceDocument?.clientCode === "" || state.invoiceDocument?.clientCode === undefined;
		if (allMatch && matchesDisplayedClientCode)
			setIsClientCodeConsistent((true));
		else
			setIsClientCodeConsistent(false);
	}, [state.invoiceDocument?.invoiceDocumentEditorDetails, state.invoiceDocument?.clientCode, state?.invoiceDocument?.invoiceDocumentEditorDetails]);

	useEffect(() => {
		if (state.invoiceDocument?.companyCode != undefined)
			fetchCompanyList();
	}, [state.invoiceDocument?.companyCode]);



	useEffect(() => {
		if (props.info.modelDefId === 3 && state?.invoiceDocument) {
			if (broadCastValidation.changeCount === 0 || state.isInvoiceNumberDuplicate === true) {
				let obj = {
					isVendorSelectEnabled: !VendorSelected(),
					isDueDateEnabled: !DueDateValid(),
					isStartDateEnabled: !ServiceTermStartValidInner(),
					isEndDateEnabled: !ServiceTermEndValidInner(),
					isInvoiceNumberEnabled: !(InvoiceNumberValid() && state.isInvoiceNumberDuplicate !== true),
					isGLDateEnabled: !(!stringIsNullOrEmpty(state?.invoiceDocument?.glDate)),
					isPaymentTermEnabled: !(!stringIsNullOrEmpty(state?.invoiceDocument?.paymentTermCode)),
					isInvoiceDateEnabled: !(!(stringIsNullOrEmpty(state.invoiceDocument?.invoiceDateString))),
					isTaxCodeEnabled: !(!(stringIsNullOrEmpty(state.invoiceDocument?.invoiceDocumentEditorDetails[0]?.taxCode) || (state?.invoiceDocument?.invoiceDocumentEditorDetails[0]?.taxCode))),
					changeCount: broadCastValidation.changeCount + 1
				}
				setBroadCastValidation(obj);
			}

		}
	}, [state?.invoiceDocument, state.isInvoiceNumberDuplicate]);
	useEffect(() => {
		if (props.info.previewInvoiceDocument) {
			setDateValidations(props.info.previewInvoiceDocument);
			const title = getTitle(state.mode);
			setTitle(title);
		}
	}, [props.info.previewInvoiceDocument, setDateValidations, getTitle]);

	useEffect(() => {
		if (state.invoiceDocument?.companyCode && state.invoiceDocument?.modelDefId === 3 && !state.isDirty) {
			httpGet(`/api/invoicedocument/mediatypebands/${state.invoiceDocument?.companyCode}`)
				.then((response) => {
					const data = response.data;

					const mediaMap = {};
					const mediaList = [];

					data.forEach(item => {
						if (!mediaMap[item.mediaTypeCode]) {
							mediaMap[item.mediaTypeCode] = [];
							mediaList.push({
								value: item.mediaTypeCode,
								label: item.mediaTypeName
							});
						}
						mediaMap[item.mediaTypeCode].push(item.mediaTypeBand);
					});

					setMediaTypeOptions(mediaList);
					setMediaTypeBandMap(mediaMap);

					const selectedType = state.invoiceDocument?.broadcastType;
					const allBands = Array.from(new Set(data.map(item => item.mediaTypeBand)));
					if (selectedType) {
						setFilteredBandOptions([...new Set(mediaMap[selectedType])]);
					} else {
						setFilteredBandOptions(allBands);
					}

				})
				.catch(() => toast.error("Failed to load media types and bands"));
		}
	}, [state.invoiceDocument?.companyCode]);


	const [inputMode, setInputMode] = React.useState('text');
	const [rawNetAmount, setRawNetAmount] = React.useState(
		((props.info.modelDefId === 3 ? broadCastInvoiceTotal : grossTotal) || '0.00').toString().replace(/,/g, '')
	);

	React.useEffect(() => {
		const val = props.info.modelDefId === 3 ? broadCastInvoiceTotal : grossTotal;
		setRawNetAmount(val?.toString().replace(/,/g, '') || '0.00');
	}, [broadCastInvoiceTotal, grossTotal, props.info.modelDefId]);


	const deleteInvoiceDocument = async (invoiceDocumentId, onSuccess, onError) => {
		try {
			props.info.inProgress(true);
			const response = await httpDelete(`/api/invoicedocument/${invoiceDocumentId}`);
			toast.success('Invoice deleted successfully');
			onSuccess?.();
			props.info.inProgress(false);
		} catch (error) {
			toast.error(<div>Invoice delete failed<br />{error.response?.data || "Unknown error"}</div>);
			onError?.(error);
			props.info.inProgress(false);
		}
	};

	const isFieldReadOnly = (fieldName) => {
		const systemCheck = () => {
			switch (fieldName) {
				case "Invoice Number":
					return (
						isPostInProgress || ((!enableForCreditMemo &&
							(state.readOnly || isInvoiceSource || !broadCastValidation.isInvoiceNumberEnabled)))

					);

				case "Invoice Date":
					return (
						isPostInProgress || ((!enableForCreditMemo &&
							((!ignorePreviousCases &&
								(state.readOnly || isInvoiceSource)) ||
								readOnlyForAdmin)))

					);

				case "GL Date":
					return (
						isPostInProgress || ((!enableForCreditMemo &&
							((mode !== Constants.EDIT_DATES &&
								(state.readOnly || isInvoiceSource)) ||
								readOnlyForAdmin)))

					);

				case "Due Date":
					return (
						isPostInProgress || ((!enableForCreditMemo &&
							((mode !== Constants.EDIT_DATES &&
								(state.readOnly || isInvoiceSource)) ||
								readOnlyForAdmin ||
								readOnlyOverride)))
					);
				case "Manage Invoice Archive/Unarchive":
					return (
						isPostInProgress ||
						isInvoiceSource
						|| state.originalInvoiceDocumentStatus === 170
						|| mode === Constants.TEST
						|| state.invoiceDocument?.transactionId
						|| state.invoiceDocument?.applyToInvoiceDocumentId
						|| mode === Constants.REPLACE
						|| mode === Constants.USER_ENTRY
						|| capabilities?.hasDifferentCompany
					);
				case 'Add Line':
					return (
						isPostInProgress
						|| mode === Constants.TEST
						|| state.invoiceDocument?.transactionId
						|| state.readOnly
					)
				case 'Delete Line':
					return (
						isPostInProgress
						|| mode === Constants.TEST
						|| state.invoiceDocument?.transactionId
						|| state.readOnly
					)
				case 'Merge Line':
					return (
						isPostInProgress
						|| mode === Constants.TEST
						|| state.invoiceDocument?.transactionId
						|| state.readOnly
					)
				case 'Split Line':
					return (
						isPostInProgress
						|| mode === Constants.TEST
						|| state.invoiceDocument?.transactionId
						|| state.readOnly
					)

				// broadcast taxcode
				case 'Tax Code':
					return (
						isPostInProgress
						|| state.readOnly
						|| !broadCastValidation.isTaxCodeEnabled
						|| mode === Constants.TEST
						|| state.invoiceDocument?.transactionId
					)
				default:
					return false;
			}
		};

		// If system check disables the field, return true
		if (systemCheck()) {
			return true;
		}

		// Otherwise, check group rule
		return !isEditable(fieldName);
	};


	const routingHistory_clickHandler = (invoiceDocumentId, seqId) => {
		setState((prev) => ({
			...prev,
			openInvoiceDocumentRoutingHistoryDialog: true,
			routingHistoryData: { invoiceDocumentId, seqId, historyTitle: "Line Level Approval History" }
		}));
	}
	const vendorDialog_closeHandler = (event, vendor) => {
		// existing_vendor_code		model_def(1,2)		lines_po_code		new_vendor_code		header_po_code		result_dialog
		//		1						1					1					1					0					1
		//		1						2					0					1					1					1

		// Block vendor change if any line is fully approved (and not correctable) — model 1 and 2 only.
		if (vendor && !stringIsNullOrEmpty(state.invoiceDocument?.vendorCode) && state.invoiceDocument?.vendorCode !== vendor.vendorCode &&
			(state.invoiceDocument?.modelDefId === 1 || state.invoiceDocument?.modelDefId === 2)) {
			const maxApprovalLevelBase = state.invoiceDocument?.companyApprovalConfiguration?.routingNumberOfApprovalLevels || 0;
			const maxApprovalStatus = (maxApprovalLevelBase * 20) + 50;
			const hasFullyApprovedLines = (state.invoiceDocument?.invoiceDocumentEditorDetails || [])
				.some(line => {
					const status = Number(line.lineStatus);
					if (status === 180) return false; // Post Failed — not considered fully approved
					if (status % 20 === 0) return false; // Rejection statuses (60, 80, 100, 120...) — not fully approved
					const correctable = line.hasAuthority === 'Y' && line.allowInvoiceCorrection === 'Y';
					return status >= maxApprovalStatus && !correctable;
				});
			if (hasFullyApprovedLines) {
				toast.error("Vendor cannot be changed. This invoice contains fully approved lines.");
				setState((prev) => ({ ...prev, openVendorDialog: false }));
				return;
			}
		}

		if (vendor && !stringIsNullOrEmpty(state.invoiceDocument?.vendorCode) && state.invoiceDocument?.vendorCode !== vendor.vendorCode &&
			((state.invoiceDocument?.modelDefId === 1 && state?.invoiceDocument?.invoiceDocumentEditorDetails.length > 0) ||
				(state.invoiceDocument?.modelDefId === 2 && !stringIsNullOrEmpty(state.invoiceDocument?.poCode)))
		) {
			const approvedLineCount = (state?.invoiceDocument?.invoiceDocumentEditorDetails || [])
						.filter(line => {
							const s = Number(line.lineStatus);
							return s > 50 && s !== 180 && s % 20 !== 0;
						})
						.length;
					const approvalLevelText = (() => {
						const companyConfig = state.invoiceDocument?.companyApprovalConfiguration;
						const labels = (state?.invoiceDocument?.invoiceDocumentEditorDetails || [])
							.filter(line => {
								const s = Number(line.lineStatus);
								return s > 50 && s !== 180 && s % 20 !== 0;
							})
							.map(line => {
								const level = (Number(line.lineStatus) - 50) / 20;
								return companyConfig?.[`approvalLevel${level}AcceptName`] || null;
							})
							.filter(Boolean)
							.filter((d, i, arr) => arr.indexOf(d) === i); // unique
						return labels.length > 0 ? labels.join(' / ') : 'partially';
					})();
				const message = approvedLineCount > 0
						? `Warning: This invoice contains ${approvalLevelText} approved lines. Changing the vendor will reset all vendor-specific fields, including Payment Terms, Tax Code, and IO/PO Numbers across all invoice details, including approved lines. Do you want to continue?`
						: "Changing the vendor will reset all vendor-specific fields, including Payment Terms, Tax Code, and IO/PO Numbers across all invoice details. Do you want to continue?";
			setVendorChangeWarningMessage(message);
			setState((prev) => ({ ...prev, openVendorDialog: false, vendor: vendor, openChangeVendorConfirmation: true }));
		}
		else {
			if (vendor) {
				var invoiceDocument = state.invoiceDocument;

				// Only recalculate payment term and due date if the vendor actually changed.
				// If the user closes the lookup without selecting (same vendor or no selection),
				// vendor.vendorCode equals the current one — skip to avoid wiping existing dates.
				const isVendorActuallyChanged = vendor.vendorCode && vendor.vendorCode !== state.invoiceDocument?.vendorCode;
				if (isVendorActuallyChanged) {
					// Payment term: stamp if vendor has one, clear if vendor has none.
					invoiceDocument.paymentTermCode = vendor.termsCode || '';

					// Due date recalculation on vendor change (no-dialog path):
					// This mirrors the same logic in changeVendorYes_clickHandler for the case where
					// the confirmation dialog is skipped (modelDefId=2 with no PO code, or modelDefId=3
					// with no existing lines). Must run before setVendor to capture computed values.
					const matchedTermDirect = (invoiceDocument.paymentTerms || []).find(t => t.termsCode === invoiceDocument.paymentTermCode);
					if (matchedTermDirect && invoiceDocument.invoiceDateString) {
						const daysDueDirect = parseInt(matchedTermDirect.daysDue, 10);
						const invoiceDateDirect = new Date(invoiceDocument.invoiceDateString);
						const dueDateDirect = addDaysInDate(invoiceDateDirect, daysDueDirect);
						const isValidDirect = dueDateDirect.toString().indexOf('Invalid Date') === -1;
						if (dueDateDirect && isValidDirect && dueDateDirect.toISOString().length > 10) {
							invoiceDocument.dueDate = dueDateDirect;
							invoiceDocument.dueDateString = dueDateDirect.toISOString().slice(0, 10);
						}
					} else if (!invoiceDocument.paymentTermCode) {
						// New vendor has no payment terms — clear the stale due date.
						invoiceDocument.dueDate = null;
						invoiceDocument.dueDateString = '';
					}
				}

				const taxExistsInList = vendor.taxCode && (state.taxes || []).some(t => t.taxCode === vendor.taxCode);
				const taxToApply = taxExistsInList ? vendor.taxCode : '';
				if (invoiceDocument.modelDefId === 3) {
					setBroadCastTaxCode(taxToApply);
					// Reset broadCastValidation so useEffect recalculates field editability.
					setBroadCastValidation((prev) => ({ ...prev, changeCount: 0 }));
				}
				setState((prev) => ({ ...prev, openVendorDialog: false, poHeaderLookup: [], isDirty: true, invoiceDocument: invoiceDocument }));

				if (isVendorActuallyChanged) {
					// Capture computed dates before setVendor — setVendor calls input_changeHandler
					// multiple times using a stale state closure, which would overwrite dueDate.
					// Re-stamp them via functional setState after setVendor to guarantee they survive.
					const computedDueDateDirect = invoiceDocument.dueDate ?? null;
					const computedDueDateStringDirect = invoiceDocument.dueDateString ?? '';
					setVendor(vendor);
					setState((prev) => ({
						...prev,
						invoiceDocument: {
							...prev.invoiceDocument,
							dueDate: computedDueDateDirect,
							dueDateString: computedDueDateStringDirect,
							paymentTermCode: invoiceDocument.paymentTermCode
						}
					}));
					setDateValidations(invoiceDocument);
					applyTaxCodeToAllLines(taxToApply);
				} else {
					setVendor(vendor);
				}
			} else {
				setState((prev) => ({ ...prev, openVendorDialog: false, poHeaderLookup: [], isDirty: true }));
				setVendor(vendor);
			}
		}
	}
	const clientDialog_closeHandler = (event, selectedClient) => {
		const newClientCode = selectedClient ? selectedClient.clientCode : '';
		const newClientName = selectedClient ? selectedClient.clientName : '';
		setState((prev) => {
			return {
				...prev,
				openClientDialog: false,
				isDirty: true,
				invoiceDocument: {
					...prev.invoiceDocument,
					clientCode: newClientCode,
					clientName: newClientName,
					client: newClientCode && newClientName ? `${newClientCode} - ${newClientName}` : '',
				},
				previousClientData: selectedClient || null,
				poHeaderLookup: []
			};
		});
	};
	const handleClientCodeConsistency = (isConsistent) => {
		setIsClientCodeConsistent(isConsistent);
	};

	const close_clickHandler_wrapper = ({
		event = null,
		isRoutedToEmployeeOrApproval = false,
		wasUpdated = true,
		responseObject = null,
		statusId = 0,
		isSaved = false,
		updatedRowFields = null,
		wasDeleted = false,
		isCompanyChangedOverride = null,
		invoiceDocumentIdOverride = null,
		isAvailableForRescaning = false,
		applyToInvoiceDocumentId = null
	} = {}) => {
		return close_clickHandler(
			event,
			isRoutedToEmployeeOrApproval,
			wasUpdated,
			responseObject,
			statusId,
			isSaved,
			updatedRowFields,
			wasDeleted,
			isCompanyChangedOverride,
			invoiceDocumentIdOverride,
			isAvailableForRescaning,
			applyToInvoiceDocumentId
		);
	};
	const close_clickHandler = (
		event,
		isRoutedToEmployeeOrApproval = false,
		wasUpdated = true,
		responseObject = null,
		statusId = 0,
		isSaved = false,
		updatedRowFields = null,
		wasDeleted = false,
		isCompanyChangedOverride = null,
		invoiceDocumentIdOverride = null,
		isAvailableForRescaning = false,
		applyToInvoiceDocumentId = null
	) => {

		const orignalInvoiceDocumentStatusId = originalInvoiceStatusIdRef.current;
		const currentStatusId = statusId || state.originalInvoiceDocumentStatus || 0;
		const approvalRoutingLevels = state.invoiceDocument?.companyApprovalConfiguration?.routingNumberOfApprovalLevels || 0;
		if (changeCompanyData?.isCompanyChanged === true) {

			const updatedRowFieldsData = {
				invoiceDocumentId: state.invoiceDocument?.invoiceDocumentId
			}
			updatedRowFields = updatedRowFieldsData;
		};

		//if (props.onClose) {
		//	props.onClose(event, isRoutedToEmployeeOrApproval, wasUpdated, updatedRowFields, responseObject, currentStatusId, approvalRoutingLevels, orignalInvoiceDocumentStatusId, state.isDirty, isSaved, changeCompanyData?.isCompanyChanged || false);
		//} 


		const shouldUpdateRow = successfullSave;
		const wasDeletedBySource = wasDeleted && isListLikeSource;

		if (shouldUpdateRow && !updatedRowFields) {
			updatedRowFields = state.updatedRowFields;
		}

		if (props.onClose) {
			props.onClose({
				event,
				isRoutedToEmployeeOrApproval,
				wasUpdate: wasUpdated || shouldUpdateRow,
				updatedRowFieldsData: updatedRowFields,
				responseObject,
				currentStatusId,
				approvalRoutingLevels,
				orignalInvoiceDocumentStatusId,
				isDirty: state.isDirty,
				isSaved,
				isCompanyChanged: (isCompanyChangedOverride ?? changeCompanyData?.isCompanyChanged) || false,
				// For new invoice creation, state update can lag behind the close callback.
				// Prefer the override coming from save() when available.
				invoiceDocumentId: (invoiceDocumentIdOverride ?? state.invoiceDocument?.invoiceDocumentId),
				wasDelete: wasDeletedBySource,
				isAvailableForRescaning: isAvailableForRescaning,
				applyToInvoiceDocumentId: applyToInvoiceDocumentId
			});
		}
	}
	const replace_clickHandler = (event) => {
		setState((prev) => ({ ...prev, openReplaceInvoiceDocumentEditorDialog: true }));
	}
	const collapseUncollapse_clickHandler = (event) => {
		var collapseState = !state.uncollapsed;
		setState((prev) => ({ ...prev, uncollapsed: collapseState, displayInvoiceDocumentViewer: collapseState ? "" : "none" }));
	}
	const changeVendorYes_clickHandler = (event) => {
		const newVendor = state.vendor;
		var invoiceDocument = state.invoiceDocument;
		// Payment term: stamp if vendor has one, clear if vendor has none.
		invoiceDocument.paymentTermCode = newVendor?.termsCode || '';

		// Due date recalculation on vendor change:
		// When a vendor is changed, the paymentTermCode above gets updated but the due date was previously
		// never recalculated. This block mirrors the exact logic inside onPaymentTermsChange so that
		// dueDate/dueDateString stay in sync with the newly applied payment term — for ALL modelDefIds.
		const matchedTerm = (invoiceDocument.paymentTerms || []).find(t => t.termsCode === invoiceDocument.paymentTermCode);
		if (matchedTerm && invoiceDocument.invoiceDateString) {
			const daysDue = parseInt(matchedTerm.daysDue, 10);
			const invoiceDate = new Date(invoiceDocument.invoiceDateString);
			const dueDate = addDaysInDate(invoiceDate, daysDue);
			const isValidDueDate = dueDate.toString().indexOf('Invalid Date') === -1;
			if (dueDate && isValidDueDate && dueDate.toISOString().length > 10) {
				invoiceDocument.dueDate = dueDate;
				invoiceDocument.dueDateString = dueDate.toISOString().slice(0, 10);
			}
		} else if (!invoiceDocument.paymentTermCode) {
			// New vendor has no payment terms — clear the stale due date.
			invoiceDocument.dueDate = null;
			invoiceDocument.dueDateString = '';
		}

		// Tax: stamp if vendor has a valid taxCode in the list, clear otherwise.
		const taxExistsInList = newVendor?.taxCode && (state.taxes || []).some(t => t.taxCode === newVendor.taxCode);
		const taxToApply = taxExistsInList ? newVendor.taxCode : '';
		if (invoiceDocument.modelDefId === 2) {
			invoiceDocument.poCode = "";
			invoiceDocument.isPOCodeValid = newVendor.isNoPOVendor ? "Y" : "N";
			// Pass taxToApply so it is applied AFTER setInvoiceDetailsOnVendorChange completes,
			// preventing the async server response from overwriting the tax cascade.
			verifyProductionInvoiceDocumentDetails(taxToApply);
			setState((prev) => ({ ...prev, poHeaderLookup: [], invoiceDocument: invoiceDocument, openChangeVendorConfirmation: false, isDirty: true }));
		}
		else {
			// Model 1/3: stamp tax directly in cleared lines to avoid stale-closure issues.
			// ioInvoiceAmount preserved; tax recalculated immediately via calculateTaxAmountForRow.
			const taxesList = state.invoiceDocument?.taxes || [];
			const clearedDetails = (invoiceDocument.invoiceDocumentEditorDetails || []).map(line => {
				const clearedLine = {
					...line,
					ioNumber: "",
					poAmount: 0.00,
					consumedAmount: 0.00,
					deliveryAmount: 0.00,
					clientCode: "",
					taxCode: taxToApply,
					taxAmount: 0.00,
					invoiceDocumentDetailTaxes: [],
					ioDescription: "",
					mediaType: "",
					siteName: "",
					hasAuthority: "N",
					isTaxManuallyChanged: false,
					lineStatus: 40
				};
				return taxToApply ? calculateTaxAmountForRow(taxToApply, clearedLine, taxesList) : clearedLine;
			});
			invoiceDocument.invoiceDocumentEditorDetails = clearedDetails;
			if (invoiceDocument.modelDefId === 3) {
				setBroadCastTaxCode(taxToApply);
				// Reset broadCastValidation so useEffect recalculates field editability.
				setBroadCastValidation((prev) => ({ ...prev, changeCount: 0 }));
			}
			setState((prev) => ({ ...prev, poHeaderLookup: [], invoiceDocument: invoiceDocument, openChangeVendorConfirmation: false, isDirty: true }));
		}
		// setVendor calls input_changeHandler multiple times, each of which reads state.invoiceDocument
		// from its own stale closure and calls setState with it — overwriting the dueDate/dueDateString
		// we computed above. To prevent this, we re-stamp the computed dates AFTER setVendor in a
		// functional setState (using prev =>) so it always reads the latest committed state.
		const computedDueDate = invoiceDocument.dueDate ?? null;
		const computedDueDateString = invoiceDocument.dueDateString ?? '';
		setVendor(newVendor);
		setState((prev) => ({
			...prev,
			invoiceDocument: {
				...prev.invoiceDocument,
				dueDate: computedDueDate,
				dueDateString: computedDueDateString,
				paymentTermCode: invoiceDocument.paymentTermCode
			}
		}));
		// Refresh date validations so datesValidation.dueDateString reflects the new dueDateString.
		// This prevents the Save button from being incorrectly disabled after the vendor change.
		setDateValidations(invoiceDocument);
	}
	const changeVendor_closeHandler = (event) => {
		setState((prev) => ({ ...prev, openChangeVendorConfirmation: false }));
	}
	const searchIONumber_clickHandler = useCallback((event, selectedRows, currentEditRow, isAllowMultiple) => {
		const { modelDefId, serviceDateFilterForIoLookup, serviceTermStartDateString, serviceTermEndDateString } = state.invoiceDocument || {};
		const isMandatoryServiceDate = modelDefId === 1 && serviceDateFilterForIoLookup === "MANDATORY";

		if (isMandatoryServiceDate) {
			if (!serviceTermStartDateString || !serviceTermEndDateString) {
				toast.error('Please enter both Service Start Date and End Date for IO/PO selection.');
				return;
			}
			if (!serviceTermStartDateString) {
				toast.error('Please enter Service End Date for IO/PO selection.');
				return;
			}
			if (!serviceTermStartDateString) {
				toast.error('Please enter Service Start Date for IO/PO selection.');
				return;
			}

			const start = new Date(serviceTermStartDateString);
			const end = new Date(serviceTermEndDateString);

			if (end < start) {
				toast.error('End Date cannot be earlier than Start Date for IO/PO selection.');
				return;
			}
		}
		currentDetailEditRowRef.current = currentEditRow ? currentEditRow : null;
		const lineStatuses =
			Array.isArray(selectedRows) && selectedRows.length > 0
				? selectedRows.map(r => r.lineStatus)
				: currentEditRow
					? [currentEditRow.lineStatus]
					: [];
		if (isAllowMultiple) {
			setState((prev) => ({
				...prev,
				openPOHeaderDialog: true,
				selectedRow: selectedRows,
				allowMultipleSelection: true,
				poSelectionContext: {
					lineStatuses
				}
			}));
		}
		else {
			setState((prev) => ({
				...prev,
				openPOHeaderDialog: true,
				selectedRow: selectedRows,
				allowMultipleSelection: false,
				poSelectionContext: {
					lineStatuses
				}
			}));
		}
		setcurrentSelectedRow(selectedRows);
	}, [state.invoiceDocument]);


	const deletePOCode_clickHandler = (event) => {
		var invoiceDocument = state.invoiceDocument;
		invoiceDocument.poCode = "";
		invoiceDocument.isPOCodeValid = 'Y';
		setState((prev) => ({ ...prev, invoiceDocument: invoiceDocument, isDirty: true }));
		verifyProductionInvoiceDocumentDetails();
	}

	const EPSILON = 0.000001;

	const areFloatsEqual = (a, b) => {
		return Math.abs(a - b) < EPSILON;
	};

	const handleTaxCodeChange = (event) => {
		const newTaxCode = event.target.value;
		setBroadCastTaxCode(newTaxCode);
		setBraodCastTaxChanged(true);
		setState((prevState) => ({
			...prevState,
			isDirty: true,
		}));
	};

	// ModelDef 1/2 header Tax Code dropdown, apply selected tax code to ALL lines.
	const handleHeaderTaxCodeForLinesChange = (event) => {
		const newTaxCode = event.target.value;

		applyTaxCodeToAllLines(newTaxCode);

		setState((prevState) => ({
			...prevState,
			isDirty: true,
		}));
	};

	const handleMediaTypeChange = (event) => {
		const selectedType = event.target.value;
		const bands = selectedType
			? mediaTypeBandMap[selectedType] || []
			: Array.from(new Set(Object.values(mediaTypeBandMap).flat()));

		setFilteredBandOptions([...new Set(bands)]);

		setState((prevState) => ({
			...prevState,
			isDirty: true,
			invoiceDocument: {
				...prevState.invoiceDocument,
				broadcastType: selectedType,
				band: ''
			}
		}));
	};



	const handleBandChange = (event) => {
		const broadcastBand = event.target.value;

		setState((prevState) => ({
			...prevState,
			isDirty: true,
			invoiceDocument: {
				...prevState.invoiceDocument,
				band: broadcastBand
			}
		}));
	}

	const checkLineStatusForChangeCompany = (invoiceDocument) => {
		const lines = invoiceDocument?.invoiceDocumentEditorDetails;
		if (!lines?.length) return true; // no lines = nothing blocking the change

		return lines.every(line => line.lineStatus < 70 || line.lineStatus === 100);
	};

	const poHeaderDialog_closeHandler = React.useCallback((event, SelectedDataRows) => {
		let invoiceDocument = state.invoiceDocument || {};
		let isDirty = false;

		if (!SelectedDataRows || SelectedDataRows.length === 0 || SelectedDataRows[0] === undefined) {
			setState(prev => ({ ...prev, openPOHeaderDialog: false, clientLookup: [] }));
			return;
		}

		const { allowMultipleSelection } = state;

		if (allowMultipleSelection && SelectedDataRows.length <= 1) {
			toast.error('Please select more than one IO to split the amount into multiple lines.');
			return;
		}

		if (invoiceDocument && SelectedDataRows.length > 0) {
			isDirty = true;

			if (state.invoiceDocument?.modelDefId === 2) {
				const firstPOHeader = SelectedDataRows[0];
				const doVerification = invoiceDocument.poCode !== firstPOHeader?.poCode;

				invoiceDocument.poCode = firstPOHeader?.poCode.trim();
				invoiceDocument.poAmount = firstPOHeader?.poAmount;
				invoiceDocument.consumedAmount = firstPOHeader?.consumedAmount;
				invoiceDocument.isPOCodeValid = 'Y';
				invoiceDocument.hasAuthority = firstPOHeader?.hasAuthority;
				invoiceDocument.allowInvoiceCorrection = state.invoiceDocument?.allowInvoiceEditing == true ? 'Y' : 'N';
				//invoiceDocument.clientCode = firstPOHeader.clientCode;

				if (doVerification) {
					verifyProductionInvoiceDocumentDetails();
				}
			} else {
				const selectedRowsArray = Array.from(currentSelectedRow);
				const multipleInvoiceLinesSelected = selectedRowsArray.length > 1;
				const selectedFirstRow = selectedRowsArray[0];
				const taxCode = selectedFirstRow.taxCode;

				if (SelectedDataRows.length === 1) {
					const singlePOHeader = SelectedDataRows[0];

					if (multipleInvoiceLinesSelected) {
						selectedRowsArray.forEach((seqId, index) => {
							let row = selectedRowsArray.find(r => r.seqId === seqId.seqId);
							if (row) {
								row.ioNumber = singlePOHeader?.poCode.trim();
								row.poCode = singlePOHeader?.poCode.trim();
								row.poAmount = singlePOHeader?.poAmount;
								row.consumedAmount = singlePOHeader?.consumedAmount;
								row.isIONumberValid = 'Y';
								row.isIOUpdated = true;
								row.isDirty = true;
								row.hasAuthority = singlePOHeader?.hasAuthority;
								row.allowInvoiceCorrection = selectedRowsArray[index].allowInvoiceCorrection;
								row.taxCode = taxCode;
								row.clientCode = singlePOHeader?.clientCode;
								row.mediaType = singlePOHeader?.mediaType;
								row.siteName = singlePOHeader?.siteName;
								let { start: serviceTermStartDateString, end: serviceTermEndDateString } = parseServiceTermDates(singlePOHeader?.serviceStartDate);

								row.startDate = serviceTermStartDateString;
								row.endDate = serviceTermEndDateString;
								// Pass the row to the setDetailsOnPOChange function
								editorGridRef.current.setDetailsOnPOChange(row, SelectedDataRows, row.taxCode);
							}
						});

						setState(prev => ({
							...prev,
							isDirty: true,
							invoiceDocument: { ...invoiceDocument, invoiceDocumentEditorDetails: [...invoiceDocument?.invoiceDocumentEditorDetails] }
						}));
					} else {
						selectedFirstRow.ioNumber = singlePOHeader?.poCode?.trim();
						selectedFirstRow.poCode = singlePOHeader?.poCode?.trim();
						selectedFirstRow.poAmount = singlePOHeader?.poAmount;
						selectedFirstRow.consumedAmount = singlePOHeader?.consumedAmount;
						selectedFirstRow.deliveryAmount = singlePOHeader?.deliveryAmount;
						selectedFirstRow.taxCode = taxCode; // Assign taxCode
						selectedFirstRow.clientCode = singlePOHeader?.clientCode;
						selectedFirstRow.mediaType = singlePOHeader?.mediaType;
						selectedFirstRow.siteName = singlePOHeader?.siteName;
						let { start: serviceTermStartDateString, end: serviceTermEndDateString } = parseServiceTermDates(singlePOHeader?.serviceStartDate);

						selectedFirstRow.startDate = serviceTermStartDateString;
						selectedFirstRow.endDate = serviceTermEndDateString;
						if (!singlePOHeader)
							selectedFirstRow.lineStatus = 40;

						// Pass the row to the setDetailsOnPOChange function
						editorGridRef.current.setDetailsOnPOChange(selectedFirstRow, SelectedDataRows, selectedFirstRow.taxCode);

						setState(prev => ({
							...prev,
							isDirty: true,
							invoiceDocument: {
								...invoiceDocument,
								invoiceDocumentEditorDetails: invoiceDocument.invoiceDocumentEditorDetails.map(row =>
									row.seqId === selectedFirstRow.seqId ? selectedFirstRow : row
								)
							}
						}));
					}
				} else {
					const anyZeroAllocated = SelectedDataRows.some(row => !row.allocatedAmount || parseFloat(row.allocatedAmount) === 0);
					if (anyZeroAllocated) {
						toast.error('Split not allowed: One or more selected IOs have zero allocated amount.');
						return;
					}
					//const anyNegativeRemaining = SelectedDataRows.some(row => {
					//	const remaining = row.poAmount - row.consumedAmount;
					//	return remaining < 0;
					//});
					//if (anyNegativeRemaining) {
					//	toast.error('Split not allowed: One or more selected IOs have negative remaining amount.');
					//	return;
					//}
					const anyOverAllocated = SelectedDataRows.some(row => {
						const rawRemaining = row.poAmount - row.consumedAmount;
						const remaining = parseFloat(rawRemaining.toFixed(2));
						const allocated = parseFloat(row.allocatedAmount);

						// 🚫 Condition depends on whether remaining is positive or negative
						if (remaining >= 0) {
							return allocated > remaining;
						} else {
							return false;
						}
					});

					if (anyOverAllocated) {
						toast.error('Split not allowed: One or more selected IOs have allocated amount greater than remaining amount.');
						return;
					}


					const totalRemainingAmount = SelectedDataRows.reduce((sum, row) => sum + row.allocatedAmount, 0);

					if (!areFloatsEqual(totalRemainingAmount, selectedFirstRow.ioInvoiceAmount)) {
						toast.error('The sum of the remaining amounts for the selected IO/PO numbers does not match the Invoice Net Amount.');
						return;
					} else {
						const additionalPOHeadersWithSeq = SelectedDataRows.map((row, index) => {
							const newSeqId = Math.max(...invoiceDocument?.invoiceDocumentEditorDetails.map(r => r.seqId)) + index + 1;
							return {
								...row,
								ioInvoiceAmount: row.allocatedAmount,
								seqId: newSeqId,
								invoiceDocumentId: state.invoiceDocument?.invoiceDocumentId,
								hasAuthority: row.hasAuthority,
								allowInvoiceCorrection: state.invoiceDocument?.allowInvoiceEditing == true ? 'Y' : 'N',
								lineStatus: 50,
								taxCode: taxCode,
								clientCode: row.clientCode,
								mediaType: row.mediaType
							};
						});

						selectedFirstRow.ioInvoiceAmount = SelectedDataRows[0].allocatedAmount;
						selectedFirstRow.taxCode = taxCode; // Assign taxCode

						editorGridRef.current.setDetailsOnPOChange(selectedFirstRow, additionalPOHeadersWithSeq, taxCode);
					}
				}
			}
		}

		setState(prev => ({ ...prev, openPOHeaderDialog: false, isDirty: isDirty || state.isDirty, clientLookup: [] }));

	}, [state.invoiceDocument, state.isDirty, editorGridRef, currentSelectedRow]);

	const poHeaderResourceDialog_closeHandler = (event, poHeaderResources) => {
		if (poHeaderResources.length > 0) {
			const source = state.source;
			let routedToResources;
			if (source === 'approvalRouting') {
				routedToResources = poHeaderResources.map(resource => ({
					companyCode: state.invoiceDocument?.companyCode,
					invoiceDocumentId: state.invoiceDocument?.invoiceDocumentId,
					comments: resource.comments,
					resourceId: resource.resourceId,
					email: resource.email,
					createBy: "",
					createdDate: new Date().toISOString(),
				}));
			} else {
				routedToResources = poHeaderResources.map(poHeaderResource => ({
					invoiceDocumentId: state.invoiceDocument?.invoiceDocumentId,
					resourceId: poHeaderResource.resourceId,
					email: poHeaderResource.email,
					comments: poHeaderResource.comments
				}));
			}

			props.info.inProgress(true);

			const apiEndpoint = source === 'approvalRouting'
				? "/api/invoicedocument/invoiceDocumentApprovalRoutingHistory/"
				: "/api/invoicedocument/routetoemployee/";

			httpPost(apiEndpoint, routedToResources)
				.then((response) => {
					var data = response.data;
					var invoiceDocument = state.invoiceDocument;
					invoiceDocument.routedToResourceId = data.resourceId;

					setState((prev) => ({ ...prev, invoiceDocument: invoiceDocument }));

					props.info.inProgress(false);

					const successMessage = source === 'approvalRouting'
						? 'Approval Routing Successful'
						: 'Routed to Employee Successfully';
					const isRoutedToEmployeeOrApproval = true;
					toast.success(successMessage);

					const updatedRowFields = {
						invoiceDocumentId: data?.[0]?.invoiceDocumentId,

					};
					close_clickHandler(null, isRoutedToEmployeeOrApproval, false, null, 0, false, updatedRowFields);
				})
				.catch((error) => {
					props.info.inProgress(false);

					const errorMessage = source === 'approvalRouting'
						? 'Approval Routing Failed'
						: 'Route to Employee Failed';

					toast.error(errorMessage);
				});
		}

		setState((prev) => ({
			...prev,
			openPOHeaderResourceDialog: false,
			selectedRows: [],
			comments: ""
		}));
	}
	const level2ResourceDialog_closeHandler = (event, level2Resources) => {
		if (level2Resources.length > 0) {
			const source = state.source;
			let routedToResources;

			if (source === 'approvalRouting') {
				routedToResources = level2Resources.map(resource => ({
					companyCode: state.invoiceDocument?.companyCode,
					invoiceDocumentId: state.invoiceDocument?.invoiceDocumentId,
					comments: resource.comments,
					resourceId: resource.resourceId,
					email: resource.email,
					createBy: "",
					createdDate: new Date().toISOString(),
				}));
			}
			else {
				routedToResources = level2Resources.map(level2Resource => ({
					invoiceDocumentId: state.invoiceDocument?.invoiceDocumentId,
					resourceId: level2Resource.resourceId,
					email: level2Resource.email,
					comments: level2Resource.comments
				}));
			}

			props.info.inProgress(true);

			const apiEndpoint = source === 'approvalRouting'
				? "/api/invoicedocument/invoiceDocumentApprovalRoutingHistory/"
				: "/api/invoicedocument/routetoemployee/";

			httpPost(apiEndpoint, routedToResources)
				.then((response) => {
					const responseData = response.data;
					const updatedInvoiceDocument = {
						...state.invoiceDocument,
						routedToResourceId: responseData.resourceId
					};

					setState((prev) => ({ ...prev, invoiceDocument: updatedInvoiceDocument }));
					props.info.inProgress(false);

					const successMessage = source === 'approvalRouting'
						? 'Approval Routing Successful'
						: 'Routed to Employee Successfully';
					toast.success(successMessage);
					const isRoutedToEmployeeOrApproval = true;

					const updatedRowFields = {
						invoiceDocumentId: updatedInvoiceDocument?.invoiceDocumentId,

					};
					close_clickHandler(null, isRoutedToEmployeeOrApproval, false, null, 0, false, updatedRowFields);


				})
				.catch((error) => {
					props.info.inProgress(false);

					const errorMessage = source === 'approvalRouting'
						? 'Approval Routing Failed'
						: 'Route to Employee Failed';
					toast.error(errorMessage);
				});
		}

		setState((prev) => ({
			...prev,
			openLevel2ResourceDialog: false,
			selectedRows: [],
			comments: ""
		}));
	};

	const handleServiceTermChange = (field, value) => {

		const updatedInvoiceDocument = {
			...state.invoiceDocument,
			[field]: value
		};

		const invalidRows =
			getInvalidIoPoRowsForServiceTerm(updatedInvoiceDocument);

		if (invalidRows.length > 0) {

			setPendingServiceTerm({ field, value });
			setInvalidIoPoRows(invalidRows);
			setOpenServiceTermDialog(true);

			return;
		}

		setState(prev => ({
			...prev,
			invoiceDocument: updatedInvoiceDocument
		}));
	};

	const handleServiceTermDialogYes = () => {
		invalidIoPoRows.forEach(row => {
			if (editorGridRef.current &&
				editorGridRef.current.clearIONumberHandler) {
				editorGridRef.current.clearIONumberHandler(row);
			}
		}); setOpenServiceTermDialog(false); setInvalidIoPoRows([]); setPendingServiceTerm(null);
	};

	const handleServiceTermDialogNo = () => {

		if (!initialInvoiceDocument) {
			setOpenServiceTermDialog(false);
			return;
		}

		setState(prev => ({
			...prev,
			invoiceDocument: {
				...prev.invoiceDocument,
				serviceTermStartDateString:
					initialInvoiceDocument.serviceTermStartDateString,
				serviceTermEndDateString:
					initialInvoiceDocument.serviceTermEndDateString,
				serviceTermStartDate:
					initialInvoiceDocument.serviceTermStartDate,
				serviceTermEndDate:
					initialInvoiceDocument.serviceTermEndDate
			}
		}));

		setOpenServiceTermDialog(false);
		setInvalidIoPoRows([]);
		setPendingServiceTerm(null);
	};

	const approval_Routing_clickHandler = () => {
		var isProduction = state.invoiceDocument?.modelDefId === 2;
		setState((prev) => ({ ...prev, openPOHeaderResourceDialog: !isProduction, openLevel2ResourceDialog: isProduction, userRoleName: loginUserRole, source: 'approvalRouting' }));
	};

	const routing_History_clickHandler = () => {
		setOpenInvoiceDocumentApprovalDialog(true);
	}
	const favourite_button_clickhandler = () => {

		const wasMarkedFavourite = props.info.rowData.isFavorite === 'Y';
		const message = wasMarkedFavourite
			? 'Removed from favorites successfully.'
			: 'Added to favorites successfully.';

		props.info.toggleFavoriteStatus(props.info.rowData);

		toast.success(message);
	};

	const closeDialogHandler = () => {
		setOpenInvoiceDocumentApprovalDialog(false);
	};

	const reset_clickHandler = () => {
		setState((prev) => {
			const resetInvoice = structuredClone(state.invoiceDocumentImage);
			const selectedType = resetInvoice.broadcastType;

			let validBands = [];

			if (selectedType) {
				validBands = mediaTypeBandMap[selectedType] || [];
			} else {
				validBands = Array.from(new Set(Object.values(mediaTypeBandMap).flat()));
			}

			const band = validBands.includes(resetInvoice.band) ? resetInvoice.band : '';
			setFilteredBandOptions(validBands);

			return {
				...prev,
				invoiceDocument: {
					...resetInvoice,
					broadcastType: selectedType || '',
					band: band
				},
				isDirty: false
			};
		});
		if (props.info.modelDefId === 3) {
			let detail = state?.invoiceDocumentImage?.invoiceDocumentEditorDetails[0];
			setBroadCastInvoiceTotal(detail?.ioInvoiceAmount || 0);
			setBroadCastTaxCode(detail?.taxCode || '')
		}
		editorGridRef?.current?.resetGridData(state.invoiceDocumentImage);
	};




	//#endregion Events

	//#region Validations

	const POCodeValid = () => {
		var isValid = state.invoiceDocument?.modelDefId === 2 ? false : true;
		if (state.invoiceDocument?.modelDefId === 2) {
			if (VendorSelected()) {
				let invoiceDocumentDetails = state?.invoiceDocument?.invoiceDocumentEditorDetails;
				if (state.invoiceDocument?.noPoFlag === 'Y') {
					return true;
				}
				// If vendor was changed and flagged PO as required (isPOCodeValid === 'N'), PO must be selected — no lines present does not override this.
				const vendorRequiresPO = state.invoiceDocument?.isPOCodeValid === 'N';
				isValid = (stringIsNullOrEmpty(state.invoiceDocument?.poCode) && ((invoiceDocumentDetails?.length || 0) === 0 || (invoiceDocumentDetails || []).every(d => d.poRequiredFlag === 'N')))
						|| (!stringIsNullOrEmpty(state.invoiceDocument?.poCode) && state.invoiceDocument?.isPOCodeValid === 'Y');
			}
		}
		return isValid;
	}
	const DueDateValid = () => {
		var isValid = stringIsNullOrEmpty(state.invoiceDocument?.dueDateString) && stringIsNullOrEmpty(state.invoiceDocument?.invoiceDateString) ? false : true;
		if (isValid) {
			var dueDate = new Date(state.invoiceDocument?.dueDateString);
			var invoiceDate = new Date(state.invoiceDocument?.invoiceDateString);
			isValid = dueDate >= invoiceDate;
		}
		return isValid;
	}
	const InvoiceNumberValid = () => {
		var isValid = (!stringIsNullOrEmpty(state.invoiceDocument?.invoiceNumber) && state.invoiceDocument?.invoiceNumber.length <= 32)
			&& ((props.info.modelDefId !== 3 || state?.invoiceDocument?.invoiceSource === 1) || state.invoiceDocument?.invoiceNumber.length <= 10);
		return isValid;
	}
	const totalSpotValid = () => {
		var isValid = props.info.modelDefId !== 3;
		if (!isValid) {
			isValid = !stringIsNullOrEmpty(state.invoiceDocument?.totalSpot) && parseFloat(state.invoiceDocument?.totalSpot) > 0;
		}
		return isValid;
	}
	const ServiceTermStartValid = () => {
		var isValid = ServiceTermStartValidInner() && datesValidation.serviceTermStartDateString;
		return isValid;
	}
	const ServiceTermStartValidInner = () => {
		return !stringIsNullOrEmpty(state.invoiceDocument?.serviceTermStartDateString);
	}
	const ServiceTermEndValid = () => {
		var isValid = !stringIsNullOrEmpty(state.invoiceDocument?.serviceTermEndDateString) && datesValidation.serviceTermEndDateString;
		if (isValid) {
			isValid = ServiceTermEndValidInner();
		}
		return isValid;
	}
	const ServiceTermEndValidInner = () => {
		var isValid = !stringIsNullOrEmpty(state.invoiceDocument?.serviceTermEndDateString);
		if (isValid) {
			var endDate = new Date(state.invoiceDocument?.serviceTermEndDateString);
			var startDate = new Date(state.invoiceDocument?.serviceTermStartDateString);
			isValid = endDate >= startDate;
		}
		return isValid;

	}
	//#region IO PO invalid Validators
	const IONumberValid = (rowData) => {
		var isValid = true;
		if (state.invoiceDocument?.modelDefId === 1 &&
			(stringIsNullOrEmpty(rowData.ioNumber) || (!stringIsNullOrEmpty(rowData.ioNumber) && rowData.isIONumberValid !== 'Y'))) {
			isValid = false;
		}
		return isValid;
	}
	const Level2KeyValid = (rowData) => {
		var isValid = true;
		if (state.invoiceDocument?.modelDefId === 2 &&
			(stringIsNullOrEmpty(rowData.level2Key) || (!stringIsNullOrEmpty(rowData.level2Key) && rowData.isLevel2KeyValid !== 'Y'))) {
			isValid = false;
		}
		return isValid;
	}
	const Level3KeyValid = (rowData) => {
		var isValid = true;
		if (state.invoiceDocument?.modelDefId === 2 &&
			(stringIsNullOrEmpty(rowData.level3Key) || (!stringIsNullOrEmpty(rowData.level3Key) && rowData.isLevel3KeyValid !== 'Y'))) {
			isValid = false;
		}
		return isValid;
	}
	const CostCodesValid = (rowData) => {
		var isValid = true;
		if (state.invoiceDocument?.modelDefId === 2 &&
			(stringIsNullOrEmpty(rowData.resType) || (!stringIsNullOrEmpty(rowData.resType) && rowData.isCostCodesValid !== 'Y'))) {
			isValid = false;
		}
		return isValid;
	}
	const getDiscountField = React.useCallback((dataRowId) => {
		return (<div className="row-form" style={{
			display: (props?.info?.mode === 'UserEntry' || (state?.invoiceDocument?.invoiceDocumentFileLocation?.indexOf('USER_ENTRY_') !== -1 &&
				state.invoiceDocument?.masterDocumentModelId == null)
				? 'none' : '')
		}} data-row={dataRowId}>
			<div className="mf-10">
				<label>Discount:</label>
				{state.invoiceDocument && <input type="text" style={{ textAlign: 'right' }}
					name="discount" readOnly={true} value={formatNumber(state.invoiceDocument?.discountAmount || 0.00)} />}
			</div>
			<div style={{ width: 5, padding: 5 }}>
			</div>
		</div>)
	}, [state.invoiceDocument?.discountAmount])
	//#endregion
	const InvoiceAmountValid = (rowData) => {
		var isValid = false;
		// -ve values are also acceptable in invoice details
		if (props.info.modelDefId === 3) {
			var invoiceDocumentEditorDetails = structuredClone((state?.invoiceDocument?.invoiceDocumentEditorDetails || []));
			return invoiceDocumentEditorDetails.length > 0 && invoiceDocumentEditorDetails[0].ioInvoiceAmount != 0;
		}
		if (state.invoiceDocument?.modelDefId === 2) {
			isValid = rowData.ioInvoiceAmount != 0;
			if (isValid) {
				if (!stringIsNullOrEmpty(state.invoiceDocument?.poCode)) {
					var invoiceDocumentEditorDetails = structuredClone((state?.invoiceDocument?.invoiceDocumentEditorDetails || []));
					var index = invoiceDocumentEditorDetails.findIndex(d => d.seqId === rowData.seqId);
					if (index < 0) {
						invoiceDocumentEditorDetails.push(JSON.parse(JSON.stringify(rowData)));
					} else {
						invoiceDocumentEditorDetails[index] = JSON.parse(JSON.stringify(rowData));
					}
					invoiceDocumentEditorDetails[invoiceDocumentEditorDetails.findIndex(d => d.seqId === rowData.seqId)].ioInvoiceAmount = Number(Number(rowData.ioInvoiceAmount).toFixed(2));
					var groupedInvoiceDocumentDetails = groupAndSum(invoiceDocumentEditorDetails, ['level2Key', 'tolerancePOFlag', 'tolerancePOAmount', 'level3Key', 'resType', 'remainingAmount'], ['ioInvoiceAmount']);
					var groupedFilteredOnKeyFields = groupedInvoiceDocumentDetails.filter(d => d.level2Key === rowData.level2Key && d.level3Key === rowData.level3Key && d.resType === rowData.resType);
					isValid = !(groupedFilteredOnKeyFields.some(d => {
						var isInvoiceAmountInvalid = Number(zeroIfNull(parseFloat(d.ioInvoiceAmount || 0)).toFixed(2)) > Number(zeroIfNull(d.remainingAmount).toFixed(2));
						if (isInvoiceAmountInvalid) {
							if (d.tolerancePOFlag === 'N') {
								isInvoiceAmountInvalid = Number(zeroIfNull(parseFloat(d.ioInvoiceAmount || 0)).toFixed(2)) > Number((zeroIfNull(d.remainingAmount) + zeroIfNull(d.tolerancePOAmount)).toFixed(2));
							}
							else {
								var percentRemainingAmount = (zeroIfNull(d.tolerancePOAmount) * zeroIfNull(d.remainingAmount)) / 100.00;
								isInvoiceAmountInvalid = Number(Number(d.ioInvoiceAmount).toFixed(2)) > Number((d.remainingAmount + percentRemainingAmount).toFixed(2));
							}
						}
						return isInvoiceAmountInvalid;
					}));
				}
			}
		}
		else {
			if (currentEditRow !== null && currentEditRow.isIOUpdated && currentEditRow.seqId === rowData.seqId) {
				rowData.ioNumber = currentEditRow.ioNumber;
				rowData.poAmount = currentEditRow.poAmount;
				rowData.consumedAmount = currentEditRow.consumedAmount;
				rowData.deliveryAmount = currentEditRow.deliveryAmount;
				rowData.isIONumberValid = currentEditRow.isIONumberValid = 'Y';
				currentEditRow.isIOUpdated = false;
			}
			isValid = rowData.ioInvoiceAmount != 0;
			if (isValid) {
				var invoiceDocumentEditorDetails = structuredClone((state?.invoiceDocument?.invoiceDocumentEditorDetails || []));
				var index = invoiceDocumentEditorDetails.findIndex(d => d.seqId === rowData.seqId);
				if (index < 0) {
					invoiceDocumentEditorDetails.push(JSON.parse(JSON.stringify(rowData)));
				} else {
					invoiceDocumentEditorDetails[index] = JSON.parse(JSON.stringify(rowData));
				}
				invoiceDocumentEditorDetails[invoiceDocumentEditorDetails.findIndex(d => d.seqId === rowData.seqId)].ioInvoiceAmount = Number(Number(rowData.ioInvoiceAmount).toFixed(2));
				var groupedInvoiceDocumentDetails = groupAndSum(invoiceDocumentEditorDetails, ['ioNumber', 'poAmount', 'consumedAmount', 'tolerancePOFlag', 'tolerancePOAmount', 'remainingAmount'], ['ioInvoiceAmount']);
				var groupedFilteredOnKeyFields = groupedInvoiceDocumentDetails.filter(d => d.ioNumber === rowData.ioNumber);
				isValid = !(groupedFilteredOnKeyFields.some(d => {
					var remainingAmount = (Number(zeroIfNull(parseFloat(d.poAmount || 0)).toFixed(2)) - Number(zeroIfNull(d.consumedAmount).toFixed(2)));
					var isInvoiceAmountInvalid = Number(Number(zeroIfNull(parseFloat(d.ioInvoiceAmount || 0))).toFixed(2)) > Number(remainingAmount.toFixed(2));
					if (isInvoiceAmountInvalid) {
						if (d.tolerancePOFlag === 'N') {
							var remainingWithTol = Number((zeroIfNull(remainingAmount) + zeroIfNull(d.tolerancePOAmount)).toFixed(2));
							if (remainingWithTol < 0)
								remainingWithTol = 0
							isInvoiceAmountInvalid = Number(zeroIfNull(parseFloat(d.ioInvoiceAmount)).toFixed(2)) > Number((remainingWithTol).toFixed(2));
						}
						else {
							var percentRemainingAmount = (zeroIfNull(d.tolerancePOAmount) * zeroIfNull(d.poAmount)) / 100.00;
							var remainingWithTol = Number((zeroIfNull(remainingAmount) + percentRemainingAmount).toFixed(2));
							if (remainingWithTol < 0)
								remainingWithTol = 0
							isInvoiceAmountInvalid = Number(Number(d.ioInvoiceAmount).toFixed(2)) > Number((remainingWithTol).toFixed(2));
						}
					}

					return isInvoiceAmountInvalid;
				}));
			}
		}
		return isValid;
	}
	const InvoiceDocumentDetailValid = () => {
		let editorDetail = (state?.invoiceDocument?.invoiceDocumentEditorDetails || []);
		var isValid = editorDetail.length > 0;
		if (isValid) {
			if (props.info.modelDefId === 2) {
				isValid = editorDetail.some(d =>
					Level2KeyValid(d) &&
					Level3KeyValid(d) &&
					CostCodesValid(d) &&
					InvoiceAmountValid(d));
			}
			else if (props.info.modelDefId === 1) {
				isValid = !(editorDetail.some(d => stringIsNullOrEmpty(d.ioNumber) || !InvoiceAmountValid(d)));
			}
			else {
				isValid = !(editorDetail.some(d => !InvoiceAmountValid(d)));
			}
		}
		return isValid;
	}

	const InvoiceDocumentDetailMissingInfo = () => {
		let editorDetail = (state?.invoiceDocument?.invoiceDocumentEditorDetails || []);
		let isMissingInfo = editorDetail.length <= 0;
		if (!isMissingInfo) {
			if (state.invoiceDocument?.modelDefId === 2) {
				isMissingInfo = !editorDetail.every((e, i) => {
					return Level2KeyValid(e) &&
						Level3KeyValid(e) &&
						CostCodesValid(e) &&
						(parseFloat(e.quantity || 0) > 0) &&
						InvoiceAmountValid(e);
				});
			}
			else if (props.info.modelDefId === 1) {
				isMissingInfo = !(editorDetail.every(d => !stringIsNullOrEmpty(d.ioNumber) && isIOValid(d) && InvoiceAmountValid(d)));
			}
			else {
				isMissingInfo = !(editorDetail.every(d => InvoiceAmountValid(d)));
			}
		}


		return isMissingInfo;
	}
	const isIOValid = (row) => {
		if (!stringIsNullOrEmpty(row.ioNumber) && row.isIONumberValid === 'Y') {
			return true;
		} else {
			return false;
		}
	}

	const createInvoiceEditorCapabilitiesFactory = React.useCallback((userInfo, props) => {
		const stateInvoiceDocument = state.invoiceDocument;
		return function (updateInvoiceDocument) {
			let invoiceDocument;
			try {
				invoiceDocument = { ...stateInvoiceDocument, invoiceDocumentStatusId: updateInvoiceDocument?.invoiceDocumentStatusId }
				setInvoiceDocumentStatusId(updateInvoiceDocument?.invoiceDocumentStatusId);
			}
			catch (e) {
				console.log(e);
				throw e;
			}
			const Constants = props.Constants || require('../Common/Constants').Constants;
			const isListLikeSource =
				props?.info?.editorSource === Constants.INVOICE_LIST_SOURCE ||
				props?.info?.editorSource === Constants.SOURCE_DASHBOARD_GADGET ||
				props?.info?.editorSource === Constants.SOURCE_INVOICE_REPORT;

			const serverIsAdmin = invoiceDocument?.isAdmin ?? userInfo?.selectedUserRoles?.isAdmin ?? false;
			const isDifferentCompany = invoiceDocument?.isDifferentCompany ?? false;
			const routingLevels =
				invoiceDocument?.routingNumberOfApprovalLevels ??
				invoiceDocument?.companyApprovalConfiguration?.routingNumberOfApprovalLevels ??
				0;

			// Derive workflow mode from status by default.
			const workflowMode = resolveWorkflowMode(invoiceDocument, routingLevels, isDifferentCompany);
			let derivedMode = workflowMode;
			if (!isListLikeSource && props?.info?.mode) {
				derivedMode = props.info.mode;
			}

			// Enforce view-only rule for ModelDef 3 source invoices even if a caller tries to force a mode.
			if (Number(invoiceDocument?.modelDefId) === 3 && Number(invoiceDocument?.invoiceSource) === 1) {
				derivedMode = Constants.VIEW;
			}

			const resolvedCaps = isListLikeSource
				? resolveWorkflowCapabilities(invoiceDocument, {
					isAdmin: serverIsAdmin,
					routingNumberOfApprovalLevels: routingLevels,
					isDifferentCompany,
				})
				: {
					canPostToERP: false,
					canRepostToERP: false,
					canOverride: false,
					canEditDates: false,
					hasDifferentCompany: isDifferentCompany,
					canPostCreditMemo: false,
					canDelete: false
				};

			let {
				canPostToERP,
				canRepostToERP,
				canOverride,
				canEditDates,
				hasDifferentCompany,
				canPostCreditMemo,
				canDelete
			} = resolvedCaps;

			// Repost rule is required for any repost actions (both partial + full repost)
			const repostRuleEditable = isRepostRuleEditable(
				invoiceDocument?.userGroupRules,
				invoiceDocument?.modelDefId ?? props.info.modelDefId
			);

			const creditMemoPost = isCreditMemoPostEnabled(
				invoiceDocument?.userGroupRules,
				invoiceDocument?.modelDefId ?? props.info.modelDefId
			);

			// Derive partial-post / repost eligibility directly from invoiceDocument (editor truth)
			const derivedPartialInvoiceStatus = derivePartialInvoiceStatus(invoiceDocument, repostRuleEditable);

			// Gate BOTH repost buttons with the same rule
			const invoiceIndicator = invoiceDocument?.invoiceIndicator;
			const isCreditMemo = invoiceIndicator === 2;

			canRepostToERP = !isCreditMemo && Boolean((canRepostToERP) && repostRuleEditable);
			canPostToERP = !isCreditMemo && Boolean((canPostToERP) && repostRuleEditable);
			canPostCreditMemo = (creditMemoPost && canPostCreditMemo);

			return {
				mode: derivedMode,
				partialInvoiceStatus: derivedPartialInvoiceStatus,
				capabilities: {
					canEditInvoice: (canEditDates || canOverride),
					canPostToERP,
					canRepostToERP,
					canOverride,
					canEditDates,
					hasDifferentCompany,
					canDelete,
					canPostCreditMemo
				}
			};
		};

	}, [state.invoiceDocument, setInvoiceDocumentStatusId]);

	const getInvoiceEditorCapabilities = React.useCallback(createInvoiceEditorCapabilitiesFactory(props.info.userInfo, props), [createInvoiceEditorCapabilitiesFactory]);




	const getErrorMessage = () => {
		let errorRecordList = editorGridRef.current?.invalidRowsList || [];
		let details = state?.invoiceDocument?.invoiceDocumentEditorDetails || [];
		let dtlmsgs = editorGridRef.current?.invalidRowsMessage || {};
		let chkAllValid = (state.originalInvoiceDocumentStatus !== 60 && state.originalInvoiceDocumentStatus > 41);
		const isApproval50or100 =
			(state.originalInvoiceDocumentStatus === 50 ||
				state.originalInvoiceDocumentStatus === 100);
		const skipDetailErrors =
			(state?.invoiceDocument?.invoiceDocumentId || 0) !== 0 &&
			isApproval50or100 &&
			needsRevertTo40(state.invoiceDocument, props.info.modelDefId);
		let backErrors = [];
		let errors = [];
		let detailErrors = [];
		let partialErrors = [];
		let dateErrors = checkAllDateValues();
		let _isTaxDiscrepent = !allowDiscrepentTax && isTaxDiscrepent(details);
		const detailsMessage = '- Invoice amount should be less than or equal to remaining amount at detail line(s)';
		if (stringIsNullOrEmpty(state.invoiceDocument?.vendor)) {
			backErrors.push(`- Vendor is required`);
		}
		if (state.isInvoiceNumberDuplicate || !_isInvoiceNumberValid || _isTaxDiscrepent) {
			if (state.originalInvoiceDocumentStatus <= 41) {
				if ((!stringIsNullOrEmpty(state.invoiceDocument?.invoiceNumber) && state.isInvoiceNumberDuplicate)
					|| (!stringIsNullOrEmpty(state.invoiceDocument?.invoiceNumber) && state.invoiceDocument?.invoiceNumber?.length > 32)
					|| (!stringIsNullOrEmpty(state.invoiceDocument?.invoiceNumber)
						&& props.info.modelDefId === 3
						&& state.invoiceDocument?.invoiceNumber?.length > 10)
				) {
					if (props.info.modelDefId === 3
						&& state.invoiceDocument?.invoiceNumber?.length > 10) {
						backErrors.push(`- Invoice number exceeds the 10-characters limit`);
					}
					else {
						backErrors.push(`- Invoice Number is duplicate or invalid`);
					}

				}
				if (_isTaxDiscrepent) {
					backErrors.push(`- Taxes are discrepent`);
				}
			}
			else {
				if (stringIsNullOrEmpty(state.invoiceDocument?.invoiceNumber)) {
					backErrors.push(`- Invoice Number is required`);
				} else {
					backErrors.push(`- Invoice Number is duplicate or invalid`);
				}
			}

		}


		if (!chkAllValid || skipDetailErrors && props.info.modelDefId !== 3) {
			let errorCount = 0;
			details?.forEach((e, i) => {
				if (props.info.modelDefId === 1) {
					/*if (e.isDirty && IONumberValid(e)) {*/
					/*if (e.isDirty) {*/
					if (IONumberValid(e) && parseFloat(e.ioInvoiceAmount || 0) !== 0 && dtlmsgs[e.seqId] && dtlmsgs[e.seqId].type == '1') {
						//partialErrors.push(`- ${dtlmsgs[e.seqId] ? dtlmsgs[e.seqId].errorMsg : ''} at line #${i + 1}`);
						//}
						errorCount++;
					}
				}
				//CostCodesValid Level3KeyValid Level2KeyValid
				if (props.info.modelDefId === 2) {
					let isPOValid = e.poRequiredFlag === 'Y' ? !stringIsNullOrEmpty(state.invoiceDocument?.poCode) && state.invoiceDocument?.isPOCodeValid === 'Y'
						: true;
					//if (e.isDirty && isPOValid && Level2KeyValid(e) && Level3KeyValid(e) && CostCodesValid(e) && dtlmsgs[e.seqId] &&
					//	(dtlmsgs[e.seqId].type == '1' || dtlmsgs[e.seqId].type == '3')) {
					if (/*e.isDirty && isPOValid &&*/Level2KeyValid(e) && Level3KeyValid(e) && CostCodesValid(e) && dtlmsgs[e.seqId] &&
						(dtlmsgs[e.seqId].type == '1' || dtlmsgs[e.seqId].type == '3')) {
						if (parseFloat(e.ioInvoiceAmount || 0) !== 0) {
							//partialErrors.push(`- ${dtlmsgs[e.seqId] ? dtlmsgs[e.seqId].errorMsg : ''} at line #${i + 1}`);
							errorCount++;
						}
					}
				}

			})

			if (errorCount <= 0) {
				partialErrors = [...backErrors, ...dateErrors.errorList];
			} else {
				partialErrors = [...backErrors, ...dateErrors.errorList, detailsMessage];
			}
		}
		else if (!chkAllValid && props.info.modelDefId === 3) {
			if (stringIsNullOrEmpty(state.invoiceDocument?.totalSpot) || state?.invoiceDocument?.totalSpot == 0) {
				partialErrors.push(`- Total Spot is invalid`);
			}
			if (stringIsNullOrEmpty(broadCastInvoiceTotal) || broadCastInvoiceTotal == 0) {
				partialErrors.push(`- Invoice Total is invalid`);
			}
			if (stringIsNullOrEmpty(state.invoiceDocument?.broadcastType)) {
				partialErrors.push(`- Media Type is invalid`);
			}
			if (stringIsNullOrEmpty(state.invoiceDocument?.callLetters)) {
				partialErrors.push(`- Call Letters is invalid`);
			}
			if (stringIsNullOrEmpty(state.invoiceDocument?.band)) {
				partialErrors.push(`- Band is invalid`);
			}
			const isClientSelected = state.invoiceDocument?.clientCode && state.invoiceDocument?.clientCode.trim() !== "";
			if (props.info.modelDefId === 3 && !isClientSelected) {
				if (state.invoiceDocument?.requiresClientCode === 2) {
					partialErrors.push("- Please select a Client");
				}
			}
			partialErrors = [...backErrors, ...partialErrors];
		}


		if (partialErrors.length <= 0) {
			errors = [...backErrors];
			if ((props.info.modelDefId === 2 && !_isPOCodeValid) && chkAllValid) {
				errors.push(`- PO Code is required`);
			}
			if ((stringIsNullOrEmpty(state.invoiceDocument?.invoiceDateString) || !datesValidation.invoiceDateString)
				&& chkAllValid) {
				if (stringIsNullOrEmpty(state.invoiceDocument?.invoiceDateString)) {
					errors.push(`- Invoice Date is required`);
				} else {
					errors.push(`- Invoice Date is invalid`);
				}
			}
			if (!_isDueDateValid || !datesValidation.dueDateString) {
				if (chkAllValid) {
					if (stringIsNullOrEmpty(state.invoiceDocument?.dueDateString))
						errors.push(`- Due Date is required`);
					else {
						errors.push(`- Due Date is invalid`);
					}
				}

				else {
					if ((!stringIsNullOrEmpty(state.invoiceDocument?.dueDateString) && !datesValidation.dueDateString)
						|| (!stringIsNullOrEmpty(state.invoiceDocument?.dueDateString) && !stringIsNullOrEmpty(state.invoiceDocument?.invoiceDateString)))
						errors.push(`- Due Date is invalid`);
				}
			}
			if ((stringIsNullOrEmpty(state.invoiceDocument?.glDate) || !datesValidation.glDateString) && chkAllValid) {
				if (stringIsNullOrEmpty(state.invoiceDocument?.glDate)) {
					errors.push(`- GL Date is required`);
				} else {
					errors.push(`- GL Date is invalid`);
				}
			}
			if (stringIsNullOrEmpty(state.invoiceDocument?.paymentTermCode) && chkAllValid) {
				errors.push(`- Payment Term is required`);
			}
			if ((((props.info.modelDefId !== 2) && !ServiceTermStartValid()) && chkAllValid)
			) {
				let messagepart = props.info.modelDefId === 1 ? 'Service Term Start' : 'Start Date';
				if (stringIsNullOrEmpty(state.invoiceDocument?.serviceTermStartDateString))
					errors.push(`- ${messagepart} is required`);
				else {
					errors.push(`- ${messagepart} is invalid`);
				}
			}
			if (((props.info.modelDefId !== 2) && !ServiceTermEndValid())
				|| (props.info.modelDefId !== 2 && !datesValidation.serviceTermEndDateString)) {

				let messagepart = props.info.modelDefId === 1 ? 'Service Term End' : 'End Date';
				if (stringIsNullOrEmpty(state.invoiceDocument?.serviceTermEndDateString))
					errors.push(`- ${messagepart} is required`);
				else {
					errors.push(`- ${messagepart} is invalid`);
				}
			}

			if (stringIsNullOrEmpty(state.invoiceDocument?.currencyCode) && chkAllValid) {
				errors.push(`- Currency Code is required`);
			}
			if (props.info.modelDefId === 3 && (stringIsNullOrEmpty(state.invoiceDocument?.totalSpot) || state?.invoiceDocument?.totalSpot == 0 && chkAllValid)) {
				partialErrors.push(`- Total Spot is invalid`);
			}
			if (props.info.modelDefId === 3 && (stringIsNullOrEmpty(broadCastInvoiceTotal) || broadCastInvoiceTotal == 0 && chkAllValid)) {
				partialErrors.push(`- Invoice Total is invalid`);
			}
			if (props.info.modelDefId !== 3 && (details?.length || 0) == 0 && chkAllValid) {
				detailErrors.push(`- Detail Lines are required`);
			}
			if (props.info.modelDefId === 3 && stringIsNullOrEmpty(state.invoiceDocument?.broadcastType) && chkAllValid) {
				partialErrors.push(`- Media Type is invalid`);
			}
			if (props.info.modelDefId === 3 && stringIsNullOrEmpty(state.invoiceDocument?.callLetters) && chkAllValid) {
				partialErrors.push(`- Call Letters is invalid`);
			}
			if (props.info.modelDefId === 3 && stringIsNullOrEmpty(state.invoiceDocument?.band) && chkAllValid) {
				partialErrors.push(`- Band is invalid`);
			}
			const isClientSelected = state.invoiceDocument?.clientCode && state.invoiceDocument?.clientCode.trim() !== "";
			if (props.info.modelDefId === 3 && !isClientSelected) {
				if (state.invoiceDocument?.requiresClientCode === 2) {
					partialErrors.push("- Please select a Client");
				}
			} else {
				if (props.info.modelDefId !== 3) {
					let errorCount = 0;
					if (chkAllValid && !skipDetailErrors) {
						details?.forEach((e, i) => {
							if (props.info.modelDefId === 1) {
								if (!IONumberValid(e)) {
									detailErrors.push(`- IO Number is invalid at line #${i + 1}`);
								}
							}
							//CostCodesValid Level3KeyValid Level2KeyValid
							if (props.info.modelDefId === 2) {
								if (!Level2KeyValid(e)) {
									detailErrors.push(`- Project is invalid at line #${i + 1}`);
								}
								if (!Level3KeyValid(e)) {
									detailErrors.push(`- Activity is invalid at line #${i + 1}`);
								}
								if (!CostCodesValid(e)) {
									detailErrors.push(`- Expense Type is invalid at line #${i + 1}`);
								}
							}
							if (!InvoiceAmountValid(e)) {
								if (errorRecordList.size <= 0) {
									let amounttext = props.info.modelDefId === 1 ? 'invoice net amount' : 'amount';
									detailErrors.push(`- The ${amounttext} exceeds the remaining amount at line #${i + 1}`);
								}
							}
							if (errorRecordList.has(e.seqId)) {
								errorCount++;
								//detailErrors.push(`- ` + (dtlmsgs[e.seqId] ? dtlmsgs[e.seqId].errorMsg : '') + ` at line #${i + 1}`);
							}

						})
						if (errorCount > 0) {
							detailErrors.unshift(detailsMessage);
						}
					}
				}
			}
		}
		let aggregateErrors = [];
		aggregateErrors = [...errors, ...partialErrors, ...detailErrors];
		if (aggregateErrors.length <= 0 && details.length <= 0) {
			aggregateErrors.push(`- Detail Lines are required`);
		}
		const headerMessage = 'The invoice encountered the following errors';
		if (aggregateErrors.length > 0) {
			aggregateErrors.unshift(headerMessage);
		}
		return {
			errorList: aggregateErrors,
			errors: aggregateErrors.length > 0,
			isStopable: partialErrors.length > 0
		}
	}

	const checkAllDateValues = () => {
		let errors = [];
		if (!stringIsNullOrEmpty(state.invoiceDocument?.invoiceDateString) && !datesValidation.invoiceDateString) {
			errors.push('- Invoice date is invalid');
		}
		if (!stringIsNullOrEmpty(state.invoiceDocument?.glDate) && !datesValidation.glDateString) {
			errors.push('- GL date is invalid');
		}
		if (!stringIsNullOrEmpty(state.invoiceDocument?.dueDateString) && !datesValidation.dueDateString) {
			errors.push('- Due date is invalid');
		}
		if (!stringIsNullOrEmpty(state.invoiceDocument?.serviceTermStartDateString) && !datesValidation.serviceTermStartDateString) {
			errors.push('- Service term start date is invalid');
		}
		if (!stringIsNullOrEmpty(state.invoiceDocument?.serviceTermEndDateString) && !datesValidation.serviceTermEndDateString) {
			errors.push('- Service term end date is invalid');
		}
		return {
			isInvalid: errors.length > 0,
			errorList: errors
		};
	}

	//#endregion Validations

	//#region APICalls


	const postToErp_clickHandler = async () => {
		if (hasChanges()) {
			setPendingPostAction("post");
			setOpenResetAndPostDialog(true);
			return;
		}
		await doPostFlowWithOptionalRescan("post");

	};

	const repostToErp_clickHandler = async () => {
		if (hasChanges()) {
			setPendingPostAction("repost");
			setOpenResetAndPostDialog(true);
			return;
		}
		await doPostFlowWithOptionalRescan("repost");


	};



	// Partial Posting workflow (VIEW variant):
	// - Save uses operation=1
	// - Save & Repost uses operation=2
	const savePartialCore = async (operation) => {
		if (!isPartialPostRequested) return;
		if (!state.isDirty) return;


		if (IsSaveDisabled()) {
			toast.error("Error : Invalid Io Number or Invalid Amount.");
			return;
		}

		props.info.inProgress(true);
		try {
			const modelDefId = props?.info?.modelDefId;

			const logs = (partialSelectedRows || [])
				.map(row => {
					const key = String(row.intInvoiceNumber ?? '');
					const moInfo = partialPostSeqIdsMap?.get(key);
					if (!moInfo) return null;
					if (Number(moInfo.posted) === 1) return null; // never mutate posted groups
					return {
						intInvoiceNumber: key,
						invoiceDocumentId: _invoiceDocument.invoiceDocumentId,
						seqIds: (moInfo?.seqIds || []).map(String).join(',')
					};
				})
				.filter(Boolean);

			const request = {
				logs: logs,
				invoiceDocumentId: _invoiceDocument.invoiceDocumentId,
				operation: Number(operation) || 1,
				invoiceDocumentEditorDetails: (state?.invoiceDocument?.invoiceDocumentEditorDetails || []),
				headerComments: state?.invoiceDocument?.headerComments || ''
			};

			await httpPost(`/api/invoicedocument/repostmediaoceaninvoice/${modelDefId}`, request);

			toast.success(operation === 2 ? 'Save & repost successful' : 'Save successful');

			close_clickHandler_wrapper({
				wasUpdated: true,
				responseObject: { requiresReload: true },
				invoiceDocumentIdOverride: state.invoiceDocument?.invoiceDocumentId
			});
		} catch (e) {
			toast.error(operation === 2 ? 'Repost failed' : 'Save failed');
		} finally {
			props.info.inProgress(false);
		}
	};

	const savePartial_clickHandler = async () => {
		await savePartialCore(1);
	};

	const saveAndRepostPartial_clickHandler = async () => {
		await savePartialCore(2);
	};


	const postCreditMemo = async () => {
		props.info.inProgress(true);
		try {

			let url = "/api/invoicedocument/postcreditmemo/";
			if (shouldOfferRescanAfterPostPrompt) {
				url += "?isSync=true";
			}
			await httpPost(url, [state.invoiceDocument?.invoiceDocumentId]);
			toast.success('Invoice(s) post request sent');
			return true;
		}
		catch (e) {
			toast.error('Invoice(s) posting failed');
			return false;
		} finally {
			props.info.inProgress(false);
		}
	}
	const creditMemoMarkAsPosted_clickHandler = async () => {


		try {
			//let wantsRescan = false;

			//// Show rescan dialog just like normal post flow
			//if (shouldOfferRescanAfterPostPrompt) {
			//	const choice = await promptRescanAfterPost();

			//	// User cancelled
			//	if (choice === null) {
			//		props.info.inProgress(false);
			//		return;
			//	}

			//	wantsRescan = Boolean(choice);
			//}
			props.info.inProgress(true);
			// First mark credit memo as posted
			await httpPost(
				'/api/invoicedocument/creditmemomarkasposted',
				state.invoiceDocument?.invoiceDocumentId
			);

			toast.success('Credit memo marked as posted');

			//// If user selected rescan, trigger AFTER successful post
			//if (wantsRescan) {
			//	await triggerRescanOriginalInvoice();
			//}

			// Close exactly like normal post flow
			close_clickHandler_wrapper({
				wasUpdated: true,
				invoiceDocumentIdOverride: state.invoiceDocument?.invoiceDocumentId,
				responseObject: { requiresReload: true },
				isAvailableForRescaning: shouldOfferRescanAfterPostPrompt,
				applyToInvoiceDocumentId: state.invoiceDocument?.applyToInvoiceDocumentId
			});

		} catch (e) {
			toast.error('Failed to mark credit memo as posted');
		} finally {
			props.info.inProgress(false);
		}
	};


	// ==============================
	// Rescan (re-queue for scanning)
	// ==============================
	const isCreditMemoInvoice = React.useMemo(() => {
		return (
			Number(state?.invoiceDocument?.invoiceIndicator || 0) === 2 ||
			Number(state?.invoiceDocument?.applyToInvoiceDocumentId || 0) > 0 ||
			mode === Constants.CREDIT_MEMO
		);
	}, [state?.invoiceDocument?.invoiceIndicator, state?.invoiceDocument?.applyToInvoiceDocumentId, mode]);

	const shouldOfferRescanAfterPostPrompt = React.useMemo(() => {
		// Offer prompt only when it's a credit memo and hasn't been rescanned yet.
		// Posted/internal-posted becomes true after a successful post.
		return isCreditMemoInvoice;
	}, [isCreditMemoInvoice]);

	const getRescanRequest = () => {
		const modelDefId = Number(state?.invoiceDocument?.modelDefId || props?.info?.modelDefId || 0);
		const companyCode =
			Number(state?.invoiceDocument?.companyCode || 0) ||
			Number(props?.info?.companyCode || props?.info?.rowData?.companyCode || 0);
		const applyToInvoiceDocumentId = Number(
			state?.invoiceDocument?.applyToInvoiceDocumentId ||
			0
		);
		return { modelDefId, companyCode, applyToInvoiceDocumentId };
	};

	const triggerRescanOriginalInvoice = async () => {
		try {
			props.info.inProgress(true);
			await rescanOriginalInvoice(getRescanRequest());
			toast.success('Invoice sent for rescan');

			// Hide the button immediately without forcing a refetch
			setState((prev) => ({
				...prev,
				invoiceDocument: { ...prev.invoiceDocument, isRescanned: true }
			}));
			return true;
		} catch (e) {
			toast.error('Failed to initiate rescan');
			return false;
		} finally {
			props.info.inProgress(false);
		}
	};

	const promptRescanAfterPost = () => {
		return new Promise((resolve) => {
			rescanAfterPostResolverRef.current = resolve; // resolves: true | false | null
			setOpenRescanAfterPostDialog(true);
		});
	};

	const doPostFlowWithOptionalRescan = async (action /* 'post' | 'repost' */) => {
		let wantsRescan = false;

		//try {
		//	if (shouldOfferRescanAfterPostPrompt) {
		//		const choice = await promptRescanAfterPost();
		//		if (choice === null) return; // user cancelled
		//		wantsRescan = Boolean(choice);
		//	}
		//} catch (err) {
		//	toast.error("Prompt failed:", err);
		//	return;
		//}

		// -----------------------
		// 1️⃣ POSTING (API A)
		// -----------------------
		let ok = false;
		const postBroadcastCreditMemo = props?.info?.modelDefId === 3;

		try {
			if (postBroadcastCreditMemo) {
				ok = await postCreditMemo({ deferClose: wantsRescan });
			} else {
				ok = await doPostToErp(action, { deferClose: wantsRescan });
			}
		} catch (postError) {
			toast.error("Posting failed:", postError);
			// showError("Posting failed.");
			return;
		}

		if (!ok) return;

		// Finalize flow
		closeAfterPost({ isAvailableForRescaning: shouldOfferRescanAfterPostPrompt });
	};


	const closeAfterPost = ({ isAvailableForRescaning = false }) => {
		props.onClose?.({
			wasUpdate: true,
			invoiceDocumentId: state.invoiceDocument?.invoiceDocumentId,
			responseObject: { requiresReload: true },
			isAvailableForRescaning: isAvailableForRescaning,
			applyToInvoiceDocumentId: state.invoiceDocument?.applyToInvoiceDocumentId
		});
	};

	const doPostToErp = async (action /* "post" | "repost" */, options = {}) => {
		const { deferClose = false } = options || {};
		try {
			props.info.inProgress(true);

			let url = "/api/adapter/postinvoices/";
			if (shouldOfferRescanAfterPostPrompt) {
				url += "?isSync=true";
			}
			await httpPost(url, [state.invoiceDocument?.invoiceDocumentId]);

			toast.success(action === "post" ? "Invoice posted to ERP successfully" : "Invoice reposted successfully");
			//if (!deferClose) {
			//	closeAfterPost();
			//}
			return true;
		} catch (e) {
			toast.error(action === "post" ? "Post to ERP failed" : "Repost failed");
			return false;
		} finally {
			props.info.inProgress(false);
		}
	};


	const verifyProductionInvoiceDocumentDetails = React.useCallback((taxToApplyAfterVerify) => {
		if (state?.invoiceDocument?.invoiceDocumentEditorDetails.length === 0) {
			return;
		}
		props.info.inProgress(true);
		let invoiceDocument = structuredClone(state.invoiceDocument);
		invoiceDocument.invoiceDocumentEditorDetails = state?.invoiceDocument?.invoiceDocumentEditorDetails;
		httpPost("/api/invoicedocument/verifyproductioninvoicedocumenteditor/", invoiceDocument)
			.then((response) => {
				var data = response.data;
				editorGridRef.current.setInvoiceDetailsOnVendorChange(state.invoiceDocument, data);
				// Apply tax after re-verification so it is not overwritten by setInvoiceDetailsOnVendorChange.
				if (taxToApplyAfterVerify !== undefined) {
					applyTaxCodeToAllLines(taxToApplyAfterVerify);
				}
				props.info.inProgress(false);
			}).catch((error) => {
				props.info.inProgress(false);
				toast.error('Verification of invoice details failed');
			});
	})

	const fetchInvoiceDocument = useCallback(async () => {
		var modelDefId = props.info.modelDefId;
		var invoiceModel = props.info.invoiceModel;
		var uri;

		if (invoiceModel) {
			uri = "/api/invoicemodels/invoicemodeleditor/" + modelDefId + "/" + invoiceModel.masterDocumentModelId + "/sample?invoiceDocumentFileLocation=" + encodeURIComponent(invoiceModel.invoiceDocumentSampleFileLocation);
		} else {
			uri = "/api/invoicedocument/invoicedocumenteditor/" + modelDefId + "/" + (props.info.rowData ? props.info.rowData.invoiceDocumentId : "0");
			if (props?.info?.companyCode) {
				uri += "?companyCode=" + encodeURIComponent(props.info.companyCode);
			}
		}

		props.info.inProgress(true);

		try {
			const response = await httpGet(uri);
			const invoiceDocument = response.data;
			const orignalinvoicedocumnetstatus = invoiceDocument?.invoiceDocumentStatusId;
			const invoiceIndicator = invoiceDocument?.invoiceIndicator;

			if (originalInvoiceStatusIdRef.current === null) {
				originalInvoiceStatusIdRef.current = orignalinvoicedocumnetstatus;
			}
			const approvalText = invoiceDocument?.approvalLinkText || '';

			// ✅ Mode + abilities are derived on the UI.
			// Backend returns only server-truth facts (IsAdmin / IsDifferentCompany / RoutingNumberOfApprovalLevels).
			const isListLikeSource =
				props?.info?.editorSource === Constants.INVOICE_LIST_SOURCE ||
				props?.info?.editorSource === Constants.SOURCE_DASHBOARD_GADGET ||
				props?.info?.editorSource === Constants.SOURCE_INVOICE_REPORT;

			const serverIsAdmin = invoiceDocument?.isAdmin ?? userInfo?.selectedUserRoles?.isAdmin ?? false;
			const isDifferentCompany = invoiceDocument?.isDifferentCompany ?? false;
			const routingLevels =
				invoiceDocument?.routingNumberOfApprovalLevels ??
				invoiceDocument?.companyApprovalConfiguration?.routingNumberOfApprovalLevels ??
				0;

			// Derive workflow mode from status by default.
			// For non list/report entry points (test, replace, user-entry, etc.), caller decides the mode when provided.
			const workflowMode = resolveWorkflowMode(invoiceDocument, routingLevels, isDifferentCompany);
			let derivedMode = workflowMode;
			if (!isListLikeSource && props?.info?.mode) {
				// For non list-like entry points, caller decides the mode.
				derivedMode = props.info.mode;
			}

			// Partial posting editor is a VIEW-variant mode.
			// It must be honored even when opened from list-like sources.
			if (isPartialPostRequested) {
				derivedMode = PARTIAL_POST_MODE;

				let details = invoiceDocument?.invoiceDocumentEditorDetails;
				let newMap = new Map();

				const parseSeqIds = (seqIds) => {
					if (!seqIds) return [];
					if (Array.isArray(seqIds)) return seqIds.map(String);
					return String(seqIds)
						.split(',')
						.map(s => s.trim())
						.filter(Boolean);
				};

				if (partialSelectedRows?.length) {
					partialSelectedRows.forEach((row) => {
						const orders = Array.isArray(row?.orderIds) ? row.orderIds : [];
						let seqIds = parseSeqIds(row?.seqIds);

						// Backwards-compat fallback (older dialog payloads): derive seqIds from details by ioNumber.
						if ((!seqIds || seqIds.length === 0) && details?.length && orders?.length) {
							seqIds = details.filter(e => orders.indexOf(e.ioNumber) !== -1).map(e => e.seqId);
						}

						newMap.set(row.intInvoiceNumber, {
							orderIds: orders,
							seqIds: seqIds,
							posted: row.posted
						});
					});
					setPartialPostSeqIdsMap(newMap);
				}
			}

			// Enforce view-only rule for ModelDef 3 source invoices even if a caller tries to force a mode.
			if (Number(invoiceDocument?.modelDefId) === 3 && Number(invoiceDocument?.invoiceSource) === 1) {
				derivedMode = Constants.VIEW;
			}

			const resolvedCaps = isListLikeSource
				? resolveWorkflowCapabilities(invoiceDocument, {
					isAdmin: serverIsAdmin,
					routingNumberOfApprovalLevels: routingLevels,
					isDifferentCompany,
				})
				: {
					canPostToERP: false,
					canRepostToERP: false,
					canOverride: false,
					canEditDates: false,
					hasDifferentCompany: isDifferentCompany,
					canPostCreditMemo: false,
					canDelete: false
				};

			let {
				canPostToERP,
				canRepostToERP,
				canOverride,
				canEditDates,
				hasDifferentCompany,
				canPostCreditMemo,
				canDelete
			} = resolvedCaps;

			// Repost rule is required for any repost actions (both partial + full repost)
			const repostRuleEditable = isRepostRuleEditable(
				invoiceDocument?.userGroupRules,
				invoiceDocument?.modelDefId ?? props.info.modelDefId
			);

			const creditMemoPost = isCreditMemoPostEnabled(
				invoiceDocument?.userGroupRules,
				invoiceDocument?.modelDefId ?? props.info.modelDefId
			)

			// Derive partial-post / repost eligibility directly from invoiceDocument (editor truth)
			const derivedPartialInvoiceStatus = derivePartialInvoiceStatus(invoiceDocument, repostRuleEditable);

			// Gate BOTH repost buttons with the same rule
			const isCreditMemo = invoiceIndicator === 2;

			canRepostToERP = !isCreditMemo && Boolean((canRepostToERP) && repostRuleEditable);
			canPostToERP = !isCreditMemo && Boolean((canPostToERP) && repostRuleEditable);

			canPostCreditMemo = (creditMemoPost && canPostCreditMemo);





			setInvoiceDocumentStatusId(orignalinvoicedocumnetstatus);
			setInvoiceIndicator(invoiceIndicator);
			setGroupRules(invoiceDocument.userGroupRules || []);
			if (props.info.isViaQueryString) {
				if (derivedMode !== Constants.USER_ENTRY && props.info.rowData.invoiceDocumentId > 0) {
					if (invoiceDocument.invoiceDocumentId === 0) {
						throw new Error('Invoice Document not found');
					}
					else if (derivedMode === Constants.APPROVAL &&
						!(invoiceDocument.invoiceDocumentStatusId === 50 ||
							invoiceDocument.invoiceDocumentStatusId === 70 ||
							invoiceDocument.invoiceDocumentStatusId === 90 ||
							invoiceDocument.invoiceDocumentStatusId === 100 ||
							invoiceDocument.invoiceDocumentStatusId === 110 ||
							invoiceDocument.invoiceDocumentStatusId === 120 ||
							invoiceDocument.invoiceDocumentStatusId === 130 ||
							invoiceDocument.invoiceDocumentStatusId === 140 ||
							invoiceDocument.invoiceDocumentStatusId === 160)
					) {
						throw new Error('Invoice has been processed or status has changed');
					}
					else if ((derivedMode === Constants.MAKE_CORRECTIONS || derivedMode === "ManualEntry") &&
						!(invoiceDocument.invoiceDocumentStatusId <= 40 ||
							invoiceDocument.invoiceDocumentStatusId === 50 ||
							invoiceDocument.invoiceDocumentStatusId === 60 ||
							invoiceDocument.invoiceDocumentStatusId === 80 ||
							invoiceDocument.invoiceDocumentStatusId === 100 ||
							invoiceDocument.invoiceDocumentStatusId === 120 ||
							invoiceDocument.invoiceDocumentStatusId === 140 ||
							invoiceDocument.invoiceDocumentStatusId === 160 ||
							invoiceDocument.invoiceDocumentStatusId === 180)
					) {
						throw new Error('Invoice has been processed or status has changed');
					}
					else if (derivedMode !== "View" && (!isNaN(props.info.rowData.invoiceDocumentStatusId) || props.info.rowData.invoiceDocumentStatusId !== 0) && props.info.rowData.invoiceDocumentStatusId !== invoiceDocument.invoiceDocumentStatusId) {
						throw new Error('Invoice has been processed or status has changed');
					}
				}
			}
			var title = getTitle(derivedMode);
			var readOnly = derivedMode === Constants.VIEW || derivedMode === Constants.APPROVAL
				|| derivedMode === PARTIAL_POST_MODE
				|| derivedMode === Constants.TEST || derivedMode === Constants.EDIT_DATES || derivedMode === Constants.REPLACE
				|| derivedMode === Constants.CREDIT_MEMO || derivedMode === Constants.ARCHIVE;
			var serviceTermStartDate = invoiceDocument.serviceTermStartDate;
			var serviceTermEndDate = invoiceDocument.serviceTermEndDate;
			if (derivedMode === Constants.USER_ENTRY || derivedMode === Constants.REPLACE) {
				invoiceDocument.invoiceDocumentStatusAttribute = "M";
				invoiceDocument.vendorCode = "";
				invoiceDocument.vendor = "";
				invoiceDocument.siteId = "";
				invoiceDocument.documentModelName = "";
				invoiceDocument.documentModelNameTag = "";
				invoiceDocument.invoiceNumber = "";
				invoiceDocument.invoiceDateString = "";
				invoiceDocument.dueDateString = "";
				invoiceDocument.serviceTermStartDateString = "";
				invoiceDocument.serviceTermEndDateString = "";
				invoiceDocument.paymentTermCode = "";
				invoiceDocument.currencyCode = "";
				invoiceDocument.createDateString = "";
				if (derivedMode === Constants.REPLACE) {
					invoiceDocument.invoiceDocumentId = props.info.invoiceDocumentId;
				}
			} else if (derivedMode === "ManualEntry") {
				invoiceDocument.invoiceDocumentStatusId = 50;
				invoiceDocument.invoiceDocumentStatusAttribute = "M";
			} else if (derivedMode === Constants.MAKE_CORRECTIONS) {
				if (invoiceDocument.invoiceDocumentStatusId === 80 ||
					invoiceDocument.invoiceDocumentStatusId === 100 ||
					invoiceDocument.invoiceDocumentStatusId === 120 ||
					invoiceDocument.invoiceDocumentStatusId === 140 ||
					invoiceDocument.invoiceDocumentStatusId === 160) {
					invoiceDocument.invoiceDocumentStatusId = (invoiceDocument.invoiceDocumentStatusId - 30);
				}
				else {
					invoiceDocument.invoiceDocumentStatusId = 50;
				}
				invoiceDocument?.invoiceDocumentEditorDetails?.forEach((e, i) => {
					if (e.lineStatus > 50 && e.lineStatus % 20 === 0) {

					}
				})
				invoiceDocument.invoiceDocumentStatusAttribute = "C";
			} else if (derivedMode === Constants.APPROVAL) {
				title = invoiceDocument.title;
				readOnly = !invoiceDocument.allowInvoiceEditing;

				if (invoiceDocument.invoiceDocumentStatusId === 100 ||
					invoiceDocument.invoiceDocumentStatusId === 120 ||
					invoiceDocument.invoiceDocumentStatusId === 140 ||
					invoiceDocument.invoiceDocumentStatusId === 160) {
					invoiceDocument.invoiceDocumentStatusId = (invoiceDocument.invoiceDocumentStatusId - 50);
				}
				else if (invoiceDocument.invoiceDocumentStatusId === 80) {
					invoiceDocument.invoiceDocumentStatusId = 50;
				}

				invoiceDocument.invoiceDocumentStatusAttribute = "C";
			}
			if (invoiceDocument.masterDocumentModelId === 0) {
				invoiceDocument.masterDocumentModelId = null;
			}
			if (invoiceModel) {
				if (stringIsNullOrEmpty(invoiceDocument.vendor) || stringIsNullOrEmpty(invoiceDocument.siteId)) {
					invoiceDocument.vendor = invoiceModel.vendor;
					invoiceDocument.siteId = invoiceModel.siteId;
				}
				invoiceDocument.documentModelName = invoiceModel.modelName;
				invoiceDocument.documentModelNameTag = invoiceModel.modelTag;
			}
			var taxes = [];
			if (invoiceDocument.taxes) {
				invoiceDocument.taxes.forEach(t => {
					if (taxes.find(tt => tt.taxCode === t.taxCode) == null) {
						taxes.push({ taxCode: t.taxCode, taxDesc: t.taxDesc });
					}
				});
			}
			props.info.inProgress(false);
			if (invoiceDocument?.invoiceDocumentEditorDetails?.length > 0) {
				invoiceDocument.invoiceDocumentEditorDetails = invoiceDocument?.invoiceDocumentEditorDetails?.map(e => {
					return {
						...e,
						isDirty: false
					};
				})
			}
			invoiceDocument?.invoiceDocumentEditorDetails?.forEach((e, i) => {
				e.isTaxManuallyChanged = getCalculatedTax((invoiceDocument.taxes || []), e.taxCode, e) !== e.taxAmount;
			})
			setTitle(title);
			setDateValidations(invoiceDocument);
			setState((prev) => ({
				...prev, invoiceDocument: invoiceDocument,
				taxes: taxes/*, title: title*/, readOnly: readOnly || invoiceDocument.archived || hasDifferentCompany,
				serviceTermStartDate: serviceTermStartDate,
				serviceTermEndDate: serviceTermEndDate,
				isInvoiceNumberDuplicate: (invoiceDocument.duplicateInvoiceFlag === 'Y'),
				originalInvoiceDocumentStatus: orignalinvoicedocumnetstatus,
				invoiceDocumentImage: structuredClone(invoiceDocument),
				isDirty: false,
				mode: derivedMode,
				partialInvoiceStatus: derivedPartialInvoiceStatus,
				capabilities: {
					...prev.capabilities,
					// legacy keys (kept for safe rollout)
					canEditInvoice: (canEditDates || canOverride),
					canPostToERP: canPostToERP,
					canRepostToERP: canRepostToERP,
					canOverride: canOverride,
					canEditDates: canEditDates,
					hasDifferentCompany: hasDifferentCompany,
					canDelete: canDelete,
					canPostCreditMemo: canPostCreditMemo
				}
			}));

			calculateAndSetTotals(invoiceDocument);
			var _firstLineTaxCode = invoiceDocument?.invoiceDocumentEditorDetails[0]?.taxCode;
			setBroadCastTaxCode(_firstLineTaxCode);
			setInitialInvoiceDocument(structuredClone(invoiceDocument));
			setAllowDiscrepentTax(invoiceDocument?.allowTaxDiscrepent === 'N' ? false : true);
			setIsDataLoaded(true);
			props.info.inProgress(false);
			return { ...invoiceDocument, invoiceDocumentStatusId: orignalinvoicedocumnetstatus };

		} catch (error) {
			props.info.inProgress(false);
			toast.error(stringIsNullOrEmpty(error.message) ? 'Error fetching invoice document' : error.message);
			return null;
		}
	}, []);



	const fetchInvoiceDocumentByFileName = useCallback((invoiceDocumentFileLocation) => {
		const byFileUri =
			"/api/invoicedocument/invoicedocumenteditorbyfilename?invoiceDocumentFileLocation=" +
			encodeURIComponent(invoiceDocumentFileLocation) +
			(props?.info?.companyCode ? ("&companyCode=" + encodeURIComponent(props.info.companyCode)) : "");

		httpGet(byFileUri)
			.then((response) => {
				var invoiceDocument = response.data;
				if (invoiceDocument.invoiceDocumentId > 0) {
					setState((prev) => ({ ...prev, invoiceDocument: invoiceDocument, replacedInvoiceDocument: invoiceDocument, fetchInterval: null, inProgress: false }));
					clearInterval(state.fetchInterval);
					props.info.inProgress(false);
				}
				else {
					setState((prev) => ({ ...prev, inProgress: false }));
				}
			}).catch((error) => {
				props.info.inProgress(false);
				toast.error('Error fetching replaced invoice document');
				close_clickHandler();
			});
	})

	const fetchCompanyList = useCallback(() => {
		const uri = `/api/invoicedocument/companyList?resourceId=${encodeURIComponent(resourceId)}`;

		httpGet(uri)
			.then((response) => {
				const companyData = response.data;
				setCompanyList(companyData);

				const initialCompany = companyData.find(
					(company) => company.companyCode === state.invoiceDocument?.companyCode
				);
				setSelectedCompany(initialCompany);
			})
			.catch((error) => {
				toast.error('Error fetching company list');
			});
	}, [state.invoiceDocument?.companyCode]);
	const tryFetchingInvoiceDocument = useCallback(() => {
		if (!state.replacedInvoiceDocument && !state.inProgress) {
			setState((prev) => ({ ...prev, inProgress: true }));
			fetchInvoiceDocumentByFileName(state.invoiceDocument?.invoiceDocumentFileLocation);
		}
	})
	const fileUpload_changeHandler = (event) => {
		const formData = new FormData();
		const fileOriginal = event.target.files[0];
		if (!checkMimeType(event) || !checkFileSize(event)) {
			event.target.value = null
			return;
		}
		if (fileOriginal) {
			var filename = fileOriginal.name.replace(/[^\w\.]/gi, '');
			var file = new File([fileOriginal], filename, { type: fileOriginal.type });
			formData.append(0, file);
			setState({ ...state, selectedFile: file, documentContentType: file.type });
			var url = "/api/invoicedocument/";
			if (mode === "Replace") {
				url += "replace";
				formData.append("invoiceDocumentId", state.invoiceDocument?.invoiceDocumentId)
			}
			else {
				url += "upload";
			}
			formData.append("modelDefId", state.invoiceDocument?.modelDefId);
			const token = localStorage.token;
			const headers = {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${token}`
			}
			props.info.inProgress(true, false, 0);
			httpPost(url, formData, {
				headers: headers,
				onUploadProgress: ProgressEvent => {
					props.info.inProgress(true, true, (ProgressEvent.loaded / ProgressEvent.total * 100));
				},
			}).then((response) => {
				var invoiceDocument = state.invoiceDocument;
				invoiceDocument.invoiceDocumentFileLocation = response.data.invoiceDocumentFileLocation;
				invoiceDocument.fileName = response.data.fileName;
				invoiceDocument.createDateString = response.data.createDateString;
				setTimeout(function () {
					setState({ ...state, invoiceDocument: invoiceDocument });
					props.info.inProgress(false, false, 0);
					toast.success('Uploaded Successfully');
					if (mode === Constants.REPLACE) {
						if (state.fetchInterval) {
							clearInterval(state.fetchInterval)
						}
						setState({ ...state, fetchInterval: null });
						props.info.inProgress(false);
						close_clickHandler_wrapper({
							wasUpdated: true,
							responseObject: {
								operation: 'replace',
								invoiceDocumentFileLocation: response?.data?.invoiceDocumentFileLocation || invoiceDocument.invoiceDocumentFileLocation,
								fileName: response?.data?.fileName || invoiceDocument.fileName,
								createDateString: response?.data?.createDateString || invoiceDocument.createDateString,
							}
						});
					}
					else {
						props.info.inProgress(false);
					}
				}, 3000);
			}).catch((error) => {
				toast.error('Upload Failed');
				props.info.inProgress(false, false, 0);
			});
		}
		event.target.value = null;
	}
	const checkMimeType = (event) => {
		//getting file object
		let files = event.target.files
		//define message container
		let err = []
		// list allow mime type
		const types = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf']
		// loop access array
		for (var x = 0; x < files.length; x++) {
			// compare file type find doesn't matach
			if (types.every(type => files[x].type !== type)) {
				// create error message and assign to container   
				err.push(files[x].name + ' of type \'' + files[x].type + '\' is not a supported format');
			}
		};
		if (err.length > 0) { // if message not same old that mean has error
			for (var i = 0; i < err.length; i++) {
				toast.error(err[i]);
			}
			return false;
		}
		return true;
	}
	const checkFileSize = (event) => {
		let files = event.target.files
		var size = 10 * 1024 * 1024; //10 MB size
		let err = "";
		for (var x = 0; x < files.length; x++) {
			if (files[x].size > size) {
				err += files[x].name + ' is too large, please pick a smaller file\n';
			}
		};
		if (err !== '') {
			toast.error(err);
			return false
		}
		return true;
	}
	const replaceFileInfoDialog_clickHandler = (event) => {
		setState((prev) => ({ ...prev, openReplaceFileScanInProgress: false }));
	}
	const invoiceNumber_blurHandler = (event) => {
		var invoiceDocument = state.invoiceDocument;
		if ((invoiceDocument.status || '').toLowerCase() === 'posted') return;
		let cleanedInvoiceNumber = invoiceDocument?.invoiceNumber?.trim();
		if (VendorSelected() && !stringIsNullOrEmpty(cleanedInvoiceNumber)) {
			props.info.inProgress(true);
			httpGet("/api/invoicedocument/validateduplicate/" + parseInt(encodeURIComponent(invoiceDocument.invoiceDocumentId)) + "?vendorCode=" + encodeURIComponent(invoiceDocument.vendorCode) + "&invoiceNumber=" + encodeURIComponent(invoiceDocument.invoiceNumber))
				.then((response) => {

					var isInvoiceNumberDuplicate = response.data;
					props.info.inProgress(false);
					setState((prev) => ({ ...prev, isInvoiceNumberDuplicate: isInvoiceNumberDuplicate, invoiceDocument: { ...prev.invoiceDocument, invoiceNumber: cleanedInvoiceNumber } }));
				}).catch((error) => {
					props.info.inProgress(false);
					toast.error(<div>Delivery Amount update failed<br />{error.response.data}</div>);
				});
		}
		else {
			setState((prev) => ({ ...prev, isInvoiceNumberDuplicate: false, invoiceDocument: { ...prev.invoiceDocument, invoiceNumber: cleanedInvoiceNumber } }));
		}
	}

	//#endregion APICalls



	//#region Event Handler

	// Put near other handler/helper functions in InvoiceDocumentEditor.js

	const hasChanges = () => {
		// include both header/detail changes
		return !!(state.isDirty || state.lineDirty);
	};

	const resetToInitialInvoice = () => {
		if (!initialInvoiceDocument) return;

		const resetDoc = structuredClone(initialInvoiceDocument);

		// Reset UI state to match "no changes"
		setState((prev) => ({
			...prev,
			invoiceDocument: resetDoc,
			isDirty: false,
			lineDirty: false,
		}));

		// Re-run any dependent UI calculations (you already have these utilities in file)
		try {
			setDateValidations(resetDoc);
			calculateAndSetTotals(resetDoc);

			const firstLineTaxCode = resetDoc?.invoiceDocumentEditorDetails?.[0]?.taxCode;
			setBroadCastTaxCode(firstLineTaxCode);
		} catch {
			// keep silent - reset still works even if calc helpers throw
		}
	};

	const editInvoice_clickHandler = () => {
		// Pick which edit type is allowed for the user
		// If both are true, prefer EDIT_DATES (you can flip this priority if you want)
		const modeToEnable =
			buttonCapabilities?.canEditDates
				? Constants.EDIT_DATES
				: (buttonCapabilities?.canOverride ? Constants.OVERRIDE : null);

		if (!modeToEnable) {
			// Should not happen because button is hidden, but keep safe.
			return;
		}

		setPendingEditMode(modeToEnable);
		setOpenMakeEditableDialog(true);
	};


	const uniqueBy = (arr, keyProps) => {
		const kvArray = arr.map(entry => {
			const key = keyProps.map(k => entry[k]).join('|');
			return [key, entry];
		});
		const map = new Map(kvArray);
		return Array.from(map.values());
	}
	const groupAndSum = (arr, groupKeys, sumKeys) => {
		return Object.values(
			arr.reduce((acc, curr) => {
				const group = groupKeys.map(k => curr[k]).join('-');
				acc[group] = acc[group] || Object.fromEntries(groupKeys.map(k => [k, curr[k]]).concat(sumKeys.map(k => [k, 0])));
				sumKeys.forEach(k => acc[group][k] += curr[k]);
				return acc;
			}, {})
		);
	}
	const setVendor = (vendor) => {
		var target = { name: "vendorCode", value: vendor ? vendor.vendorCode : "" };
		input_changeHandler({ target: target, currentTarget: target }, state, setState, setDateValidations);
		target = { name: "shortName", value: vendor ? vendor.shortName : "" };
		input_changeHandler({ target: target, currentTarget: target }, state, setState, setDateValidations);
		const vendorDisplay = vendor ? `${vendor.vendorCode}${vendor.shortName ? " - " + vendor.shortName : ''}` : "";
		target = { name: "vendor", value: vendorDisplay };
		input_changeHandler({ target: target, currentTarget: target }, state, setState, setDateValidations);
		target = { name: "siteId", value: vendor ? vendor.siteId : "" };
		input_changeHandler({ target: target, currentTarget: target }, state, setState, setDateValidations);
		target = { name: "vendorName", value: vendor ? vendor.vendorName : "" };
		input_changeHandler({ target: target, currentTarget: target }, state, setState, setDateValidations);
		if (vendor) {
			target = { name: "currencyCode", value: vendor ? vendor.currencyCode : "" };
			input_changeHandler({ target: target, currentTarget: target }, state, setState, setDateValidations);
		}
		if (vendor && state.invoiceDocument?.modelDefId === 2) {
			var invoiceDocument = state.invoiceDocument;
			invoiceDocument.noPoFlag = vendor.noPoFlag;
			invoiceDocument.isNoPOVendor = vendor.isNoPOVendor;
			invoiceDocument.siteId = vendor.siteId || '';
			invoiceDocument.vendorName = vendor.vendorName || '';
			setState((prev) => ({ ...prev, invoiceDocument: invoiceDocument }));
		}
		invoiceNumber_blurHandler(); //Validate invoice number for this vendor
	}
	const VendorSelected = () => {
		return !(stringIsNullOrEmpty(state.invoiceDocument?.vendor));
	}

	const { clientCodeSource, shouldSelectDetailClient, shouldSelectClient } = (() => {
		const invoiceClientCode = state.invoiceDocument?.clientCode;
		const editorClientCode = state.invoiceDocument?.invoiceDocumentEditorDetails?.every(item => item.isIONumberValid === 'Y')
			? state?.invoiceDocument?.invoiceDocumentEditorDetails[0]?.clientCode
			: "";

		const clientCodeSource = invoiceClientCode || editorClientCode || '';

		const shouldSelectClient = !!invoiceClientCode;
		const shouldSelectDetailClient = editorClientCode ? editorClientCode : "";

		return { clientCodeSource, shouldSelectDetailClient, shouldSelectClient };
	})();


	const getCollapseUncollapseButton = () => {
		return <IconButton
			variant="contained"
			onClick={collapseUncollapse_clickHandler}
			size="small">
			{state.uncollapsed ? <CollapseIcon /> : <UncollapseIcon />}
		</IconButton>;
	}
	const handleDragOver = (event) => {
		event.preventDefault();
		setState((prev) => ({ ...prev, dragging: true }));
	};

	const handleDragLeave = (event) => {
		event.preventDefault();
		setState((prev) => ({ ...prev, dragging: false }));
	};

	const handleDrop = (event) => {
		event.preventDefault();
		setState((prev) => ({ ...prev, dragging: false }));
		const files = event.dataTransfer.files;
		fileUpload_changeHandler({ target: { files } });
	};


	const downloadFile = (fileObject) => {
		if (!state?.invoiceDocument?.fileName)
			return;

		props.info.inProgress(true);

		let invoicedocumentid = (state.invoiceDocument?.invoiceDocumentId !== 0 && state.invoiceDocument?.invoiceDocumentId) || (state.uuid + Temp);

		httpGet(`/api/InvoiceDocument/scannedinvoicedocument/${state.invoiceDocument?.modelDefId}?invoicedocumentid=${encodeURIComponent(invoicedocumentid)}&invoiceDocumentFileLocation=${encodeURIComponent(fileObject.invoiceDocumentFileLocation)}`)
			.then((response) => {
				const url = response.data['documentUrl'];

				if (!url) {
					throw new Error('File URL not found');
				}

				window.open(url, '_blank', 'noopener,noreferrer');

				props.info.inProgress(false);
			})
			.catch((error) => {
				toast.error('Failed to download the file. Please try again later.');
				props.info.inProgress(false);
			});
	};

	const handleChangeCompanyClick = () => {
		setShowDropdown(true);
		setShowChangeCompany(false);
	};

	const handleCompanyChange = (event) => {
		const companyCode = Number(event.target.value);
		const company = companyList.find((company) => company.companyCode === companyCode);

		if (company) {
			setSelectedCompany(company);

			if (companyCode !== state.invoiceDocument?.companyCode) {
				setPendingCompany(company);
				setOpenConfirmationDialog(true);
			} else {
				setPendingCompany(null);
				setOpenConfirmationDialog(false);
			}
		}
	};

	const handleCancelChange = () => {
		setPendingCompany(state.invoiceDocument?.companyCode);
		const initialCompany = companyList.find(
			(company) => company.companyCode === state.invoiceDocument?.companyCode
		);
		setSelectedCompany(initialCompany);
		setOpenConfirmationDialog(false);
		setShowDropdown(false);
		setShowChangeCompany(true);
	};

	const handleConfirmChange = useCallback(() => {
		if (pendingCompany) {
			setSelectedCompany(pendingCompany);
			setOpenConfirmationDialog(false);
			props.info.inProgress(true);
			const uri = `/api/invoicedocument/changeinvoicecompany/${state.invoiceDocument?.invoiceDocumentId}/${props.info.modelDefId}/${pendingCompany.companyCode}`;

			httpPost(uri)
				.then((response) => {
					const data = response.data;

					if (data && data.companyCode && data.invoiceDocumentId) {
						setChangeCompanyData({
							...data,
							isCompanyChanged: true
						});

						// If editor was opened from the invoice list, close and remove the current row from the list.
						if (props?.info?.editorSource === Constants.INVOICE_LIST_SOURCE || props?.info?.editorSource === Constants.SOURCE_INVOICE_REPORT) {
							// Important: turn off the global spinner BEFORE closing (otherwise it can stay stuck)
							props.info.inProgress(false);
							toast.success('Company changed successfully');
							close_clickHandler_wrapper({
								wasUpdated: false,
								responseObject: { operation: 'companyChange', ...data },
								isCompanyChangedOverride: true
							});
							return;
						}

						setOpenSuccessDialog(true);
					} else {
						toast.error("Unexpected error occured");
					}

					props.info.inProgress(false);
				})
				.catch((error) => {
					toast.error('Error Switching Invoice');
					props.info.inProgress(false);
				});
		}
	}, [pendingCompany, state.invoiceDocument?.invoiceDocumentId, props.info.modelDefId]);

	const handleViewInvoice = () => {
		setOpenSuccessDialog(false);
		let basePath = window.location.pathname;

		if (basePath.endsWith('/')) {
			basePath = basePath.slice(0, -1);
		}
		let mode = 'MakeCorrections';
		//if (changeCompanyData.invoiceDocumentStatusId == 50 || changeCompanyData.invoiceDocumentStatusId > 60) {
		//	mode = 'View';
		//}
		if (changeCompanyData.invoiceDocumentStatusId == 10) {
			mode = 'Map Vendor';
		}
		else if (changeCompanyData.invoiceDocumentStatusId > 60) {
			mode = 'Approval';
		}

		const newUrl = `${window.location.origin}${basePath}?companyCode=${changeCompanyData.companyCode}&invoicedocumentid=${changeCompanyData.invoiceDocumentId}&status=${changeCompanyData.invoiceDocumentStatusId}&mode=${encodeURIComponent(mode)}&modeldefid=${state.invoiceDocument?.modelDefId}`;
		window.location.href = newUrl;
	};

	const calculateAndSetTotals = (invoiceDocument) => {
		const taxTotal = invoiceDocument?.invoiceDocumentEditorDetails?.length > 0
			? invoiceDocument.invoiceDocumentEditorDetails.map(item => item.taxAmount).reduce((prev, next) => prev + next)
			: 0.00;

		const grossTotal = invoiceDocument?.invoiceDocumentEditorDetails?.length > 0
			? invoiceDocument.invoiceDocumentEditorDetails.map(item => parseFloat(item.ioInvoiceAmount || 0)).reduce((prev, next) => prev + next)
			: 0.00;

		setTaxTotal(taxTotal);
		setGrossTotal(grossTotal);
		setBroadCastInvoiceTotal(grossTotal);
	};

	const getFileUploadOrInvoiceDocumentViewer = React.useCallback(() => {
		var returnValue = "";
		if (state.invoiceDocument?.invoiceDocumentFileLocation && state.invoiceDocument?.invoiceDocumentFileLocation.length > 0
			&& mode !== Constants.REPLACE) {
			const companyCodeParam = props?.info?.companyCode ?? props?.info?.rowData?.companyCode ?? state?.invoiceDocument?.companyCode;
			const invoiceViewerInfo = {
				inProgress: props.info.inProgress,
				modelDefId: props.info.modelDefId,
				invoiceDocumentId: state.invoiceDocument?.invoiceDocumentId,
				invoiceDocumentFileLocation: state.invoiceDocument?.invoiceDocumentFileLocation,
				inline: true,
				mode: dialogTitle,
				companyCode: companyCodeParam
			}
			returnValue = <div><InvoiceDocumentViewer info={invoiceViewerInfo} /></div>
		}
		else if (state.originalInvoiceDocumentStatus >= 170 && mode === Constants.VIEW
			&& !state.invoiceDocument?.invoiceDocumentFileLocation
		) {
			returnValue = <div className={`file-drop-area ${''}`} >
				<label htmlFor="input-file">
					<div className="file-drop-container">
						<img src="images/drag-and-drop-icon.png" alt="" />
						<span className="file-msg">No File Available To Preview <br /> </span>
					</div>
				</label>
			</div>
		}
		else {
			returnValue = <div className={`file-drop-area ${state.dragging ? 'dragging' : ''}`}
				onDragOver={handleDragOver}
				onDragLeave={handleDragLeave}
				onDrop={handleDrop}>
				<label htmlFor="input-file">
					<div className="file-drop-container">
						<img src="images/drag-and-drop-icon.png" alt="" />
						<span className="file-msg">Drag & Drop Invoice Here <br /> or </span>
					</div>
					<input
						type="file"
						accept="application/pdf,image/jpg,image/jpeg,image/png"
						id="input-file"
						style={{ display: "none" }}
						onChange={fileUpload_changeHandler} />
					<div className="file-drop-browse">
						<label htmlFor="input-file">
							<Button variant="contained" color="inherit" component="span" size="large" startIcon={<CloudUploadIcon />}>Browse Invoice</Button>
						</label>
					</div>
				</label>
			</div>
		}
		return returnValue;
	})
	const IsSaveDisabled = () => {
		const isValidVendorSelected = VendorSelected();
		const isValidPOCode = POCodeValid();
		const isValidDueDate = DueDateValid();
		const isValidInvoiceDocumentDetail = InvoiceDocumentDetailValid();
		const isValidServiceTermStart = ServiceTermStartValid();
		const isValidServiceTermEnd = ServiceTermEndValid();
		const isValidInvoiceNumber = InvoiceNumberValid();
		const isValidGLDate = (!stringIsNullOrEmpty(state?.invoiceDocument?.glDate) && datesValidation.glDateString);
		const isTotalSpotValid = totalSpotValid();
		let checkgridValidity = mode !== "MakeCorrections" || (state.originalInvoiceDocumentStatus !== 60 && state.originalInvoiceDocumentStatus > 41);
		checkgridValidity = checkgridValidity && !state.readOnly && props.info.modelDefId !== 3;
		const isvalid = (
			//state.isDirty === false ||
			stringIsNullOrEmpty(state.invoiceDocument?.invoiceDocumentFileLocation) ||
			(checkgridValidity && editorGridRef.current?.isGridDataValid === false) ||
			(!isValidVendorSelected) ||
			//stringIsNullOrEmpty(state.invoiceDocument?.siteId) ||
			!isValidInvoiceNumber ||
			state.isInvoiceNumberDuplicate ||
			!isValidPOCode ||
			!isValidDueDate ||
			(stringIsNullOrEmpty(state.invoiceDocument?.invoiceDateString) || !datesValidation.invoiceDateString) ||
			(stringIsNullOrEmpty(state.invoiceDocument?.dueDateString) || !datesValidation.dueDateString) ||
			stringIsNullOrEmpty(state.invoiceDocument?.paymentTermCode) ||
			((props.info.modelDefId !== 2) && (!isValidServiceTermStart || !isValidServiceTermEnd)) ||
			((props.info.modelDefId === 3) && (!state.invoiceDocument?.broadcastType)) ||
			stringIsNullOrEmpty(state.invoiceDocument?.currencyCode) ||
			!isTotalSpotValid ||
			isValidGLDate === false ||
			!isValidInvoiceDocumentDetail);
		return isvalid;
	}
	const SaveButtonEnable = React.useCallback((isValidVendorSelected) => {
		var isDueDateValidation = true;
		if (!stringIsNullOrEmpty(state.invoiceDocument?.dueDateString) && !stringIsNullOrEmpty(state.invoiceDocument?.invoiceDateString)
			&& datesValidation.dueDateString && datesValidation.invoiceDateString
		) {
			var dueDate = new Date(state.invoiceDocument?.dueDateString);
			var invoiceDate = new Date(state.invoiceDocument?.invoiceDateString);
			isDueDateValidation = dueDate >= invoiceDate;
		}
		var isServiceTermValidation = true;
		if ((state.invoiceDocument?.modelDefId === 1 || state.invoiceDocument?.modelDefId === 3) && !stringIsNullOrEmpty(state.invoiceDocument?.serviceTermStartDateString) && !stringIsNullOrEmpty(state.invoiceDocument?.serviceTermEndDateString)
			&& datesValidation.serviceTermStartDateString && datesValidation.serviceTermEndDateString
		) {
			var endDate = new Date(state.invoiceDocument?.serviceTermEndDateString);
			var startDate = new Date(state.invoiceDocument?.serviceTermStartDateString);
			isServiceTermValidation = endDate >= startDate;
		}
		const isValidGLDate = (!stringIsNullOrEmpty(state?.invoiceDocument?.glDate) && datesValidation.glDateString) || state.originalInvoiceDocumentStatus < 50;
		let checkgridValidity = mode !== "MakeCorrections" || (state.originalInvoiceDocumentStatus !== 60 && state.originalInvoiceDocumentStatus > 41);

		const isApproval50or100 =
			(state.originalInvoiceDocumentStatus === 50 ||
				state.originalInvoiceDocumentStatus === 100);

		const mustRevertTo40 =
			isApproval50or100 &&
			needsRevertTo40(state.invoiceDocument, props.info.modelDefId);

		const skipGridValidation = mustRevertTo40;
		checkgridValidity = checkgridValidity && !skipGridValidation;

		const isvalid = (
			state.isDirty === false ||
			(checkgridValidity && editorGridRef.current?.isGridDataValid === false) ||
			stringIsNullOrEmpty(state.invoiceDocument?.invoiceDocumentFileLocation) ||
			(!isValidVendorSelected) ||
			//stringIsNullOrEmpty(state.invoiceDocument?.siteId) ||
			state.isInvoiceNumberDuplicate ||
			!isDueDateValidation ||
			isValidGLDate === false ||
			!isServiceTermValidation);
		return isvalid;
	})

	const setParentState = React.useCallback((obj) => {
		setState({
			...state,
			//isGridDataValid: (typeof obj.isGridDataValid == 'undefined' || obj.isGridDataValid == null) ? state.isGridDataValid : obj.isGridDataValid,
			isDirty: obj.isDirty || state.isDirty,
			invoiceDocument: ((typeof obj.invoiceDocument == 'undefined' || obj.invoiceDocument == null) ? state.invoiceDocument : obj.invoiceDocument)
		});
	})
	//just to update view
	const updateView = React.useCallback(() => {
		setView(view + 1);
	});
	const info = React.useMemo(() => {
		return {
			...props.info,
			openDialog: state.openVendorDialog,
			invoiceModel: { vendorCode: state.invoiceDocument?.vendorCode, currencyCode: "" }
		}
	}, [state.invoiceDocument, state.openVendorDialog, editorGridRef.current?.isGridDataValid])
	const clientInfo = React.useMemo(() => {
		return {
			...props.clientInfo,
			openDialog: state.openClientDialog,
			invoiceModel: { clientCode: state.invoiceDocument?.invoiceDocumentEditorDetails[0]?.clientCode }
		}
	}, [state.invoiceDocument, state.openClientDialog, editorGridRef.current?.isGridDataValid])
	const setDateValidations = React.useCallback((invoiceDocument) => {
		let validList = datesValidation;
		for (let key in validList) {
			let dateSplit = (invoiceDocument[key] || '').split('-')
			let year = (!dateSplit[0] || isNaN(dateSplit[0])) ? 0 : parseInt(dateSplit[0]);
			if (!stringIsNullOrEmpty(invoiceDocument[key]) && year < minYear) {
				validList[key] = false
			}
			else if (!stringIsNullOrEmpty(invoiceDocument[key]) && invoiceDocument[key]?.length > 10) {
				validList[key] = false
			}
			else {
				validList[key] = true
			}
		}
		setDateValidation(validList);
	}, [datesValidation]);

	const setLinesDirty = (() => {
		setState({ ...state, lineDirty: true });
	});

	const import_clickHandler = React.useCallback(() => {
		if (!isValidForImportExport()) return;
		if (state.isDirty) {
			toast.error("Please save your changes before importing lines.");
			return;
		}
		$("#broadcast_importfile_input").click();
	}, [state?.invoiceDocument?.totalSpot, state?.invoiceDocument?.invoiceNumber, state.isDirty])
	const importFile_changeHandler = React.useCallback((event) => {
		if (event.target.files.length === 0) return;
		let _formData = new FormData();
		let fileMimeType = '';
		let fileName = '';
		for (let fileObject of event.target.files) {
			fileMimeType = fileObject.type;
			fileName = fileObject.name;
			var filename = fileObject.name.replace(/[^\w\.]/gi, '');
			var file = new File([fileObject], filename, { type: fileObject.type });
			_formData.append(file.fileName, file);

		}
		let invoicedocumentId = state.invoiceDocument?.invoiceDocumentId !== 0 && state.invoiceDocument?.invoiceDocumentId || null;
		if (!invoicedocumentId) return;
		let invoiceDocument = structuredClone(state?.invoiceDocument);
		invoiceDocument.invoiceDocumentEditorDetails = state?.invoiceDocument?.invoiceDocumentEditorDetails;
		_formData.append('invoicedocument', JSON.stringify(invoiceDocument));
		_formData.append('modelDefId', state.invoiceDocument?.modelDefId);
		props.info.inProgress(true);
		httpPost('/api/InvoiceDocument/uploadcsvfile', _formData)
			.then((response) => {
				if (response.data.fileBase64) {
					toast.error('Upload failed');
					downloadBase64File(fileMimeType, response.data.fileBase64, fileName)
				}
				else {
					toast.success('Lines Imported successfull');
				}

				props.info.inProgress(false);
			})
			.catch((error) => {
				const rawMessage = error?.response?.data || "";
				toast.error(
					<div>
						Upload failed
						<br />
						{rawMessage}
					</div>
				);
				props.info.inProgress(false);
			})
			.finally(() => {
				$("#broadcast_importfile_input").val('');
			});
	}, [state?.invoiceDocument, state?.invoiceDocument?.invoiceDocumentEditorDetails]);

	const export_clickHandler = React.useCallback(() => {
		let invoicedocumentId = state.invoiceDocument?.invoiceDocumentId !== 0 && state.invoiceDocument?.invoiceDocumentId || null;
		if (!invoicedocumentId) return;
		if (!isValidForImportExport()) return;
		let invoiceDocument = structuredClone(state?.invoiceDocument);
		invoiceDocument.invoiceDocumentEditorDetails = state?.invoiceDocument?.invoiceDocumentEditorDetails;
		props.info.inProgress(true);
		httpPost('/api/InvoiceDocument/exportcsvfile', invoiceDocument)
			.then((response) => {
				let data = response.data;
				if (response.data.fileBase64) {
					toast.success('Export lines successfull');
					downloadBase64File('application/vnd.ms-excel', data.fileBase64, data.fileName)
				}
				else {
					toast.error('Export failed');
				}

				props.info.inProgress(false);
			})
			.catch((xhr) => {
				console.log(xhr)
				toast.error('Export failed');
				props.info.inProgress(false);
			})

	}, [state?.invoiceDocument, state?.invoiceDocument?.invoiceDocumentEditorDetails, state?.invoiceDocument?.totalSpot, state?.invoiceDocument?.invoiceNumber]);

	const isValidForImportExport = React.useCallback(() => {
		let isNotFaulty = true;
		if (isNotFaulty && !InvoiceNumberValid()) {
			if (state.invoiceDocument?.invoiceNumber?.length > 10) {
				toast.error('Invoice number exceeds the 10-characters limit');
			} else {
				toast.error('Invoice number is invalid');
			}
			isNotFaulty = false;
		}
		if (isNotFaulty && (stringIsNullOrEmpty(state?.invoiceDocument?.totalSpot) || state?.invoiceDocument?.totalSpot == 0)) {
			toast.error('Total spot is invalid');
			isNotFaulty = false;
		}
		if (isNotFaulty && (!ServiceTermStartValid() || !ServiceTermEndValid())) {
			toast.error('Valid start date and end date is required');
			isNotFaulty = false;
		}
		return isNotFaulty;
	}, [state?.invoiceDocument?.totalSpot, state?.invoiceDocument?.invoiceNumber, state?.invoiceDocument?.serviceTermStartDateString, state?.invoiceDocument?.serviceTermEndDateString])
	const getTaxAmountField = () => (
		<div className="row-form" data-row={9}>
			<div className="mf-10">
				<label>Tax Amount:</label>
				<input
					type="text"
					name="taxTotal"
					readOnly
					value={formatNumber(taxTotal) || ''}
					onChange={(e) => input_changeHandler(e, state, setState, setDateValidations)}
					style={{ textAlign: 'right' }}
				/>
			</div>
			<div style={{ width: 5, padding: 5 }} />
		</div>
	);

	const getVendorCode = React.useMemo(() => {
		return (<div className="mf-10">
			<label>ERP Vendor/Site:</label>
			<div className={`textBoxValidate searchFld`}>
				{state.invoiceDocument && <input type="text" name="vendor" tabIndex="2"
					className={`${stringIsNullOrEmpty(state.invoiceDocument?.vendor) && stringIsNullOrEmpty(state.invoiceDocument?.siteId) ? ' border-red' : ''}`}
					readOnly={true} value={
						stringIsNullOrEmpty(state.invoiceDocument?.vendor) &&
							stringIsNullOrEmpty(state.invoiceDocument?.siteId)
							? ""
							: state.invoiceDocument?.vendor +
							(stringIsNullOrEmpty(state.invoiceDocument?.siteId) ? "" : " / " + state.invoiceDocument?.siteId)
					}
				/>
				}
				<img
					src="images/images-invoicemodelsetup/search-icon.png"
					alt="Search Vendor"
					style={{
						display:
							!state.readOnly
								? isEditable("ERP Vendor/Site") ? '' : 'none'
								: 'none'
					}}
					onClick={(e) => search_clickHandler(e, setState)}
				/>
			</div>
		</div>)
	})
	const getVendorName = React.useMemo(() => {
		return (<div className="mf-10">
			<label>ERP Vendor/Site:</label>
			<div className={`textBoxValidate searchFld`}>
				<input type="text" name="vendor" tabIndex="2"
					readOnly={true} value={state.invoiceDocument?.vendorName || ''}
				/>
			</div>
		</div>)
	}, [state?.invoiceDocument?.vendorName])
	const isTaxDiscrepent = React.useCallback((detailLines) => {
		let isValid = allowDiscrepentTax || props.info.modelDefId === 3 || detailLines.length === 0;
		if (!isValid) {
			if (detailLines && detailLines.length > 0) {
				isValid = detailLines.every(line => {
					// validation criteria
					//if amount is 0 then not taxcode
					// if amount is not 0 than there should be taxcode
					if (line.taxAmount != 0 && !line.taxCode) return false;
					return true;
				})
			}
		}
		return !isValid;
	}, []);

	const showConfirmationDialog = React.useCallback(() => {
		setConfirmationDialogOpen(true)
	}, [confirmationDialogOpen]);

	const conditionalClose = React.useCallback((invoiceDocument, props, ...args) => {
		const isArchiveView = props?.info?.mode === Constants.ARCHIVE;

		return () => {
			if (typeof props?.onClose !== 'function') return;

			if (isArchiveView) {
				props.onClose({ invoiceDocumentId: invoiceDocument?.invoiceDocumentId });
			} else {
				// legacy multi-param close
				props.onClose({ wasUpdate: true });
			}
		};
	}, []);

	const archiveStatusHandler = useCallback(
		async (invoiceDocument, inProgressFn = () => { }, closeCallback = null) => {
			const invoiceDocumentId = invoiceDocument?.invoiceDocumentId;

			if (!invoiceDocumentId) {
				toast.error('Invalid invoice document.');
				return;
			}

			const payload = {
				invoiceDocumentId: invoiceDocumentId,
				isArchive: invoiceDocument?.isArchive,
				modelDefId: invoiceDocument?.modelDefId
			};

			const isUnarchiving = invoiceDocument.isArchive === 'Y';

			inProgressFn(true);
			let updatedDocument;
			try {
				updatedDocument = await httpPost('/api/InvoiceDocument/changearchivestatus', payload);
				toast.success(`Invoice successfully ${isUnarchiving ? 'unarchived' : 'archived'}`);

				if (typeof closeCallback === 'function') {
					closeCallback();
				}
			} catch (error) {
				console.error(error);
				toast.error(`Failed to ${isUnarchiving ? 'unarchive' : 'archive'} invoice`);
			} finally {
				inProgressFn(false);
			}
			return updatedDocument;
		}, [] // no dependencies — function is stable forever
	);

	const toggleArchive = React.useCallback(async () => {
		const isListLikeSource =
			props?.info?.editorSource === Constants.INVOICE_LIST_SOURCE ||
			props?.info?.editorSource === Constants.SOURCE_DASHBOARD_GADGET ||
			props?.info?.editorSource === Constants.SOURCE_INVOICE_REPORT;
		const operation = isListLikeSource ? { wasDeleted: true } : { wasUpdated: true };
		await archiveStatusHandler(state.invoiceDocument, props.info.inProgress, () => {
			setArchiveDialogOpen(false);
			close_clickHandler_wrapper({
				...operation,
				invoiceDocumentId: (state?.invoiceDocument?.invoiceDocumentId) || null
			})
		});
		//try {
		//	const latestDocument = await fetchInvoiceDocument();
		//	//setState({
		//	//	...state,
		//	//	invoiceDocument: latestDocument,
		//	//	readOnly: latestDocument.archived
		//	//});
		//}
		//catch (ex) {
		//	toast.error('failed to update view');
		//}

	}, [state])
	const applyToInvoice_clickHandler = (e) => {
		e.preventDefault();

		const linkedInvoiceId = state.invoiceDocument?.linkedInvoiceDocumentId;
		if (!linkedInvoiceId) return;

		if (state.isDirty) {
			proceedAfterUnsavedRef.current = () => {
				close_clickHandler_wrapper({
					event: e,
					wasUpdated: false,
					isSaved: false,
					responseObject: {
						openLinkedInvoice: true,
						invoiceDocumentId: linkedInvoiceId,
						modelDefId: state.invoiceDocument?.modelDefId,
						invoiceIndicator:
							state.invoiceDocument?.invoiceIndicator === 2 ? 1 : 2
					}
				});
			};

			setOpenUnsavedDialog(true);
			return;
		}

		close_clickHandler_wrapper({
			event: e,
			wasUpdated: false,
			isSaved: false,
			responseObject: {
				openLinkedInvoice: true,
				invoiceDocumentId: linkedInvoiceId,
				modelDefId: state.invoiceDocument?.modelDefId,
				invoiceIndicator:
					state.invoiceDocument?.invoiceIndicator === 2 ? 1 : 2
			}
		});
	};
	// #endregion Event Handlers

	//#region pure functions
	const deriveEntryContext = (source) => {
		switch (source) {
			case 'TEST':
				return { forcedMode: 'Test', forceReadOnly: true };

			case 'REPLACE':
				return { forcedMode: 'Replace', forceReadOnly: false };

			case 'VIEW_ONLY':
				return { forcedMode: 'View', forceReadOnly: true };

			default:
				return { forcedMode: null, forceReadOnly: null };
		}
	};

	const deriveModeFromInvoice = (invoiceDocument, isTestMode = false) => {
		if (!invoiceDocument) return 'View';

		const statusId = Number(invoiceDocument?.invoiceDocumentStatusId);
		const statusAttr = invoiceDocument?.invoiceDocumentStatusAttribute;
		console.log(statusId)
		// 1️⃣ Global overrides
		if (isTestMode === true) {
			return 'View';
		}

		if (statusAttr === 'U') {
			return 'UserEntry';
		}

		// 2️⃣ Below 40 → always View
		if (statusId < 40) {
			return 'View';
		}

		// 3️⃣ Explicit Make Corrections states
		if (statusId === 40 || statusId === 60 || statusId === 180) {
			return 'MakeCorrections';
		}

		// 4️⃣ Explicit View-only state
		if (statusId === 170) {
			return 'View';
		}

		// 5️⃣ Approval range (above 60, excluding 170)
		if (statusId >= 50 && statusId !== 60) {
			return 'Approval';
		}

		// 6️⃣ Safe fallback
		return 'View';
	};

	//#endregion
	// #region Local Variables
	const isInvoiceSource = state.invoiceDocument?.invoiceSource === 1;
	const isPostInProgress = incomingStatus === Constants.POST_IN_PROGRESS;
	const currencyCode = blankStringIfNullOrEmpty(state.invoiceDocument?.currencyCode);
	const vendorDialogConfirmationMessage = state.invoiceDocument?.modelDefId === 1 ? "Changing vendor will reset IO/PO Number from all invoice details, Do you wish to continue ?"
		: "Changing vendor will reset PO Code, Do you wish to continue ?";
	const poHeaderInfo = {
		inProgress: props.info.inProgress,
		openDialog: state.openPOHeaderDialog,
		vendorCode: state.invoiceDocument?.vendorCode,
		siteId: state.invoiceDocument?.siteId,
		serviceTermStartDate: state.invoiceDocument?.serviceTermStartDateString,
		serviceTermEndDate: state.invoiceDocument?.serviceTermEndDateString,
		modelDefId: state.invoiceDocument?.modelDefId,
		poCode: state.invoiceDocument?.modelDefId === 1 ? (currentDetailEditRow && currentDetailEditRow.ioNumber ? currentDetailEditRow.ioNumber : null) : state.invoiceDocument?.poCode,
		invoiceDocumentId: state.invoiceDocument?.invoiceDocumentId,
		allowMultipleSelection: state.allowMultipleSelection,
		ioInvoiceAmount: currentSelectedRow ? currentSelectedRow[0]?.ioInvoiceAmount : 0.00,
		clientCode: state.invoiceDocument?.clientCode,
		vendorName: state.invoiceDocument?.vendorName,
		lineStatuses: state.poSelectionContext?.lineStatuses || [],
		serviceDateFilterForIoLookup: state.invoiceDocument?.serviceDateFilterForIoLookup
	};
	const poHeaderResourceInfo = {
		inProgress: props.info.inProgress,
		openDialog: state.openPOHeaderResourceDialog,
		vendorCode: state.invoiceDocument?.vendorCode,
		siteId: state.invoiceDocument?.siteId,
		invoiceDocumentId: state.invoiceDocument?.invoiceDocumentId
	};
	const level2ResourceInfo = {
		inProgress: props.info.inProgress,
		openDialog: state.openLevel2ResourceDialog,
		vendorCode: state.invoiceDocument?.vendorCode,
		siteId: state.invoiceDocument?.siteId,
		invoiceDocumentId: state.invoiceDocument?.invoiceDocumentId
	};
	const level2Info = {
		inProgress: props.info.inProgress,
		openDialog: state.openLevel2Dialog,
		poCode: blankStringIfNullOrEmpty(state.invoiceDocument?.poCode),
		noPoFlag: state.invoiceDocument?.noPoFlag,
		clientCode: state.invoiceDocument?.clientCode,
		level2Key: currentEditRow ? currentEditRow.level2Key : null
	};
	const level3Info = {
		inProgress: props.info.inProgress,
		openDialog: state.openLevel3Dialog,
		level2Key: currentEditRow ? currentEditRow.level2Key : null,
		poCode: blankStringIfNullOrEmpty(state.invoiceDocument?.poCode),
		level3Key: currentEditRow ? currentEditRow.level3Key : null
	};
	const costCodesInfo = {
		inProgress: props.info.inProgress,
		openDialog: state.openCostCodesDialog,
		level2Key: currentEditRow ? currentEditRow.level2Key : null,
		level3Key: currentEditRow ? currentEditRow.level3Key : null,
		poCode: blankStringIfNullOrEmpty(state.invoiceDocument?.poCode),
		resType: currentEditRow ? currentEditRow.resType : null
	};
	const invoiceDocumentRoutingHistoryInfo = {
		rowData: props.info.rowData,
		inProgress: props.info.inProgress,
		openDialog: state.openInvoiceDocumentRoutingHistoryDialog,
		routingHistoryData: state.routingHistoryData,
	};
	const replaceInfo = {
		rowData: null,
		invoiceDocumentId: state.invoiceDocument?.invoiceDocumentId,
		modelDefId: state.invoiceDocument?.modelDefId,
		mode: Constants.REPLACE,
		inProgress: props.info.inProgress
	};
	const { companyApprovalConfiguration } = state.invoiceDocument || {};
	const routingNumberOfApprovalLevels = companyApprovalConfiguration?.routingNumberOfApprovalLevels || 0;
	const upperLimit = 60 + routingNumberOfApprovalLevels * 20;
	const shouldNotShowRouteToEmployee = state.originalInvoiceDocumentStatus >= 50 &&
		state.originalInvoiceDocumentStatus <= upperLimit;
	const shouldShowApprovalRouting = (state.originalInvoiceDocumentStatus >= 50 &&
		state.originalInvoiceDocumentStatus <= upperLimit &&
		(mode === Constants.APPROVAL || mode === Constants.MAKE_CORRECTIONS));
	const shouldShowApprovalRoutingHistory =
		//state.originalInvoiceDocumentStatus >= 50 &&
		//state.originalInvoiceDocumentStatus <= upperLimit &&
		(mode === Constants.APPROVAL || mode === Constants.MAKE_CORRECTIONS || mode === Constants.VIEW || mode === Constants.EDIT_DATES || mode === Constants.OVERRIDE
			|| mode === Constants.CREDIT_MEMO || mode !== Constants.TEST || invoiceIndicator !== 2);
	const displayAccept = (mode === Constants.APPROVAL || mode === Constants.MAKE_CORRECTIONS) &&
		state.originalInvoiceDocumentStatus >= 50 &&
		state.invoiceDocument?.modelDefId === 3 &&
		((upperLimit) >= state.originalInvoiceDocumentStatus) &&
		state?.invoiceDocument?.invoiceSource !== 1 && !state?.invoiceDocument?.archived &&
		!capabilities?.hasDifferentCompany ? "" : "none";


	const displayReject = mode === Constants.APPROVAL &&
		state.invoiceDocument?.invoiceDocumentStatusId > 50 &&
		state.invoiceDocument?.modelDefId === 3 && state?.invoiceDocument?.invoiceSource !== 1
		&& !state?.invoiceDocument?.archived
		&& !capabilities?.hasDifferentCompany ? "" : 'none';
	// as per requirement from abid 11212024 show save button on edi invoices
	const isAdminDateEditMode = (mode === Constants.EDIT_DATES && dateEditableForAdmin);
	const creditMemoRule = groupRules?.find(
		(rule) =>
			rule.Model_def_id === props.info.modelDefId &&
			rule.label?.toLowerCase?.() === "create credit memo" &&
			rule.editable === "1" && rule.Model_def_id === props.info.modelDefId
	);
	// Deciding whether to show the credit memo button or not
	const isCreditMemoMode = mode == Constants.CREDIT_MEMO;
	const isInvoiceAccessedFromDiscrpentGadget = props.info?.invoiceSource === 'unmatchedInvoices';
	const shouldDisplayButtons = true;// invoiceIndicator !== 2 || state.originalInvoiceDocumentStatus !== 180;
	const enableForCreditMemo = isCreditMemoMode && invoiceDocumentStatusId < 170 && invoiceIndicator === 2;
	const shouldDisplayCreditMemoButton = !!creditMemoRule
		&& invoiceDocumentStatusId === 170
		&& state?.invoiceDocument?.invoicePostStatus !== 'Partial posted'
		&& invoiceIndicator === 0
		&& state?.invoiceDocument?.invoiceSource !== 1
		&& !capabilities?.hasDifferentCompany ? "" : "none";
	const readyToPost = isApprovalLevelBreached({
		routingNumberOfApprovalLevels: routingLevels,
		invoiceDocumentStatusId: invoiceDocumentStatusId
	});
	const _isListLikeSource =
		props?.info?.editorSource === Constants.INVOICE_LIST_SOURCE ||
		props?.info?.editorSource === Constants.SOURCE_DASHBOARD_GADGET ||
		props?.info?.editorSource === Constants.SOURCE_INVOICE_REPORT;
	const canDeleteCreditMemo =
		invoiceIndicator === 2 &&
		(invoiceDocumentStatusId !== 170);
	const canDeleteInvoice =
		invoiceIndicator !== 2 &&
		(invoiceDocumentStatusId !== 170 &&
			invoiceDocumentStatusId !== 180) &&
		!readyToPost;
	const shouldDeleteInvoice =
		!(isPostInProgress || mode === Constants.USER_ENTRY || mode === Constants.REPLACE || mode === Constants.ARCHIVE)
			&& !capabilities?.hasDifferentCompany
			&& Boolean(isEditable('Delete Invoice'))
			&& (canDeleteCreditMemo || (canDeleteInvoice)) ? "" : "none";
	const displaySave =
		(isCreditMemoMode && invoiceIndicator === 2 && (invoiceDocumentStatusId === 170 || invoiceDocumentStatusId === 180))
			|| isPostInProgress
			|| (invoiceIndicator === 0 && invoiceDocumentStatusId === 170)
			|| (!isCreditMemoMode && (state.readOnly && (mode !== Constants.APPROVAL && !isAdminDateEditMode))
				|| state?.invoiceDocument?.archived
				|| capabilities?.hasDifferentCompany
		/*|| state.invoiceDocument?.modelDefId === 3*/) ? "none" : "";
	const displayReset =
		(isCreditMemoMode && invoiceIndicator === 2 && (invoiceDocumentStatusId === 170 || invoiceDocumentStatusId === 180))
			|| isPostInProgress
			|| (!isCreditMemoMode && (state.readOnly && mode !== Constants.APPROVAL && !isAdminDateEditMode))
			|| state?.invoiceDocument?.archived
			|| capabilities?.hasDifferentCompany ? "none" : "";
	const displayRouting = ((state.readOnly && mode !== Constants.APPROVAL) ||
		state.invoiceDocument?.modelDefId === 3 ||
		state.invoiceDocument?.allowApprovalRoutingSetup === 'N' || !shouldShowApprovalRouting) ||
		state?.invoiceDocument?.archived ||
		capabilities?.hasDifferentCompany ? "none" : "";
	const displayReplace = (isCreditMemoMode) || (!!state?.invoiceDocument?.sourceGeneratedPDF) ||
		(displaySave === "none" || invoiceIndicator !== 0 || (displaySave === "" && isAdminDateEditMode) ||
			(state.readOnly && mode === Constants.APPROVAL) ||
			mode === Constants.USER_ENTRY ||
			(mode === Constants.REPLACE) ||
			state.invoiceDocument?.modelDefId === 3) ||
		state?.invoiceDocument?.archived || invoiceDocumentStatusId === 180 ||
		capabilities?.hasDifferentCompany ? "none" : "";
	const displayFavouriteButton = ((state.originalInvoiceDocumentStatus === 40 || state.originalInvoiceDocumentStatus === 60) && !state?.invoiceDocument?.archived && isInvoiceAccessedFromDiscrpentGadget);
	const displayRoutingHistory = (state.invoiceDocument?.allowApprovalRoutingSetup === 'N'
		|| mode === Constants.TEST
		|| mode === Constants.REPLACE
		|| mode === Constants.USER_ENTRY
		|| state?.invoiceDocument?.invoiceSource === 1
		|| !shouldShowApprovalRoutingHistory)
		|| state?.invoiceDocument?.archived
		|| capabilities?.hasDifferentCompany ? "none" : "";
	const shouldDisplayCreditMemoMarkAsPosted =
		isCreditMemoMode &&
			state?.invoiceDocument?.isCmInternalyPosted != 1 &&
			state?.invoiceDocument?.systemType == "mediaoceanprisma" &&
			//invoiceIndicator === 2 &&
			//(invoiceDocumentStatusId < 170 ||
			//invoiceDocumentStatusId == 180) && -- asad one rule for all of them with group rules
			capabilities?.canPostCreditMemo &&
			!state.invoiceDocument?.archived &&
			!capabilities?.hasDifferentCompany
			? ""
			: "none";
	const shouldShowMarkAsPosted =
		invoiceIndicator === 2 &&
		invoiceDocumentStatusId !== 170;
	const canSaveCommentsOnPosted =
		invoiceDocumentStatusId === 170 && state?.invoiceDocument?.invoiceSource != 1;
	const _isVendorSelected = VendorSelected();
	const _isPOCodeValid = POCodeValid();
	const _isDueDateValid = DueDateValid();
	const _isServiceTermStartValid = ServiceTermStartValid();
	const _isServiceTermEndValid = ServiceTermEndValid();
	const _isInvoiceNumberValid = InvoiceNumberValid();
	const isSaveBtnDisabled = mode === Constants.APPROVAL ? IsSaveDisabled() : SaveButtonEnable(_isVendorSelected);
	const invoiceTotal = parseFloat(grossTotal || 0) + parseFloat(taxTotal || 0);
	// In Partial Posting mode we keep invoice-level readOnly, but allow limited line edits.
	const cellEditable = isPartialPostMode ? true : !(state.readOnly || (!_isVendorSelected));
	const cellVisible = mode != Constants.TEST;
	const braodCastInvoiceHasTax = (props.info.modelDefId === 3 && state?.invoiceDocument?.invoiceDocumentEditorDetails[0]?.taxCode);
	const datesEditabelAfterApprove = mode === Constants.EDIT_DATES;
	const allEditabelAfterApprove = mode === Constants.OVERRIDE;
	const readOnlyForAdmin = (!allEditabelAfterApprove && datesEditabelAfterApprove && !isAdminDateEditMode);
	const readOnlyOverride = (!datesEditabelAfterApprove && allEditabelAfterApprove && !overrideAllChks);
	const ignorePreviousCases = allEditabelAfterApprove || datesEditabelAfterApprove;
	const archiveMode = mode === Constants.ARCHIVE
	const archiveButtonText = state?.invoiceDocument?.archived ? "Unarchive" : "Archive";
	const archiveButtonClass = state?.invoiceDocument?.archived ? "btn-blue" : 'btn-grey';
	const promptMessage = (state?.invoiceDocument?.archived
		? "Are you sure, you want to unarchive the invoice?" :
		'Are you sure, you want to archive this invoice?');
	const userName = JSON.parse(localStorage?.userInfo || null)?.lastName + ', ' + JSON.parse(localStorage?.userInfo)?.firstName;
	const showApplyTo =
		Number(state.invoiceDocument?.invoiceIndicator) > 0 &&
		!!state.invoiceDocument?.linkedInvoiceDocumentId;

	const linkedInvoiceMode =
		Number(state.invoiceDocument?.invoiceIndicator) === 1
			? 'CreditMemo'
			: 'View';
	const currentBasePath = window.location.pathname;

	const linkedInvoiceUrl = showApplyTo
		? `${currentBasePath}?companyCode=${state.invoiceDocument?.companyCode}` +
		`&invoicedocumentid=${state.invoiceDocument?.linkedInvoiceDocumentId}` +
		`&status=${state.invoiceDocument?.linkedInvoiceDocumentStatusId}` +
		`&mode=${linkedInvoiceMode}` +
		`&modeldefid=${state.invoiceDocument?.modelDefId}`
		: '';
	const proceedAfterUnsavedRef = useRef(null);



	const siteDisplayName = getDisplayName('User Status');

	const deliveryMismatchSuffix = (() => {
		if (!state.invoiceDocument?.ioDeliveryMismatchFlag) return '';
		const msg = state.invoiceDocument?.deliveryMismatchMessage;
		return ` (${msg && msg.trim() ? msg.trim() : 'Delivery Amount Discrepant!'})`;
	})();

	const displayedStatus = (state.invoiceDocument?.status || '') + deliveryMismatchSuffix;



	// #endregion Local Variables
	// #region Renderer
	return (

		state.invoiceDocument &&
		<div>
			<VendorMappingConfirmationDialog
				isOpen={openClientWarningDialog}
				title="Warning"
				message="Are you sure, you want to save without selecting a Client?"
				onClose={(event) => {
					if (dialogResponseHandler) {
						dialogResponseHandler(event);
					}
				}}
			/>

			<VendorMappingConfirmationDialog
				isOpen={openAmountsMismatchDialog}
				title="Amount Mismatch"
				message={amountsMismatchMessage || "The scanned total amount doesn’t match the invoice total amount. Do you want to continue?"}
				onClose={(event) => {
					if (amountsMismatchDialogResponseHandler) {
						amountsMismatchDialogResponseHandler(event);
					}
				}}
			/>
			<VendorMappingConfirmationDialog
				isOpen={openUnsavedDialog}
				title="Unsaved Changes"
				message="There are unsaved changes. Do you want to continue?"
				onClose={(event) => {
					setOpenUnsavedDialog(false);
					if (event?.response === 'Y') {
						proceedAfterUnsavedRef.current?.();
					}
				}}
			/>



			<h1 style={{ marginLeft: 15 }}>{title}</h1>
			<div className="col-invoice-view">
				<div className="mainTable box-container" style={{ maxWidth: "none", paddingBottom: 90 }}>
					<Grid container justify="center" style={{ flexGrow: 1 }} spacing={1}>
						<Slide direction="right" in={state.uncollapsed} mountOnEnter>
							<Grid key={1} item xs={state.uncollapsed ? 6 : 1} style={{ display: state.displayInvoiceDocumentViewer }}>
								{getFileUploadOrInvoiceDocumentViewer()}
							</Grid>
						</Slide>
						<Grid key={2} item xs={state.uncollapsed ? 6 : 12}>
							<Grid item xs>
								{getCollapseUncollapseButton()}
							</Grid>
							<Grid item xs>
								<Grid container justify="center">
									<Grid item xs={10}>
										<div className="row-form" style={{ display: stringIsNullOrEmpty(state.invoiceDocument?.fileName) ? "none" : "" }}>
											<div className="mf-10">
												<label>Invoice Document File:</label>
												{state.invoiceDocument && <input type="text" name="fileName" tabIndex="1" readOnly={true} value={state.invoiceDocument?.fileName + " " + new Date(state.invoiceDocument?.createDateString).toLocaleString() || ''} />}
											</div>
											<div style={{ width: 5, padding: 5 }}>
											</div>
										</div>
										<div className="row-form">
											{/*- vendor name ,vendor code placeholder*/}
											{(props.info.modelDefId === 3 && state?.invoiceDocument?.invoiceSource === 1) ? getVendorName : getVendorCode}
											{/*- vendor name ,vendor code placeholder end*/}
											<div style={{ width: 5, padding: 5 }}>
											</div>

										</div>
										<div className="row-form" style={{ display: (!state.invoiceDocument?.documentModelName || !state.invoiceDocument?.documentModelNameTag) || mode === "UserEntry" || mode === "Replace" || state.invoiceDocument?.modelDefId === 3 ? "none" : "" }}>
											<div className="mf-10">
												<label>Invoice Model/Tag:</label>
												{state.invoiceDocument && <input type="text" name="documentModelName" tabIndex="3" readOnly={true} value={state.invoiceDocument?.documentModelName + " - " + state.invoiceDocument?.documentModelNameTag || ''} />}
											</div>
											<div style={{ width: 5, padding: 5 }}>
											</div>
										</div>
											<div className="row-form" style={{ display: mode === "UserEntry" || mode === "Replace" ? "none" : "flex" }}
												data-row={1} >
												<div className="mf-10">
													<label>Invoice Status:</label>
													<input type="text" name="status" title={
														state?.invoiceDocument?.postedUserName
															? `${state.invoiceDocument?.status} by: ${state.invoiceDocument?.postedUserName}`
															: state?.invoiceDocument?.taxDiscrepancyReason || ""
													}
														tabIndex="5" readOnly={true} value={displayedStatus} />
												</div>
												<div style={{ width: 5, padding: 5 }}>
												</div>
											</div>
									</Grid>
									<Grid item xs={2}>
									</Grid>
								</Grid>
								{/*Header Column*/}
								<Grid container justify="flex-start">
									{/*column 1*/}
									<Grid item xs>
										{showChangeCompany && (<div className="row-form" data-row={4}>
											<div className="mf-10">
												<label>Company:</label>
												<div
													style={{
														display: 'flex',
														alignItems: 'center',
														flexGrow: 1,
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														maxWidth: '100%',
														paddingLeft: '3%',
													}}
													title={selectedCompany?.coName || ''}
												>
													<span style={{
														flexGrow: 1,
														marginTop: (
															state.readOnly ||
															(state.invoiceDocument?.invoiceDocumentStatusId > 60)
														) ? '9px' : '8px'
													}}>
														{selectedCompany?.coName || ''}
													</span>
													<Button
														variant="text"
														color="primary"
														onClick={handleChangeCompanyClick}
														style={{
															minWidth: 'auto',
															fontSize: '0.75rem',
															whiteSpace: 'nowrap',
															transform: 'none',
															marginTop: '8px',
															padding: '0px 5px',
															lineHeight: 'normal',
															display: state.readOnly || props?.info?.mode === 'UserEntry' || state?.invoiceDocument?.invoiceDocumentFileLocation?.indexOf(Constants.USER_ENTRY_IDENTIFIER) !== -1 || !checkLineStatusForChangeCompany(state.invoiceDocument) ? 'none' : ((state.invoiceDocument?.invoiceDocumentStatusId < 60 && state.invoiceDocument?.changeCompany === 'Y') ? 'block' : 'none'),
														}}
													>
														Change Company
													</Button>
												</div>
											</div>
											<div style={{ width: 5, padding: 5 }}></div>
										</div>
										)}

										{showDropdown && (
											<div className="row-form" data-row={5}>
												<div className="mf-10">
													<label>Company:</label>
													<select
														id="changeCompany"
														name="changeCompany"
														style={{ padding: '5px 10px' }}
														className={`${stringIsNullOrEmpty(selectedCompany?.coName) ? "empty-select" : ""}`}
														value={pendingCompany?.companyCode || selectedCompany?.companyCode || ''}
														onChange={handleCompanyChange}
													>
														<option key="defaultOption" value="">
															{companyList?.length === 0 ? "No Companies Available" : "Select Company"}
														</option>
														{companyList?.map((item, index) => (
															<option key={index} value={item.companyCode}>
																{item.coName}
															</option>
														))}
													</select>
												</div>
												<div style={{ width: 5, padding: 5 }}>
												</div>
											</div>
										)}


										<div className="row-form" data-row={2}>
											<div className="mf-10" style={{ marginTop: '9px' }}>
												<label>Invoice Number:</label>
												{state.invoiceDocument && <input type="text" name="invoiceNumber"
													title={_isInvoiceNumberValid && state.isInvoiceNumberDuplicate ? "Duplicate" : ""}
													className={`${state.isInvoiceNumberDuplicate || !_isInvoiceNumberValid ? 'border-red' : ''}`}
													tabIndex="4" readOnly={isFieldReadOnly("Invoice Number")} value={state.invoiceDocument?.invoiceNumber || ''}
													maxLength={(props.info.modelDefId !== 3 || state?.invoiceDocument?.invoiceSource === 1) ? 32 : 10} onChange={(e) => input_changeHandler(e, state, setState, setDateValidations)} onBlur={invoiceNumber_blurHandler} />}
											</div>
											<div style={{ width: 5, padding: 5 }}>
												{/*<span title={_isInvoiceNumberValid && state.isInvoiceNumberDuplicate ? "Duplicate" : ""} style={{ color: "red", visibility: state.isInvoiceNumberDuplicate || !_isInvoiceNumberValid ? "visible" : "hidden" }}>*</span>*/}
											</div>
										</div>

										<div className="row-form" style={{ display: state.invoiceDocument?.modelDefId === 2 ? "" : "none" }} data-row={3}>
											<div className="mf-10">
												<label>PO Code:</label>
												<div className="textBoxValidate searchFld">
													{state.invoiceDocument && <input type="text"
														className={`${!_isPOCodeValid ? 'border-red' : ''}`}
														name="poCode" tabIndex="6" readOnly={true} value={stringIsNullOrEmpty(state.invoiceDocument?.poCode) ? "" : state.invoiceDocument?.poCode} />}
													<img src="images/cross.png" alt="Remove PO Code" style={{ padding: 6, marginRight: 30, display: (state.readOnly || state.invoiceDocument?.modelDefId !== 2 || (!state.invoiceDocument?.isNoPOVendor && _isPOCodeValid) || stringIsNullOrEmpty(state.invoiceDocument?.poCode)) ? "none" : isEditable("PO Code") ? "" : "none" }}
														onClick={deletePOCode_clickHandler} />
													<img src="images/images-invoicemodelsetup/search-icon.png" alt="Search PO Code" style={{
														display: ((!ignorePreviousCases && (state.readOnly ||
															stringIsNullOrEmpty(state.invoiceDocument?.vendor) ||
															stringIsNullOrEmpty(state.invoiceDocument?.siteId || isInvoiceSource)))
															|| (readOnlyForAdmin)
															|| (readOnlyOverride)
														) ? "none" : isEditable("PO Code") ? "" : "none"
													}} onClick={searchIONumber_clickHandler} />
												</div>
											</div>
											<div style={{ width: 5, padding: 5 }}>
												{/*<span style={{ color: "red", visibility: !_isPOCodeValid ? "visible" : "hidden" }}>*</span>*/}
											</div>
										</div>
										<div className="row-form" data-row={4}>
											<div className="mf-10">
												<label>Invoice Date:</label>
												{state.invoiceDocument && <input type="date"
													className={`${state?.invoiceDocument?.invoiceSource !== 1 && (stringIsNullOrEmpty(state.invoiceDocument?.invoiceDateString) || !datesValidation.invoiceDateString) ? 'border-red' : ''}`}
													name="invoiceDateString" tabIndex="7" data-name="invoiceDate" readOnly={isFieldReadOnly("Invoice Date")}
													value={state.invoiceDocument?.invoiceDateString || ''}
													onChange={(e) => onPaymentTermsChange(
														e,
														state,
														setState,
														setDateValidations,
														() => input_changeHandler(e, state, setState, setDateValidations),
														addDaysInDate)} />}
											</div>
											<div style={{ width: 5, padding: 5 }}>
												{/*<span style={{ color: "red", visibility: stringIsNullOrEmpty(state.invoiceDocument?.invoiceDateString) ? "visible" : "hidden" }}>*</span>*/}
											</div>
										</div>
										<div className="row-form" data-row={5}>
											<div className="mf-10">
												<label htmlFor="paymentTerms">Payment Term:</label>
												<select id="paymentTermCode" name="paymentTermCode"
													style={{ padding: '5px 10px 5px 10px' }}
													className={`${state?.invoiceDocument?.invoiceSource !== 1 && (stringIsNullOrEmpty(state.invoiceDocument?.paymentTermCode)
														|| state.invoiceDocument?.paymentTerms?.filter((e, i) => e.termsCode === state.invoiceDocument?.paymentTermCode)?.length <= 0) ? 'border-red' : ''}`}
													tabIndex="9" disabled={(state.readOnly || isInvoiceSource || !broadCastValidation.isPaymentTermEnabled || overrideAllChks || mode === Constants.EDIT_DATES) ? true : !isEditable("Payment Term")} value={stringIsNullOrEmpty(state.invoiceDocument?.paymentTermCode) ? "" : state.invoiceDocument?.paymentTermCode}
													onChange={(e) => onPaymentTermsChange(
														e,
														state,
														setState,
														setDateValidations,
														() => input_changeHandler(e, state, setState, setDateValidations),
														addDaysInDate)}>
													<option key="paymentTermCode" value={(state.invoiceDocument?.paymentTerms?.length || 0) === 0 ? state.invoiceDocument?.paymentTermCode : ""}>{(state.invoiceDocument?.paymentTerms?.length || 0) === 0 ? state.invoiceDocument?.paymentTermCode : "Select Payment Term"}</option>
													{
														state.invoiceDocument?.paymentTerms?.map(function (item, index) {
															return <option key={index} value={item.termsCode}>{item.termsDesc}</option>
														})
													}
												</select>
											</div>
											<div style={{ width: 5, padding: 5 }}>
												{/*<span style={{ color: "red", visibility: stringIsNullOrEmpty(state.invoiceDocument?.paymentTermCode) ? "visible" : "hidden" }}>*</span>*/}
											</div>
										</div>
										<div className="row-form" style={{ display: state.invoiceDocument?.modelDefId === 2 ? "none" : "" }} data-row={8}>
											<div className="mf-10">
												<label>{state.invoiceDocument?.modelDefId === 3 ? 'Start Date' : 'Service Term From'}:</label>
												{state.invoiceDocument && <input type="date"
													className={`${state?.invoiceDocument?.invoiceSource !== 1 && (!_isServiceTermStartValid || !datesValidation.serviceTermStartDateString) ? 'border-red' : ''}`}
													name="serviceTermStartDateString" tabIndex="11" data-name="serviceTermStartDate"
													readOnly={((!ignorePreviousCases && (state.readOnly || isInvoiceSource))
														|| (readOnlyOverride) || isPostInProgress) ? true : !isEditable(state.invoiceDocument?.modelDefId === 3 ? "Start Date" : "Service Term From")
													}
													value={state.invoiceDocument?.serviceTermStartDateString || ''} onChange={(e) => input_changeHandler(e, state, setState, setDateValidations)}
													onBlur={(e) => {
														if (e.target.disabled) return;
														serviceTerm_blurHandler(
															e,
															props,
															state,
															setState,
															currentEditRow,
															toast,
															stringIsNullOrEmpty,
															uniqueBy,
															editorGridRef
														);

														if (e.target.value && e.target.value.length === 10) {
															handleServiceTermChange('serviceTermStartDateString', e.target.value);
														}
													}} />}
											</div>
											<div style={{ width: 5, padding: 5 }}>
												{/*<span style={{ color: "red", visibility: !_isServiceTermStartValid ? "visible" : "hidden" }}>*</span>*/}
											</div>
										</div>
										{/*{state?.invoiceDocument?.invoiceSource !== 1 &&*/}
										<div className="row-form" data-row={9}>
											<div className="mf-10">
												<label>Net Amount:</label>
												{
													<input
														type="text"
														name="netAmount"
														readOnly={state.readOnly || !((props?.info?.modelDefId === 3) && isEditable("Net Amount"))}
														maxLength={15}
														value={
															inputMode === 'number'
																? rawNetAmount
																: formatAmount(round((parseFloat(rawNetAmount.replace(/,/g, ''))), 2))
														}
														onFocus={() => {
															if (state.readOnly || props.info.modelDefId !== 3) return;
															const num = parseFloat(rawNetAmount.replace(/,/g, ''));
															const rounded = isNaN(num) ? '0.00' : round(num, 2).toFixed(2);
															setRawNetAmount(rounded);
															setInputMode('number');
														}}
														onBlur={() => {
															if (state.readOnly || props.info.modelDefId !== 3) return;
															const num = parseFloat(rawNetAmount.replace(/,/g, ''));
															const formatted = isNaN(num) ? '0.00' : formatAmount(num);
															setRawNetAmount(formatted.replace(/,/g, ''));
															setInputMode('text');
														}}
														onChange={(e) => {
															const val = e.target.value;
															if (/^-?\d*\.?\d*$/.test(val)) {
																setRawNetAmount(val);
																setBroadCastInvoiceTotal(val);
																setState((prev) => ({ ...prev, isDirty: true }));
															}
														}}
														style={{ textAlign: 'right' }}
														onKeyDown={(e) => {
															if (e.ctrlKey || e.metaKey) {
																return;
															}
															const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'];
															if (!/[0-9.\-]/.test(e.key) && !allowedKeys.includes(e.key)) {
																e.preventDefault();
															}
														}}
													/>

												}

											</div>
											<div style={{ width: 5, padding: 5 }}>
											</div>
										</div>
										{/*}*/}
										<div className="row-form" style={{ display: state.invoiceDocument?.modelDefId === 3 && state?.invoiceDocument?.invoiceSource !== 1 ? "" : "none" }} data-row={9}>
											<div className="mf-10">
												<label>Tax Code:</label>
												<select
													value={broadCastTaxCode}
													onChange={handleTaxCodeChange}
													//className={state.taxes.every(tax => tax.taxCode !== broadCastTaxCode) ? 'border-red' : ''}
													disabled={isFieldReadOnly('Tax Code')}
													style={{ textAlign: 'left' }}
												>
													<option value="">Select Tax Code</option>
													{state.taxes.map((tax, index) => (
														<option key={index} value={tax.taxCode}>
															{tax.taxDesc}
														</option>
													))}
												</select>
											</div>
											<div style={{ width: 5, padding: 5 }}></div>
										</div>
										{/* ModelDef 1/2: */}
										<div className="row-form" style={{ display: showHeaderTaxForLines ? "" : "none" }} data-row={9}>
											<div className="mf-10">
												<label>Tax Code:</label>
												<select
													value={headerTaxCodeForLines}
													onChange={handleHeaderTaxCodeForLinesChange}
													disabled={isFieldReadOnly('Tax Code')}
													style={{ textAlign: 'left' }}
												>
													<option value="">Select Tax Code</option>
													{state.taxes.map((tax, index) => (
														<option key={index} value={tax.taxCode}>
															{tax.taxDesc}
														</option>
													))}
												</select>
											</div>
											<div style={{ width: 5, padding: 5 }}></div>
										</div>
										{/*{getTaxAmountField()}*/}
										<div className="row-form" data-row={10}>
												<div className="mf-10" style={{ position: 'relative', display: 'inline-block' }}>
													<label>Invoice Total:</label>
													{(() => {
														const scannedTotal = parseFloat(state.invoiceDocument?.scannedTotal) || 0;
														const hasScannedTotal = scannedTotal !== 0;
														// 1. Check if there is an active mathematical difference right now
														const isCurrentlyDifferent = Math.abs(invoiceTotal - scannedTotal) > 0.001;

														// Border red if there's a difference and user HASN'T accepted it yet

														const hasDiscrepancy = hasScannedTotal
															&& !state?.invoiceDocument?.userAcceptDiscrepancy
															&& isCurrentlyDifferent;

														// Icon and Red text should ONLY show if a difference actually exists AND user accepted it
														const showDiscrepancyAccepted = state?.invoiceDocument?.userAcceptDiscrepancy && isCurrentlyDifferent;

														const discrepancyTooltip = hasDiscrepancy
															? `Amount does not match scanned total (${formatNumber(scannedTotal)})`
															: '';
														return (
															<input
																type="text"
																name="invoiceTotal"
																readOnly={true}
																value={formatNumber(invoiceTotal) || ''}
																onChange={(e) => input_changeHandler(e, state, setState, setDateValidations)}
																title={discrepancyTooltip}
																className={hasDiscrepancy ? 'border-red' : ''}
																style={{
																	textAlign: 'right',
																	// FIX: Only turn text red if the amount is actually still different
																	...(showDiscrepancyAccepted && { color: 'red' })
																}}
															/>
														);
													})()}

													{/* FIX: Only show the info icon if the amount is actually still different */}
													{state?.invoiceDocument?.userAcceptDiscrepancy
														&& (Math.abs(invoiceTotal - (parseFloat(state.invoiceDocument?.scannedTotal) || 0)) > 0.001) && (
														<Tooltip
															title={`${state?.invoiceDocument?.userAcceptDiscrepancyName || userName} has accepted the amount discrepancy.`}
															placement="top"
															arrow
														>
															<span
																style={{
																	position: 'absolute',
																	right: '-24px',
																	top: '40%',
																	transform: 'translateY(-35%)',
																	lineHeight: '1',
																	pointerEvents: 'auto'
																}}
															>
																<img
																	src="images/info.svg"
																	alt="Information"
																	style={{
																		width: 24,
																		height: 24,
																		display: 'block'
																	}}
																/>
															</span>
														</Tooltip>
													)}
												</div>

												<div style={{ width: 5, padding: 5 }}></div>
											</div>

										{/*{(state.invoiceDocument && state.invoiceDocument?.modelDefId == 1 && getDiscountField(9)) ||*/}
										{/*	(state.invoiceDocument && state.invoiceDocument?.modelDefId == 2 && getDiscountField(9))*/}
										{/*}*/}

										{/*<div className="row-form" style={{ display: state.invoiceDocument?.modelDefId === 3 && state?.invoiceDocument?.invoiceSource !== 1 ? "" : "none" }} data-row={9}>*/}
										{/*	<div className="mf-10">*/}
										{/*		<label>Tax Code:</label>*/}
										{/*		<select*/}
										{/*			value={broadCastTaxCode}*/}
										{/*			onChange={handleTaxCodeChange}*/}
										{/*			//className={state.taxes.every(tax => tax.taxCode !== broadCastTaxCode) ? 'border-red' : ''}*/}
										{/*				disabled={isFieldReadOnly('Tax Code')}*/}
										{/*			style={{ textAlign: 'left' }}*/}
										{/*		>*/}
										{/*			<option value="">Select Tax Code</option>*/}
										{/*			{state.taxes.map((tax, index) => (*/}
										{/*				<option key={index} value={tax.taxCode}>*/}
										{/*					{tax.taxDesc}*/}
										{/*				</option>*/}
										{/*			))}*/}
										{/*		</select>*/}
										{/*	</div>*/}
										{/*	<div style={{ width: 5, padding: 5 }}></div>*/}
										{/*	</div>*/}
										{/*	*/}{/* ModelDef 1/2: */}
										{/*	<div className="row-form" style={{ display: showHeaderTaxForLines ? "" : "none" }} data-row={9}>*/}
										{/*		<div className="mf-10">*/}
										{/*			<label>Tax Code:</label>*/}
										{/*			<select*/}
										{/*				value={headerTaxCodeForLines}*/}
										{/*				onChange={handleHeaderTaxCodeForLinesChange}*/}
										{/*				disabled={isFieldReadOnly('Tax Code')}*/}
										{/*				style={{ textAlign: 'left' }}*/}
										{/*			>*/}
										{/*				<option value="">Select Tax Code</option>*/}
										{/*				{state.taxes.map((tax, index) => (*/}
										{/*					<option key={index} value={tax.taxCode}>*/}
										{/*						{tax.taxDesc}*/}
										{/*					</option>*/}
										{/*				))}*/}
										{/*			</select>*/}
										{/*		</div>*/}
										{/*		<div style={{ width: 5, padding: 5 }}></div>*/}
										{/*	</div>*/}

										<div className="row-form" style={{ display: state.invoiceDocument?.modelDefId === 3 ? "" : "none" }} data-row={10}>
											<div className="mf-10">
												<label>Total Spots:</label>
												<input type={state?.invoiceDocument?.invoiceSource === 1 ? 'text' : 'number'}
													className={"numberInput-moz-no-button numberInput-webkit-no-button"
														+ `${state?.invoiceDocument?.invoiceSource !== 1 && (stringIsNullOrEmpty(state.invoiceDocument?.totalSpot) || parseFloat(state.invoiceDocument?.totalSpot) === 0) ? ' border-red' : ''}`}
													name="totalSpot" readOnly={(state.readOnly || state?.invoiceDocument?.invoiceSource === 1) ? true : !isEditable("Total Spots")} value={
														state?.invoiceDocument?.invoiceSource === 1 ? formatNumber(state.invoiceDocument?.totalSpot || 0)
															: state.invoiceDocument?.totalSpot || 0
													} onChange={(e) => input_changeHandler(e, state, setState, setDateValidations)} style={{ textAlign: 'right' }} />
											</div>
											<div style={{ width: 5, padding: 5 }}>
											</div>
										</div>
										<div className="row-form" style={{ display: state.invoiceDocument?.modelDefId === 3 ? "" : "none" }} data-row={11}>
											<div className="mf-10">
												<label>Call Letters:</label>
												<input type='text'
													className={`${state?.invoiceDocument?.invoiceSource !== 1 && (stringIsNullOrEmpty(state.invoiceDocument?.callLetters)) ? ' border-red' : ''}`}
													name="callLetters" readOnly={(state.readOnly || isInvoiceSource) ? true : !isEditable("Call Letters")} value={state.invoiceDocument?.callLetters || ""} maxLength={4} onChange={(e) => input_changeHandler(e, state, setState, setDateValidations)} style={{ textAlign: 'left' }} />
											</div>
											<div style={{ width: 5, padding: 5 }}>
											</div>
										</div>
										<div className="row-form" style={{ display: state.invoiceDocument?.modelDefId === 3 && state?.invoiceDocument?.invoiceSource !== 1 ? "" : "none" }} data-row={12}>
											<div className="mf-10">
												<label>Station Order Number:</label>
												<input type='text'
													name="stationOrderNumber" readOnly={(state.readOnly || isInvoiceSource) ? true : !isEditable("Station Order Number")} value={state.invoiceDocument?.stationOrderNumber || ""} maxLength={64} onChange={(e) => input_changeHandler(e, state, setState, setDateValidations)} style={{ textAlign: 'right' }} />
											</div>
											<div style={{ width: 5, padding: 5 }}>
											</div>
										</div>

										<div className="row-form" style={{ display: state?.invoiceDocument?.invoiceSource !== 1 ? "" : "none" }} data-row={5}>
											<div className="mf-10">
												<label htmlFor="invoiceUserStatus">{siteDisplayName}:</label>
												<select
													id="invoiceUserStatus"
													name="invoiceUserStatusId"
													tabIndex="10"
													style={{ padding: '5px 10px' }}
													disabled={(state.readOnly || isInvoiceSource ? true : !isEditable("User Status"))}
													value={state.invoiceDocument?.invoiceUserStatusId || ''}
													onChange={(e) =>
														input_changeHandler(e, state, setState, setDateValidations)
													}
												>
													<option value="">Select {siteDisplayName}</option>

													{state.invoiceDocument?.invoiceUserStatus?.map((item, index) => (
														<option key={index} value={item.invoiceUserStatusId}>
															{item.userStatusCode}
														</option>
													))}
												</select>

											</div>
											<div style={{ width: 5, padding: 5 }}>
											</div>
										</div>
										{/*(state.invoiceDocument && state.invoiceDocument?.modelDefId == 1 && cellVisible && getDiscountField(9)) ||*/
												/*(state.invoiceDocument && state.invoiceDocument?.modelDefId == 2 && cellVisible && getDiscountField(9))*/}
									</Grid>
									{/*column 2*/}
									<Grid item xs>
										<div className="row-form">
											<div className="mf-10">
												<label>Client:</label>
												<div className={`textBoxValidate searchFld`}>
													{state.invoiceDocument && (
														<input
															type="text"
															name="clientCode"
															tabIndex="2"
															className={`${stringIsNullOrEmpty(state.invoiceDocument?.clientCode)}`}
															readOnly={true}
															value={state.invoiceDocument?.client || ''}
														/>
													)}
													<img
														src="images/images-invoicemodelsetup/search-icon.png"
														alt="Search Client"
														style={{
															display:
																isClientCodeConsistent && !state.readOnly
																	? isEditable("Client") ? 'inline' : 'none'
																	: 'none'
														}}

														onClick={(e) => isClientCodeConsistent ? searchClient_clickHandler(e, setState) : null}
													/>
												</div>
											</div>
											<div style={{ width: 5, padding: 5 }}>
												{/*<span style={{ color: "red", visibility: stringIsNullOrEmpty(state.invoiceDocument?.vendor) || stringIsNullOrEmpty(state.invoiceDocument?.siteId) ? "visible" : "hidden" }}>*</span>*/}
											</div>
										</div>
										<div className="row-form" style={{ display: cellVisible ? "" : "none" }} data-row={2}>
											<div className="mf-10">
												<label>GL Date:</label>
												<input type="date" name="glDateString"
													data-name="glDate"
													readOnly={isFieldReadOnly("GL Date")}
													className={`${state?.invoiceDocument?.invoiceSource !== 1 && (stringIsNullOrEmpty(state.invoiceDocument?.glDateString) || !datesValidation.glDateString) ? 'border-red' : ''}`}
													value={state.invoiceDocument?.glDateString} onChange={(e) => input_changeHandler(e, state, setState, setDateValidations)} />
											</div>
											<div style={{ width: 5, padding: 5 }}>
											</div>
										</div>


										<div className="row-form" style={{ display: state.invoiceDocument?.modelDefId === 2 ? "" : "none", minHeight: '34px' }}
											data-row={3} >
											<div className="mf-10">
												<label>&nbsp;</label>
												<div className="textBoxValidate searchFld">
												</div>
											</div>
											<div style={{ width: 5, padding: 5 }}>
											</div>
										</div>
										<div className="row-form" data-row={4}>
											<div className="mf-10">
												<label>Due Date:</label>
												<input type="date" name="dueDateString"
													className={`${state?.invoiceDocument?.invoiceSource !== 1 && (!_isDueDateValid || !datesValidation.dueDateString) ? 'border-red' : ''}`}
													tabIndex="8" data-name="dueDate" readOnly={isFieldReadOnly("Due Date")}
													value={state.invoiceDocument?.dueDateString || ''} onChange={(e) => input_changeHandler(e, state, setState, setDateValidations)} />
											</div>
											<div style={{ width: 5, padding: 5 }}>
												{/*<span style={{ color: "red", visibility: !_isDueDateValid ? "visible" : "hidden" }}>*</span>*/}
											</div>
										</div>

										{/*<div className="row-form" style={{ display: state.invoiceDocument?.modelDefId === 3 ? "" : "none" }} data-row={7}>*/}
										{/*	<div className="mf-10">*/}
										{/*		<label>End Date:</label>*/}
										{/*		<input type="date" name="endDateString" data-name="endDate" readOnly={state.readOnly || isInvoiceSource} value={state.invoiceDocument?.endDateString || ''} style={{ textAlign: 'left' }} onChange={input_changeHandler} />*/}
										{/*	</div>*/}
										{/*	<div style={{ width: 5, padding: 5 }}>*/}
										{/*	</div>*/}
										{/*</div>*/}
										<div className="row-form" data-row={5}>
											<div className="mf-10">
												<label htmlFor="currencies">Currency:</label>
												{/*<input type="text" id="currencyCode" name="currencyCode" tabIndex="10" readOnly={true} value={currencyCode} />*/}
												<select id="currencyCode"
													className={`${state?.invoiceDocument?.invoiceSource !== 1 && stringIsNullOrEmpty(state.invoiceDocument?.currencyCode) ? 'border-red' : ''}`}
													style={{ padding: '5px 10px' }}
													name="currencyCode" tabIndex="10" disabled={state.readOnly || !stringIsNullOrEmpty(state.invoiceDocument?.vendor) || isInvoiceSource} value={state.invoiceDocument?.currencyCode} onChange={(e) => input_changeHandler(e, state, setState, setDateValidations)}>
													<option key="currencyCode" value={(state.invoiceDocument?.currencies?.length || 0) === 0 ? state.invoiceDocument?.currencyCode : ""}>{(state.invoiceDocument?.currencies?.length || 0) === 0 ? state.invoiceDocument?.currencyCode : ""}</option>
													{
														state.invoiceDocument?.currencies?.map(function (item, index) {
															return <option key={index} value={item.currencyCode}>{item.currencyName}</option>
														})
													}
												</select>
											</div>
											<div style={{ width: 5, padding: 5 }}>
												{/*<span style={{ color: "red", visibility: stringIsNullOrEmpty(state.invoiceDocument?.currencyCode) ? "visible" : "hidden" }}>*</span>*/}
											</div>
										</div>
										<div className="row-form" style={{ display: state.invoiceDocument?.modelDefId === 2 ? "none" : "" }}
											data-row={6}>
											<div className="mf-10">
												<label>{state.invoiceDocument?.modelDefId === 3 ? 'End Date:' : 'Service Term To:'}</label>
												<input type="date"
													className={`${state?.invoiceDocument?.invoiceSource !== 1 && (!_isServiceTermEndValid || !datesValidation.serviceTermEndDateString) ? 'border-red' : ''}`}
													name="serviceTermEndDateString" tabIndex="12" data-name="serviceTermEndDate" readOnly={
														((!ignorePreviousCases && (state.readOnly))
															|| (readOnlyOverride) || isPostInProgress) ? true : !isEditable(state.invoiceDocument?.modelDefId === 3 ? "End Date" : "Service Term To")
													} value={state.invoiceDocument?.serviceTermEndDateString || ''} onChange={(e) => input_changeHandler(e, state, setState, setDateValidations)}
													onBlur={(e) => {
														if (e.target.disabled) return;
														serviceTerm_blurHandler(
															e,
															props,
															state,
															setState,
															currentEditRow,
															toast,
															stringIsNullOrEmpty,
															uniqueBy,
															editorGridRef
														);

														if (e.target.value && e.target.value.length === 10) {
															handleServiceTermChange('serviceTermEndDateString', e.target.value);
														}
													}} />
											</div>
											<div style={{ width: 5, padding: 5 }}>
												{/*<span style={{ color: "red", visibility: !_isServiceTermEndValid ? "visible" : "hidden" }}>*</span>*/}
											</div>
										</div>
										<div className="row-form" style={{ display: (state.invoiceDocument?.masterDocumentModelId == null || state.invoiceDocument?.modelDefId === 3) ? "none" : "" }}
											data-row={8}>
											<div className="mf-10">
												<label>Remaining Balance:</label>
												<input type="text" name="remainingBalance" readOnly={true} value={formatNumber(Math.max(0, state.invoiceDocument?.scannedTotal - parseFloat(grossTotal || 0))) || ''} style={{ textAlign: 'right' }} />
											</div>
											<div style={{ width: 5, padding: 5 }}>
											</div>
										</div>


										{/*{getTaxAmountField}*/}


										<div className="row-form" style={{
											display: (props?.info?.mode === 'UserEntry' || (state?.invoiceDocument?.invoiceDocumentFileLocation?.indexOf('USER_ENTRY_') !== -1 &&
												state.invoiceDocument?.masterDocumentModelId == null || state.invoiceDocument?.invoiceSource === 1)
												? 'none' : '')
										}} data-row={9}>
											<div className="mf-10">
												<label>Scanned Total:</label>
												<input type="text" name="scannedTotal" readOnly={true} value={formatNumber(state.invoiceDocument?.scannedTotal) || ''}
													style={{ textAlign: 'right' }} />
											</div>
											<div style={{ width: 5, padding: 5 }}>
											</div>
										</div>

										{getTaxAmountField()}

										{(state.invoiceDocument && state.invoiceDocument?.modelDefId == 1 && getDiscountField(10)) ||
											(state.invoiceDocument && state.invoiceDocument?.modelDefId == 2 && getDiscountField(10))
										}

										<div className="row-form" style={{ display: state.invoiceDocument?.modelDefId === 3 && state?.invoiceDocument?.invoiceSource !== 1 ? "" : "none" }} data-row={10}>
											<div className="mf-10">
												<label>Media Type:</label>
												<select
													value={state.invoiceDocument?.broadcastType}
													onChange={handleMediaTypeChange}
													className={stringIsNullOrEmpty(state.invoiceDocument?.broadcastType) ? 'border-red' : ''}
													disabled={state.readOnly ? true : !isEditable("Media Type")}
												>
													<option value="">Select Media Type</option>
													{mediaTypeOptions.map((type) => (
														<option key={type.value} value={type.value}>
															{type.label}
														</option>
													))}
												</select>

											</div>
											<div style={{ width: 5, padding: 5 }}>
											</div>
										</div>
										<div className="row-form" style={{ display: state.invoiceDocument?.modelDefId === 3 ? "" : "none" }} data-row={10}>
											<div className="mf-10">
												<label>Band:</label>
												<select
													value={state.invoiceDocument?.band}
													onChange={handleBandChange}
													className={stringIsNullOrEmpty(state.invoiceDocument?.band) ? 'border-red' : ''}
													disabled={state.readOnly ? true : !isEditable("Band")}
													style={{ textAlign: 'left' }}
												>
													<option value="">Select Band</option>
													{filteredBandOptions.map((band) => (
														<option
															key={band}
															value={band}>
															{band}
														</option>
													))}
												</select>
											</div>
											<div style={{ width: 5, padding: 5 }}>
											</div>
										</div>

										<div className="row-form" style={{ display: state.invoiceDocument?.modelDefId === 3 && state?.invoiceDocument?.invoiceSource !== 1 ? "" : "none" }} data-row={12}>
											<div className="mf-10">
												<label>Product Code:</label>
												<input type='text'
													name="productCode" readOnly={(state.readOnly || isInvoiceSource) ? true : !isEditable("Product Code")} value={state.invoiceDocument?.productCode || ""} maxLength={8} onChange={(e) => input_changeHandler(e, state, setState, setDateValidations)} style={{ textAlign: 'left' }} />
											</div>
											<div style={{ width: 5, padding: 5 }}>
											</div>
										</div>

										<div
											className="row-form"
											style={{ display: showApplyTo ? "" : "none" }}
											data-row={13}
										>
											<div className="mf-10">
												<label>Applied To:</label>

												<a
													href="#"
													onClick={applyToInvoice_clickHandler}
													style={{
														display: 'flex',
														alignItems: 'center',
														flexGrow: 1,
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														maxWidth: '100%',
														paddingLeft: '2.2%',
														marginTop: '7px',
														color: 'blue',
														textDecoration: 'underline',
														cursor: 'pointer'
													}}
												>
													{state.invoiceDocument?.linkedInvoiceNumber}
												</a>
											</div>
										</div>

										{/*<div className="row-form" data-row={10}>*/}
										{/*	<div className="mf-10">*/}
										{/*		<label>&nbsp;</label>*/}
										{/*		{state?.invoiceDocument && (state?.invoiceDocument?.invoiceDocumentId || 0) !== 0 && (*/}
										{/*			<span*/}
										{/*				onClick={() => downloadFile(state.invoiceDocument)}*/}
										{/*				title={state.invoiceDocument?.fileName}*/}
										{/*				style={{*/}
										{/*					display: 'flex',*/}
										{/*					alignItems: 'center',*/}
										{/*					flexGrow: 1,*/}
										{/*					overflow: 'hidden',*/}
										{/*					textOverflow: 'ellipsis',*/}
										{/*					maxWidth: '100%',*/}
										{/*					paddingLeft: '2.2%',*/}
										{/*					marginTop: '7px',*/}
										{/*					color: 'blue',*/}
										{/*					textDecoration: 'underline',*/}
										{/*					cursor: 'pointer'*/}
										{/*				}}*/}
										{/*			>*/}
										{/*				{state.invoiceDocument?.fileName && state.invoiceDocument?.fileName.length > 15*/}
										{/*					? `${state.invoiceDocument?.fileName.substring(0, 15)}...`*/}
										{/*					: state.invoiceDocument?.fileName || 'No file attached'}*/}
										{/*			</span>*/}
										{/*		)}*/}
										{/*	</div>*/}
										{/*</div>*/}
									</Grid>
								</Grid>
								<Grid style={{ display: mode === "Test" ? 'none' : 'flex' }} container justify="center">
									<Grid item xs>
										<div className="row-form" >
											<div className="mf-11 field_full-9">
												<label>Comments:</label>
												<textarea name="headerComments" readOnly={mode === "Test" || isInvoiceSource} disabled={isInvoiceSource} onChange={(e) => input_changeHandler(e, state, setState, setDateValidations)} value={state.invoiceDocument?.headerComments || ''}></textarea>
											</div>
										</div>

									</Grid>
								</Grid>
								{/*block only for broadcast*/}
								<Grid container justifyContent="center" style={{ display: state.invoiceDocument?.modelDefId === 3 && state?.invoiceDocument?.invoiceSource !== 1 ? "" : 'none' }}>
									{(shouldDisplayButtons && props.info.modelDefId === 3 && state?.invoiceDocument?.invoiceSource !== 1) && mode !== 'View' && mode !== 'Test' && <button className="btn-blue" disabled={state.readOnly ? true : !isEditable("Import Lines")} onClick={import_clickHandler}>Import Lines</button>}
									{(props.info.modelDefId === 3 && state?.invoiceDocument?.invoiceSource !== 1) && ((mode !== 'View' && mode !== 'Test') || state.originalInvoiceDocumentStatus >= 170) && <button className="btn-blue" disabled={!isEditable("Export Line")} onClick={export_clickHandler}>Export Lines</button>}
									{(shouldDisplayButtons && props.info.modelDefId === 3 && state?.invoiceDocument?.invoiceSource !== 1) && mode !== 'View' && mode !== 'Test' && <input style={{ display: "none" }}
										accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
										id="broadcast_importfile_input" type="file" onChange={importFile_changeHandler} />}

								</Grid>
								{<Grid container justify="center" style={{ display: state.invoiceDocument?.modelDefId !== 3 ? "" : 'none' }}>
									<Grid item xs>
										<div className="col-md-12 form-group" style={{ marginTop: 10, marginBottom: 10 }}>
											{(state.invoiceDocument &&
												//state.invoiceDocument?.modelDefId === 1 &&
												//(!!state.invoiceDocument?.invoiceDocumentId && state.invoiceDocument?.invoiceDocumentId !== 0) &&
												props?.info?.mode !== 'Test') &&
												<div className="form-group">
													<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 sub_navigations">
														<div className="col-lg-10 col-md-10 col-sm-10 col-xs-12 nav-padding">
															<ul id="tabStrip">

																<li className={activeTab === "tabInvoiceDetails" ? "active" : ""}
																	onClick={() => handleTabInvoiceDetails(setActiveTab)}><a>Invoice Details</a></li>
																<li className={activeTab === "tabAttachments" ? "active" : ""}
																	onClick={() => handleTabAttachments(setActiveTab)}><a>Attachments</a></li>
															</ul>
														</div>
													</div>
												</div>}
											<div className="form-group">
												<div key={0} style={{ display: (activeTab === "tabInvoiceDetails") ? 'block' : 'none' }} className="col-md-12 zero-padding tabInvoiceDetails">
													<div key={11} style={{ marginTop: 10, marginBottom: 10 }}>

														<InvoiceDocumentEditorGrid key={100}
															poHeaderLookupInfo={poHeaderInfo}
															level2LookupInfo={level2Info}
															level3LookupInfo={level3Info}
															costCodesLookupInfo={costCodesInfo}
															editable={cellEditable}
															partialPostMode={isPartialPostMode}
															partialEditableIONumberSet={partialEditableIONumberSet}
															partialMoInvoiceMap={partialMoInvoiceMap}
															info={props.info}
															clientInfo={props.clientInfo}
															poCode={state.invoiceDocument?.poCode}
															stateRef={editorGridRef}
															setParentState={setParentState}
															updateView={updateView}
															messageDialog={state.openReplaceFileScanInProgress}
															vendorDialog={state.openVendorDialog}
															duplicateCheck={state.isInvoiceNumberDuplicate}
															searchIONumber_clickHandler={searchIONumber_clickHandler}
															originalInvoiceDocumentStatus={state.originalInvoiceDocumentStatus}
															verifyProductionInvoiceDocumentDetails={verifyProductionInvoiceDocumentDetails}
															routingHistory_clickHandler={routingHistory_clickHandler}
															setLinesDirty={setLinesDirty}
															readOnly={state.readOnly}
															isEditableByRule={isEditable}
															onClientCodeConsistencyChange={handleClientCodeConsistency}
															broadCastInvoiceTotal={broadCastInvoiceTotal}
															setBroadCastInvoiceTotal={setBroadCastInvoiceTotal}
															setBroadCastTaxCode={setBroadCastTaxCode}
															broadCastTaxCode={broadCastTaxCode}
															allowOverrideTaxAmount={allowOverrideTaxAmount}
															braodCastTaxChanged={braodCastTaxChanged}
															overrideAllChks={overrideAllChks}
															fetchDashboard={props.fetchDashboard}
															isFieldReadOnly={isFieldReadOnly}
															headerTaxCodeForLines={headerTaxCodeForLines}
														/>
													</div>
												</div>
												<div key={1} style={{ display: (activeTab !== "tabInvoiceDetails") ? 'block' : 'none' }} className="col-md-12 zero-padding tabAttachments">
													<div key={10} style={{ marginTop: 10, marginBottom: 10 }}>
														{props.info.modelDefId !== 3 &&
															<InvoiceDocumentEditorAttachments key={110} stateRef={attachmentRef} setParentState={setParentState}
																invoiceDocument={state.invoiceDocument} info={props.info} editable={!isPartialPostMode && cellEditable} />
														}
													</div>
												</div>


											</div>
										</div>

									</Grid>
								</Grid>}
							</Grid>
						</Grid>
					</Grid>
					<div className="floatingButtons editorButtons">
						<div className="row-form row-btn" style={{ marginBottom: '-4px' }}>
							<div className="mf-12">
								{shouldDisplayButtons && !isPartialPostMode ? <>{shouldDeleteInvoice === '' ? <><button className="btn-danger-red" style={{ display: shouldDeleteInvoice }} onClick={() => setOpenDeleteConfirmation(true)}>Delete</button><span style={{ display: 'inline-block', width: '24px' }}></span></> : <></>}</> : <></>}
								{shouldDisplayButtons && !isPartialPostMode ? <>
									{!isFieldReadOnly('Manage Invoice Archive/Unarchive') && !capabilities?.hasDifferentCompany && <button className={archiveButtonClass}
										style={{ marginRight: '9px' }}
										onClick={() => {
											//state.invoiceDocument?.archived ? toggleArchive() : setArchiveDialogOpen(true);
											setArchiveDialogOpen(true);
										}}
									>
										{archiveButtonText} Invoice
									</button>}
									<button className="btn-blue" style={{ display: displayReplace }} onClick={replace_clickHandler}>Replace Invoice</button>
									{displayFavouriteButton && (
										<button
											className="btn-blue"
											onClick={favourite_button_clickhandler}
										>
											{props.info.rowData.isFavorite === 'Y' ? 'Remove Favorite' : 'Mark as Favorite'}
										</button>
									)}
										<button className="btn-blue" style={{
											display: state.readOnly === false &&
												//mode !== "Approval" &&
												mode !== "UserEntry" &&
												state.originalInvoiceDocumentStatus == 40 &&
												//(isAdmin || state.invoiceDocument?.routedToResourceId == null || state.invoiceDocument?.routedToResourceId === resourceId) &&
												!stringIsNullOrEmpty(state.invoiceDocument?.invoiceDocumentFileLocation) &&
												!shouldNotShowRouteToEmployee && state.invoiceDocument?.allowRoutingSetup === 'Y' && !capabilities?.hasDifferentCompany ? "" : "none"
										}} disabled={!_isVendorSelected} onClick={() =>
											routeToEmployee_clickHandler(
												state,
												setState,
												() =>
													handleRouteToEmployeeWarning(
														setOpenRouteToEmployeeDialog,
														setDialogResponseHandler
													),
												() => save_clickHandler(
													state,
													setState,
													props,
													editorGridRef,
													attachmentRef,
													isTaxDiscrepent,
													IsSaveDisabled,
													InvoiceDocumentDetailMissingInfo,
													allowDiscrepentTax,
													getErrorMessage,
													() => handleClientWarning(setOpenClientWarningDialog, setDialogResponseHandler),
													(message) => handleCustomWarning(setOpenAmountsMismatchDialog, setAmountsMismatchDialogResponseHandler, setAmountsMismatchMessage, message),
													isSaveBtnDisabled,
													overrideAllChks,
													() => handleOverrideWarning(setConfirmationDialogOpen, setOverrideDialogResponseHandler),
													httpPost,
													fetchInvoiceDocument,
													close_clickHandler,
													Constants,
													toast,
													false,
													setSuccessfullSave,
													getInvoiceEditorCapabilities
												),
											)
										}>Route to Employee</button>

									<VendorMappingConfirmationDialog
										isOpen={openRouteToEmployeeWarningDialog}
										title="Confirmation"
										message="Do you want to save before routing to employee(s)?"
										onClose={(event) => {
											if (dialogResponseHandler) {
												dialogResponseHandler(event);
											}
										}}
									/>

									{/*block only for broadcast*/}
									<button className="btn-blue" style={{ display: displayAccept }} onClick={() => {
										accept_clickHandler(state,
											props,
											getErrorMessage,
											() => handleClientWarning(setOpenClientWarningDialog, setDialogResponseHandler),
											(message) => handleCustomWarning(setOpenAmountsMismatchDialog, setAmountsMismatchDialogResponseHandler, setAmountsMismatchMessage, message),
											IsSaveDisabled,
											editorGridRef,
											attachmentRef,
											httpPost,
											close_clickHandler_wrapper)
									}}
									>{state.invoiceDocument?.acceptName}</button>
									<button className="btn-blue" style={{ display: displayReject }} onClick={() => reject_clickHandler(state,
										props,
										getErrorMessage,
										() => handleClientWarning(setOpenClientWarningDialog, setDialogResponseHandler),
										(message) => handleCustomWarning(setOpenAmountsMismatchDialog, setAmountsMismatchDialogResponseHandler, setAmountsMismatchMessage, message),
										IsSaveDisabled,
										editorGridRef,
										attachmentRef,
										httpPost,
										close_clickHandler_wrapper)
									}>{state.invoiceDocument?.rejectName}</button>
									<button className="btn-blue" style={{ display: props.info.rowData && props.info.rowData.routingHistoryCount > 0 ? "none" : "none" }} onClick={routingHistory_clickHandler}>View Approval History</button>
									{/*as per requirement from abid 11212024 show save on broadcast*/}
									<button className="btn-blue" style={{ display: props.info.rowData && props.info.rowData.routingHistoryCount > 0 ? "none" : "none" }} onClick={routingHistory_clickHandler}>View Approval History</button>
									<button className="btn-blue" style={{ display: displayRouting }} disabled={state.isDirty || state.invoiceDocument?.modelDefId === 3} onClick={approval_Routing_clickHandler}>Approval Routing</button>
									<button className="btn-blue" style={{ display: displayRoutingHistory }} disabled={state.isDirty} onClick={routing_History_clickHandler}>Routing History</button>
									{
										(buttonCapabilities?.canPostToERP || (buttonCapabilities.canPostCreditMemo &&
											_invoiceDocument?.invoiceDocumentStatusId !== 180
										)) && !capabilities?.hasDifferentCompany && (
											<button
												className="btn-blue"
												onClick={postToErp_clickHandler}
												style={{ cursor: 'pointer' }}
											>
												Post
											</button>
										)}

									{(function () {
										return ((buttonCapabilities.canRepostToERP || (buttonCapabilities.canPostCreditMemo &&
											_invoiceDocument?.invoiceDocumentStatusId === 180
										)) && !capabilities?.hasDifferentCompany && <button
											className="btn-blue"
											onClick={repostToErp_clickHandler}
											style={{ cursor: 'pointer' }}
										>
												Repost
											</button>)
									})()}
									{
										shouldShowEditInvoiceButton && (
											<Tooltip title={isEditModeEnabled ? "Edit mode already enabled" : ""}>
												<span>
													<button
														className="btn-blue"
														onClick={editInvoice_clickHandler}
														disabled={isEditModeEnabled}
													>
														Edit Invoice
													</button>
												</span>
											</Tooltip>
										)}
								</> : <></>}
								{/*<button className="btn-blue" style={{ display: displaySave }} disabled={isSaveBtnDisabled} onClick={save_clickHandler}>Save</button>*/}
								{shouldDisplayButtons && !isPartialPostMode ?
									<><button className="btn-blue" style={{ display: shouldDisplayCreditMemoButton }} onClick={() => invoiceIndicator === 0 ? creditMemo(
										props,
										state,
										close_clickHandler,
										(memoInvoiceDocumentId) => {
											setCreditedMemoInvoiceId(memoInvoiceDocumentId || 0);
											setOpenCreditMemoDialog(true);
										},
										setCreditedMemoInvoiceId
									) : null}>Credit Memo</button>

									</> : <></>}
								{shouldDisplayButtons && !isPartialPostMode && (
									<button
										className="btn-blue"
										style={{ display: shouldDisplayCreditMemoMarkAsPosted, marginRight: 8 }}
										onClick={creditMemoMarkAsPosted_clickHandler}
									>
										Mark as Posted
									</button>
								)}
								{!shouldDisplayButtons ?
									<> <button className="btn-blue" style={{ display: displayRoutingHistory }} disabled={state.isDirty || state.invoiceDocument?.modelDefId === 3} onClick={routing_History_clickHandler}>Routing History</button>
									</> : <></>}

								<button className="btn-grey" style={{ display: (isPartialPostMode || (displaySave === "none" && canSaveCommentsOnPosted && !capabilities?.hasDifferentCompany)) ? "" : displayReset }} disabled={!state.isDirty} onClick={reset_clickHandler}>Reset</button>
								{isPartialPostMode && !capabilities?.hasDifferentCompany ? (
									<>
										<button
											className="btn-blue"
											disabled={!state.isDirty}
											onClick={savePartial_clickHandler}
											style={{ marginRight: 8 }}
										>
											Save
										</button>
										<button
											className="btn-blue"
											disabled={!state.isDirty}
											onClick={saveAndRepostPartial_clickHandler}
										>
											Save &amp; Repost
										</button>
									</>
								) : (
									<button className="btn-blue" style={{
										display:
											displaySave === "none" && canSaveCommentsOnPosted && !capabilities?.hasDifferentCompany
												? ""
												: displaySave
									}} disabled={!state.isDirty /*|| state.invoiceDocument?.modelDefId === 3*/} onClick={() => {

										const isPostedInvoice =
											Number(state?.invoiceDocument?.invoiceDocumentStatusId) === 170 &&
											!state?.invoiceDocument?.archived;

										if (isPostedInvoice) {

											savePostedInvoiceComments(
												state,
												props,
												httpPost,
												toast,
												setSuccessfullSave,
												close_clickHandler
											);

										} else {

											save_clickHandler(
												state,
												setState,
												props,
												editorGridRef,
												attachmentRef,
												isTaxDiscrepent,
												IsSaveDisabled,
												InvoiceDocumentDetailMissingInfo,
												allowDiscrepentTax,
												getErrorMessage,
												() => handleClientWarning(setOpenClientWarningDialog, setDialogResponseHandler),
												(message) => handleCustomWarning(
													setOpenAmountsMismatchDialog,
													setAmountsMismatchDialogResponseHandler,
													setAmountsMismatchMessage,
													message
												),
												isSaveBtnDisabled,
												overrideAllChks,
												() => handleOverrideWarning(setConfirmationDialogOpen, setOverrideDialogResponseHandler),
												httpPost,
												fetchInvoiceDocument,
												close_clickHandler,
												Constants,
												toast,
												true,
												setSuccessfullSave,
												getInvoiceEditorCapabilities
											)
										}
									}}>Save</button>
								)}
								<button className="btn-grey" onClick={(event) => close_clickHandler_wrapper({ event: event, wasUpdated: false, isRoutedToEmployeeOrApproval: false })}>Close </button>

							</div>
						</div>
					</div>
				</div>
				<VendorLookup info={info}
					onClose={vendorDialog_closeHandler} />

				<POHeaderLookup info={poHeaderInfo} onClose={poHeaderDialog_closeHandler} />
				<POHeaderResourceLookup info={{ ...poHeaderResourceInfo, userRoleName: state.userRoleName, source: state.source }} onClose={poHeaderResourceDialog_closeHandler} />
				<Level2ResourceLookup info={{ ...level2ResourceInfo, userRoleName: state.userRoleName, source: state.source }} onClose={level2ResourceDialog_closeHandler} />
				<InvoiceDocumentRoutingHistory info={invoiceDocumentRoutingHistoryInfo} onClose={() => invoiceDocumentRoutingHistoryDialog_closeHandler(setState)} />
				<ClientLookup
					info={{
						...clientInfo,
						openDialog: state.openClientDialog,
						invoiceModel: {
							...clientInfo.invoiceModel,
							clientCode: shouldSelectDetailClient,
							selectedClientCode: clientCodeSource
						},
						shouldSelectClient,
					}}
					onClose={clientDialog_closeHandler}
				/>
				<InvoiceDocumentApprovalRoutingHistory
					info={{
						openDialog: openInvoiceDocumentApprovalDialog,
						inProgress: props.info.inProgress,
						rowData: props.info.rowData,
						routingHistoryData: props.info.routingHistoryData,
						mode: state.originalInvoiceDocumentStatus >= 50 ? "approval" : "discrepant",
					}}
					onClose={closeDialogHandler}
				/>
				{/* Archive Dialog */}
				<GenericMessageDialog
					type={'confirm'}
					message={promptMessage}
					open={archiveDialogOpen}
					//acceptCallback={async () => {
					//	const closeHandler = conditionalClose();
					//	await archiveStatusHandler(state.invoiceDocument, props.info.inProgress,closeHandler);
					//}}
					onClose={() => { }}
					acceptCallback={toggleArchive}
					rejectCallback={() => {
						setArchiveDialogOpen(false)
					}}
					maxWidthPx={400}
				/>
				<Dialog
					open={state.openChangeVendorConfirmation}
					aria-labelledby="draggable-dialog-title"
				>
					<DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
						Change vendor on invoice
					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{vendorChangeWarningMessage || vendorDialogConfirmationMessage}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={changeVendorYes_clickHandler} color="primary">
							Yes
						</Button>
						<Button autoFocus onClick={changeVendor_closeHandler} color="primary">
							No
						</Button>
					</DialogActions>
				</Dialog>
				<Dialog
					open={state.openReplaceFileScanInProgress}
					aria-labelledby="draggable-dialog-title"
				>
					<DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
						Invoice Replacement
					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							On file selection, the existing invoice will be replaced and the selected file will be uploaded for scanning
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={replaceFileInfoDialog_clickHandler} color="primary">
							Ok
						</Button>
					</DialogActions>
				</Dialog>
				<Dialog
					open={openConfirmationDialog}
					aria-labelledby="draggable-dialog-title"
				>
					<DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
						Change Company
					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							Are you sure you want to move this invoice to {pendingCompany?.coName}? Press OK to continue.
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={handleConfirmChange} color="primary">
							Ok
						</Button>
						<Button autoFocus onClick={handleCancelChange} color="primary">
							Cancel
						</Button>
					</DialogActions>
				</Dialog>
				<Dialog
					open={openSuccessDialog}
					aria-labelledby="success-dialog-title"
					BackdropProps={{
						style: {
							backgroundColor: 'rgba(0, 0, 0, 0.8)',
						},
					}}
				>
					<DialogTitle id="success-dialog-title" sx={{ color: 'black', fontWeight: 'bold' }}>
						Invoice Moved
					</DialogTitle>
					<DialogContent>
						<DialogContentText sx={{ color: 'black' }}>
							Invoice "{state.invoiceDocument?.invoiceNumber}" has been successfully moved to "{selectedCompany?.coName}".
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						{changeCompanyData.invoiceDocumentStatusId !== 10 && (
							<Button
								onClick={handleViewInvoice}
								sx={{
									color: 'white',
									backgroundColor: 'primary.main',
									'&:hover': { backgroundColor: 'primary.dark' }
								}}
							>
								View Invoice
							</Button>
						)}
						<Button
							onClick={close_clickHandler}
							sx={{
								color: 'white',
								backgroundColor: 'primary.main',
								'&:hover': { backgroundColor: 'primary.dark' }
							}}
						>
							Ok
						</Button>
					</DialogActions>
				</Dialog>
				<Dialog open={state.openReplaceInvoiceDocumentEditorDialog} TransitionComponent={Transition} fullScreen>
					<InvoiceDocumentEditor
						info={replaceInfo}
						clientInfo={clientInfo}
						onClose={(payload = {}) => {
							// Always close ONLY the replace dialog first
							setState((prev) => ({ ...prev, openReplaceInvoiceDocumentEditorDialog: false }));
							const {
								wasUpdate = false,
								responseObject = null,
								invoiceDocumentId = null,
								isCompanyChanged = false,
								wasDelete = false
							} = payload || {};
							const isReplace = responseObject?.operation === 'replace';
							// If user just closed the replace editor without completing anything, don't bubble up
							if (!wasUpdate && !isReplace && !wasDelete && !isCompanyChanged) return;
							// Bubble up the full payload so list/report can trigger retry logic
							close_clickHandler_wrapper({
								wasUpdated: wasUpdate,
								responseObject,
								wasDeleted: wasDelete,
								isCompanyChangedOverride: isCompanyChanged,
								invoiceDocumentIdOverride: invoiceDocumentId
							});
						}}
					/>
				</Dialog>
				<Dialog
					open={openServiceTermDialog}
					maxWidth="sm"
					fullWidth
					PaperProps={{
						sx: {
							borderRadius: 3,
							px: 3,
							py: 2.5
						}
					}}
				>
					<DialogTitle
						sx={{
							display: "flex",
							alignItems: "center",
							gap: 1.5,
							fontWeight: 600,
							fontSize: "1.1rem",
							pb: 1.5,
							padding: 0
						}}
					>
						<WarningAmberIcon color="warning" />
						Clear IO/POs?
					</DialogTitle>

					<DialogContent sx={{ px: 0 }}>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ mb: 2 }}
						>
							The following IO/PO(s) are outside the selected service date range.
							Do you want to clear them from the invoice line(s)?
						</Typography>

						<Box
							sx={{
								maxHeight: 200,
								overflowY: "auto",
								borderRadius: 2,
								backgroundColor: "#f8f9fb",
								border: "1px solid #e0e0e0",
								p: 2
							}}
						>
							{invalidIoPoRows.map((row) => (
								<Typography
									key={row.seqId}
									variant="body2"
									sx={{
										fontWeight: 500,
										mb: 0.8
									}}
								>
									{row.ioNumber}{" "}
									<Typography
										component="span"
										variant="body2"
										color="text.secondary"
										sx={{ fontWeight: 400 }}
									>
										({FormatToInputDate(row.startDate)} –{" "}
										{FormatToInputDate(row.endDate)})
									</Typography>
								</Typography>
							))}
						</Box>
					</DialogContent>

					<DialogActions
						sx={{
							mt: 2,
							px: 0,
							display: "flex",
							justifyContent: "flex-end",
							gap: 1.5
						}}
					>
						<Button
							onClick={handleServiceTermDialogNo}
							variant="outlined"
						>
							No
						</Button>

						<Button
							onClick={handleServiceTermDialogYes}
							variant="contained"
							color="primary"
						>
							Yes
						</Button>
					</DialogActions>
				</Dialog>
				<VendorMappingConfirmationDialog
					isOpen={confirmationDialogOpen}
					title={'Warning!'}
					message={'You have made changes to the approved invoice. Do you want to continue?'}
					onClose={(event) => {
						if (overrideDialogResponseHandler) {
							overrideDialogResponseHandler(event);
						}
					}}

				/>
				<Dialog open={openCreditMemoDialog} TransitionComponent={Transition} fullScreen>
					<InvoiceDocumentEditor
						info={creditMemoEditorInfo}
						clientInfo={props.clientInfo}
						onClose={(payload) => {
							setOpenCreditMemoDialog(false);

							if (payload?.responseObject?.openLinkedInvoice) {
								close_clickHandler(
									payload?.event,
									payload?.isRoutedToEmployeeOrApproval,
									payload?.wasUpdated,
									payload?.responseObject,
									payload?.statusId,
									payload?.isSaved,
									payload?.updatedRowFields,
									payload?.wasDeleted,
									payload?.isCompanyChangedOverride,
									payload?.invoiceDocumentIdOverride
								);
								return;
							}


							const memoInvoiceDocumentId =
								creditedMemoInvoiceId ||
								payload?.invoiceDocumentId ||
								payload?.responseObject?.invoiceDocumentId ||
								payload?.responseObject?.invoiceDocument?.invoiceDocumentId ||
								null;

							setCreditedMemoInvoiceId(0);

							// Credit memo was deleted — close without triggering fetch.
							if (payload?.wasDelete) {
								close_clickHandler(null);
								return;
							}

							if (memoInvoiceDocumentId) {
								// If the credit memo was posted inside the nested dialog (requiresReload is set),
								// bubble up requiresReload, isAvailableForRescaning, and applyToInvoiceDocumentId
								// so Dashboard can refresh the row and show the rescan prompt.
								const wasPosted = payload?.responseObject?.requiresReload === true;
								close_clickHandler_wrapper({
									wasUpdated: wasPosted,
									responseObject: wasPosted
										? {
											requiresReload: true,
											operation: 'creditMemo',
											invoiceIndicator: 1
										}
										: {
											operation: 'creditMemo',
											invoiceIndicator: 1
										},
									invoiceDocumentIdOverride: memoInvoiceDocumentId,
									...(wasPosted && {
										isAvailableForRescaning: payload?.isAvailableForRescaning ?? false,
										applyToInvoiceDocumentId: payload?.applyToInvoiceDocumentId ?? null
									})
								});
								return;
							}

							close_clickHandler(null);

						}}
					/>
				</Dialog>

				<Dialog
					open={openDeleteConfirmation}
					onClose={() => setOpenDeleteConfirmation(false)}
				>
					<DialogTitle>Delete Invoice</DialogTitle>
					<DialogContent>
						<DialogContentText>
							Are you sure you want to delete this invoice?
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={() => {

								deleteInvoiceDocument(
									state.invoiceDocument?.invoiceDocumentId,
									() => {
										setOpenDeleteConfirmation(false);
										close_clickHandler_wrapper({ wasDeleted: true, invoiceDocumentIdOverride: _invoiceDocument?.invoiceDocumentId });
									},
									() => setOpenDeleteConfirmation(false)
								);
							}}
							color="primary"
						>
							Yes
						</Button>
						<Button onClick={() => setOpenDeleteConfirmation(false)} color="primary" autoFocus>
							No
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog open={openMakeEditableDialog} onClose={() => setOpenMakeEditableDialog(false)}>
					<DialogTitle>Warning</DialogTitle>
					<DialogContent>
						<DialogContentText>
							This will make the invoice editable. If you post/repost after editing, the invoice data will be reset before posting.
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={() => {
								setOpenMakeEditableDialog(false);

								// 🔑 NEW SOURCE OF TRUTH
								setIsEditModeEnabled(true);

								// existing logic that actually unlocks fields
								setState((prev) => ({
									...prev,
									readOnly: false,
									mode: pendingEditMode || prev.mode,
								}));
							}}
							color="primary"
						>
							OK
						</Button>
						<Button onClick={() => setOpenMakeEditableDialog(false)} autoFocus color="primary">
							Cancel
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog open={openResetAndPostDialog} onClose={() => setOpenResetAndPostDialog(false)}>
					<DialogTitle>Confirm</DialogTitle>
					<DialogContent>
						<DialogContentText>
							You have changes on this invoice. On confirmation, the invoice data will be reset and then{" "}
							{pendingPostAction === "repost" ? "reposted" : "posted"} to ERP. Continue?
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={async () => {
								setOpenResetAndPostDialog(false);

								// Reset client-side edits
								resetToInitialInvoice();

								// Then post/repost
								if (pendingPostAction) {
									await doPostFlowWithOptionalRescan(pendingPostAction);
								}
								setPendingPostAction(null);
							}}
							color="primary"
						>
							Yes
						</Button>
						<Button
							onClick={() => {
								setOpenResetAndPostDialog(false);
								setPendingPostAction(null);
							}}
							autoFocus
							color="primary"
						>
							No
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={openRescanAfterPostDialog}
					onClose={() => {
						setOpenRescanAfterPostDialog(false);
						// Treat close/backdrop as cancel
						if (rescanAfterPostResolverRef.current) {
							rescanAfterPostResolverRef.current(null);
							rescanAfterPostResolverRef.current = null;
						}
					}}
				>
					<DialogTitle>Rescan original invoice?</DialogTitle>
					<DialogContent>
						<DialogContentText>
							Do you want to rescan the original invoice after posting?
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={() => {
								setOpenRescanAfterPostDialog(false);
								if (rescanAfterPostResolverRef.current) {
									rescanAfterPostResolverRef.current(true);
									rescanAfterPostResolverRef.current = null;
								}
							}}
							color="primary"
						>
							Yes
						</Button>
						<Button
							onClick={() => {
								setOpenRescanAfterPostDialog(false);
								if (rescanAfterPostResolverRef.current) {
									rescanAfterPostResolverRef.current(false);
									rescanAfterPostResolverRef.current = null;
								}
							}}
							color="primary"
							autoFocus
						>
							No
						</Button>
						<Button
							onClick={() => {
								setOpenRescanAfterPostDialog(false);
								if (rescanAfterPostResolverRef.current) {
									rescanAfterPostResolverRef.current(null);
									rescanAfterPostResolverRef.current = null;
								}
							}}
							color="primary"
						>
							Cancel
						</Button>
					</DialogActions>
				</Dialog>


			</div>
		</div>) || <></>
	// #endregion Renderer
}